import React, { useEffect, useRef, useState  } from "react";
import { Autocomplete, GoogleMap, useJsApiLoader, Marker, Polygon  } from "@react-google-maps/api";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import axios from 'axios';
import logoMain from './img/inmoapp_logo.png';
import sampleImage from './img/sample.JPG';
import { RotatingLines } from 'react-loader-spinner';
import CurrencyFormat from 'react-currency-format';
import wpp_png from "./img/wpp.png";
import ModalCredits from './components/ModalCredits.js';
import { logPageVisit, logUserAction, ACTIONS } from './utils/logger';
import ServiceModal from './components/ServiceModal.js';
import SampleResultModal from './components/SampleResultModal.js';
//import PayValuacion from './components/PayValuacion.js';
import Navbar from './components/Navbar.jsx';
import AdminSidebar from './components/AdminSidebar.jsx';
import DevelopmentAnalysis from './components/DevelopmentAnalysis.js';
import MercadoPagoPayment from './components/MercadoPagoPayment.js';

import { verifyToken } from './utils/auth';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import '@fortawesome/fontawesome-free/css/all.min.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCar, faRuler, faCogs, faCalendarAlt, faPhone, faEnvelope, faQuestionCircle, faHandshake, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FaGift, FaCrown, FaStar, FaCheck, FaUserPlus, FaUser, FaIdCard, FaEnvelope, FaPhone, FaLock, FaUserTag, FaTimes, FaCheckCircle, FaTimesCircle, FaRocket, FaClock, FaSignInAlt } from 'react-icons/fa';
import { RiVipCrownFill } from 'react-icons/ri';
import { HiSparkles } from 'react-icons/hi';
import { IoShareSocial, IoCopyOutline, IoStorefrontOutline, IoLocationSharp, IoBriefcaseOutline, IoBusinessOutline, IoHomeOutline, IoCalendarOutline, IoFlash } from 'react-icons/io5';
import { MdSell, MdDirectionsCar, MdMeetingRoom, MdSquareFoot, MdConstruction, MdPerson, MdAttachMoney, MdGpsFixed, MdSettings, MdLandscape } from 'react-icons/md';
import { BsHouseDoor, BsStars, BsRulers } from 'react-icons/bs';
import { GiBarbecue, GiPoolTriangle } from 'react-icons/gi';
import { FaBuilding, FaHome, FaBriefcase, FaMapMarkerAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import PDF from './components/TasacionPDF.js';
import { apiBaseUrl, url } from './config.js';
import Metrics from './components/Metrics.js';
import Finanzas from './components/Finanzas.js';
import AgentDashboard from './components/AgentDashboard.js';
import AgentCredits from './components/AgentCredits.js';
import AgentAccount from './components/AgentAccount.js';
import Users from './components/Users.js';

// Check if we're in development mode
const isDevelopment = apiBaseUrl.includes('localhost');

const libraries = ['places','geometry'];

// Cookie helper functions
const setCookie = (name, value, days = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
};

function App() {

  const navigate = useNavigate(); // Initialize navigate

  const { isLoaded, loadError } = useJsApiLoader({
		googleMapsApiKey: 'AIzaSyD9E7iaceHctltR_c_xL8dXbQo1OoFfMw8',
		libraries
	})

  // URL is now automatically configured based on environment

  function request_wpp(){
    fetch(`${url}/api/request_wpp_valuacionesya`).then(function (response) {
}).catch(function (err) {
});
}

  const [marker, setMarker] = useState({ lat: -34.6037345, lng: -58.3841453 });
  const [markers, setMarkers] = useState([]);
  const [coordsArray, setCoordsArray] = useState([]);

  const [address, setAddress] = useState();
  const [addressD, setAddressD] = useState();
  const [zone, setZone] = useState("");
  const [operation, setOperation] = useState("venta");
  const [property, setProperty] = useState("departamento");
  const [amb, setAmb] = useState('');
  const [garage, setGarage] = useState('');
  const [sc, setSc] = useState('');
  const [st, setSt] = useState('');
  const [sd, setSd] = useState('');
  const [sterre, setSterreno] = useState('');
  const [condition, setCondition] = useState("Estrenar");
  const [antiguedad, setAntiguedad] = useState('');
  const [barbecue, setBarbecue] = useState(false);
  const [pool, setPool] = useState(false);
  const [sum, setSum] = useState(false);
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState('');
  const [valorProp, setValorProp] = useState(0);
  const [valorPropUno, setValorPropUno] = useState("");
  const [valorPropDos, setValorPropDos] = useState("");
  const [rentData, setRentData] = useState(null); // Store full rent estimation data (ARS + USD)
  const [gotPrice, setGotPrice] = useState(false);
  const [isMobile, setIsMobile] = useState(false); // Mobile device detection
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [user, setUser] = useState('');
  const [motive, setMotive] = useState('Personal');
  const [modalC, setModalC] = useState(false);
  const [logedIn, setLogIn] = useState(false);
  const [isModalSampleOpen, setIsModalSampleOpen] = useState(false);
  const [isPayValuacionOpen, setIsPayValuacionOpen] = useState(false);
  const [foundZone, setFoundZone] = useState(true);
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);
  const [paymentLink, setPaymentLink] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [resultExists, setResultExists] = useState(false);
  const [valuationType, setValuationType] = useState("simple"); // "simple" or "advanced"
  const [showNotCoveredModal, setShowNotCoveredModal] = useState(false);
  const [isMartilleroModalOpen, setIsMartilleroModalOpen] = useState(false);
  const [showSellingAdviceModal, setShowSellingAdviceModal] = useState(false);
  const [sellingAdviceLoading, setSellingAdviceLoading] = useState(false); // Loading state for selling advice request
  const [showNewFeatureModal, setShowNewFeatureModal] = useState(false); // New feature announcement modal
  
  // New login state
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginMode, setLoginMode] = useState('login'); // 'login' or 'register'
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [registerForm, setRegisterForm] = useState({ 
    name: '', 
    lname: '', 
    email: '', 
    password: '', 
    phone: '',
    userType: 'agent'
  });
  const [registerTermsAccepted, setRegisterTermsAccepted] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loginSuccess, setLoginSuccess] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [currentView, setCurrentView] = useState(() => {
    // Restore view from localStorage if available
    const savedView = localStorage.getItem('currentView');
    return savedView || 'main';
  }); // 'main', 'metrics', 'agent-dashboard', or 'users'
  const [viewMode, setViewMode] = useState('valuation'); // 'valuation' or 'development'
  const [addressSelected, setAddressSelected] = useState(false); // Track if address has been selected
  const [isTypingManually, setIsTypingManually] = useState(false); // Track manual typing vs Google Places
  const [isViewLoading, setIsViewLoading] = useState(false); // Loading state for view transitions
  const [loadingViewName, setLoadingViewName] = useState(''); // Name of view being loaded
  const [isMobileChatOpen, setIsMobileChatOpen] = useState(false); // Track if mobile chat is open
  const [isAuthChecking, setIsAuthChecking] = useState(true); // Track if we're checking authentication
  const [activitySocket, setActivitySocket] = useState(null); // Socket for activity tracking

  // Mobile slider state
  const [currentStep, setCurrentStep] = useState(1); // Current step in mobile form
  const [requirePhoneNumber, setRequirePhoneNumber] = useState(true); // Phone requirement setting
  const totalSteps = requirePhoneNumber ? 7 : 6; // Total number of steps (skip phone step if not required)
  
  // Development mode: Email sending control
  const [sendEmail, setSendEmail] = useState(true); // Default to true (send emails)
  
  // Step 6: User type selection (personal or agent)
  const [userTypeSelection, setUserTypeSelection] = useState('personal'); // Default to 'personal' to skip selection step
  const [whatsappStatus, setWhatsappStatus] = useState(null); // null, 'checking', 'valid', 'invalid'
  const [whatsappMessage, setWhatsappMessage] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false); // Terms & conditions checkbox
  const [showTermsError, setShowTermsError] = useState(false); // Show error when terms not accepted
  
  // Price preview (calculated before Step 6 to reduce drop-off)
  const [pricePreview, setPricePreview] = useState(null); // {minPrice, maxPrice, currency, address, zone}
  const [loadingPreview, setLoadingPreview] = useState(false); // Loading state for preview calculation
  
  // Martillero appointment modal
  const [showMartilleroModal, setShowMartilleroModal] = useState(false);
  const [martilleroBookingData, setMartilleroBookingData] = useState(null);
  
  // Pay option settings
  const [enablePayOption, setEnablePayOption] = useState(true); // Default to true to show options
  const [payOptionPrice, setPayOptionPrice] = useState(1000);
  const [payOptionDiscountPercent, setPayOptionDiscountPercent] = useState(0);
  const [enableFreeValuacion, setEnableFreeValuacion] = useState(true);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null); // 'free' or 'premium'
  const [premiumResults, setPremiumResults] = useState(null); // Store full premium valuation results
  const [agentCredits, setAgentCredits] = useState(null); // Store agent's premium credits
  
  // Check if current user is admin
  const isAdmin = () => {
    const token = localStorage.getItem('userToken');
    
    if (!token) return false;
    
    try {
      // Decode the base64 token to check userType
      const decoded = JSON.parse(atob(token));
      // Case-insensitive comparison (can be 'admin' or 'Admin')
      return decoded.userType && decoded.userType.toLowerCase() === 'admin';
    } catch (e) {
      console.error('❌ Error decoding token:', e);
      return false;
    }
  };

  // Handle premium selection - skip payment for admin users
  const handlePremiumSelection = async () => {
    if (isAdmin() || (((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') || userInfo?.userType === 'individual') && agentCredits > 0)) {
      // Admin user or agent with credits - run premium valuation directly without payment
      const userTypeLabel = isAdmin() ? 'Admin' : `Agent (${agentCredits} credits)`;
      console.log(`🔑 ${userTypeLabel} user detected - running free premium valuation`);
      setSelectedPaymentOption('admin_free'); // Set to special value to avoid payment component
      setCurrentStep(7); // Go to results step
      setLoadingPreview(true);
      
      try {
        // Get admin token to send with request
        const token = localStorage.getItem('userToken');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        
        // Apply default values for optional fields
        const finalGarage = garage || '0';
        const finalSt = st || '0';
        const finalSd = sd || '0';
        const finalSterre = sterre || '0';
        const finalAntiguedad = antiguedad || '1';
        
        const response = await axios.post(`${apiBaseUrl}/api/premium_valuation`, {
          address: addressD,
          lat: address.lat,
          lng: address.lng,
          zone: zone,
          property: property,
          operation: operation,
          amb: amb,
          condition: condition,
          sc: sc,
          st: finalSt,
          sd: finalSd,
          sterreno: finalSterre,
          garage: finalGarage,
          antiguedad: finalAntiguedad,
          barbecue: barbecue,
          pool: pool,
          sum: sum,
          valuationType: valuationType
        }, { headers });

        if (response.data.success) {
          console.log('✅ Admin premium valuation completed');
          console.log('Response data:', response.data);
          
          // Backend returns data directly, not nested in valuationResults
          setPremiumResults(response.data);
          
          // For rent, also set rentData
          if (response.data.isRent) {
            setRentData({
              preciosARS: response.data.preciosARS,
              preciosUSD: response.data.preciosUSD
            });
            console.log('Set rent data for admin:', response.data.preciosARS, response.data.preciosUSD);
          } else {
            // For sale, set the price values
            setValorPropUno(response.data.valorMinimo);
            setValorPropDos(response.data.valorMaximo);
            setGotPrice(true);
            console.log('Set sale data for admin:', response.data.valorMinimo, response.data.valorMaximo);
          }
          
          // Critical: Set showResult to true so results page actually shows
          setShowResult(true);
          setResultExists(true);
          
          // Refresh agent credits if it was an agent using a credit
          if ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) {
            // Refresh credits
            try {
              const creditsResponse = await axios.get(`${apiBaseUrl}/api/agent/credits`, {
                headers: { 'Authorization': `Bearer ${token}` }
              });
              if (creditsResponse.data.success) {
                setAgentCredits(creditsResponse.data.premiumCredits);
                console.log('✅ Agent credits refreshed:', creditsResponse.data.premiumCredits);
              }
            } catch (err) {
              console.error('Failed to refresh credits:', err);
            }
          }
          
          // Stop loading and ensure we're on results page
          setLoadingPreview(false);
          setCurrentStep(7);
        } else {
          alert('Error en la valuación. Por favor intenta nuevamente.');
          setCurrentStep(6);
          setSelectedPaymentOption(null);
          setLoadingPreview(false);
        }
      } catch (error) {
        console.error('❌ Error in admin premium valuation:', error);
        alert('Error al procesar la valuación. Por favor intenta nuevamente.');
        setCurrentStep(6);
        setSelectedPaymentOption(null);
        setLoadingPreview(false);
      }
    } else {
      // Regular user - go to payment flow
      setSelectedPaymentOption('premium');
    }
  };
  
  // Fetch settings on mount (phone requirement and pay option)
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        // Fetch phone requirement
        const phoneResponse = await fetch(`${url}/api/settings/require-phone`);
        if (phoneResponse.ok) {
          const phoneData = await phoneResponse.json();
          if (phoneData.success) {
            setRequirePhoneNumber(phoneData.required);
          }
        }
        
        // Fetch pay option settings (public endpoint needed)
        const payResponse = await fetch(`${url}/api/settings/pay-option`);
        if (payResponse.ok) {
          const payData = await payResponse.json();
          console.log('💰 Pay option settings fetched:', payData);
          if (payData.success) {
            setEnablePayOption(payData.settings.enablePayOption ?? false);
            setPayOptionPrice(payData.settings.payOptionPrice ?? 1000);
            setPayOptionDiscountPercent(payData.settings.payOptionDiscountPercent ?? 0);
            setEnableFreeValuacion(payData.settings.enableFreeValuacion ?? true);
            console.log('✅ Pay option enabled:', payData.settings.enablePayOption);
          }
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Defaults on error
        setRequirePhoneNumber(true);
        setEnablePayOption(false);
      }
    };
    fetchSettings();
  }, []);
  
  // Calculate price preview when reaching Step 6
  useEffect(() => {
    const shouldCalculate = currentStep === 6 && requirePhoneNumber && !pricePreview && !loadingPreview;
    
    if (shouldCalculate) {
      console.log('📊 Reached Step 6 - calculating price preview');
      setLoadingPreview(true);
      
      axios.post(`${url}/api/get_price_preview`, {
        address,
        addressD,
        zone_c: zone,
        operation,
        property,
        amb,
        garage,
        sc,
        st,
        sd,
        sterre,
        condition,
        antiguedad,
        valuationType,
        barbecue,
        pool,
        sum
      })
      .then(response => {
        if (response.data.success) {
          setPricePreview(response.data.preview);
        }
      })
      .catch(error => {
        console.error('Error calculating price preview:', error);
        // Even if preview fails, continue
      })
      .finally(() => {
        setLoadingPreview(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, requirePhoneNumber]);
  
  // Calculate display step for cocheras (which skips steps 4 & 5)
  const getDisplayStep = () => {
    if (property === 'cocheras') {
      if (currentStep <= 3) return currentStep;
      if (currentStep === 6) return 4; // Phone step
      if (currentStep === 7) return 5; // Results step
    }
    return currentStep;
  };
  
  const getDisplayTotalSteps = () => {
    return property === 'cocheras' ? 5 : 7;
  };


  

  const openPayValuacionModal = () => {
    setIsPayValuacionOpen(true);
};

const closePayValuacionModal = () => {
    setIsPayValuacionOpen(false);
};

const openNotCoveredModal = () => {
  setShowNotCoveredModal(true);
};

const closeNotCoveredModal = () => {
  setShowNotCoveredModal(false);
};

const openMartilleroModal = () => {
  setIsMartilleroModalOpen(true);
};

  const closeMartilleroModal = () => {
    setIsMartilleroModalOpen(false);
  };

  const openSellingAdviceModal = () => {
    setShowSellingAdviceModal(true);
  };

  const closeSellingAdviceModal = () => {
    setShowSellingAdviceModal(false);
  };

  const closeNewFeatureModal = () => {
    setShowNewFeatureModal(false);
  };

  const tryNewFeature = () => {
    setShowNewFeatureModal(false);
    setCurrentView('development'); // Switch to the development analysis view
  };

  // Login functions
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError('');
    setLoginSuccess('');

    try {
      const response = await axios.post(`${apiBaseUrl}/api/login`, loginForm);
      
      if (response.data && response.data.token) {
        localStorage.setItem('userToken', response.data.token);
        setIsLoggedIn(true);
        setUserInfo(response.data.user || { email: loginForm.email });
        setShowLoginModal(false);
        setLoginForm({ email: '', password: '' });
        setLoginMode('login');
      } else {
        setLoginError('Credenciales inválidas');
      }
    } catch (error) {
      setLoginError('Error al iniciar sesión. Intente nuevamente.');
    } finally {
      setLoginLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (!registerTermsAccepted) {
      setLoginError('Debe aceptar los términos y condiciones para continuar');
      return;
    }
    
    setLoginLoading(true);
    setLoginError('');
    setLoginSuccess('');

    try {
      const response = await axios.post(`${apiBaseUrl}/api/register`, {
        ...registerForm,
        acceptedTerms: true,
        acceptedTermsDate: new Date().toISOString()
      });
      
      if (response.data && response.data.success) {
        // Track LinkedIn conversion for registration
        try {
          if (typeof window.lintrk === 'function') {
            console.log('🎯 Tracking LinkedIn registration conversion');
            window.lintrk('track', { conversion_id: 25094081 });
          }
        } catch (linkedinError) {
          console.error('Error tracking LinkedIn registration:', linkedinError);
        }
        
        // If agent registration, auto-login and close modal
        if (registerForm.userType === 'agent' && response.data.token) {
          localStorage.setItem('userToken', response.data.token);
          setIsLoggedIn(true);
          setUserInfo(response.data.user || { 
            email: registerForm.email, 
            name: registerForm.name,
            userType: registerForm.userType 
          });
          setShowLoginModal(false);
          setLoginSuccess('');
          setRegisterForm({ 
            name: '', 
            lname: '', 
            email: '', 
            password: '', 
            phone: '',
            userType: 'agent'
          });
          setRegisterTermsAccepted(false);
        } else {
          // Regular registration flow
        setLoginSuccess('¡Registro exitoso! Ahora puedes iniciar sesión.');
        setLoginMode('login');
        setRegisterForm({ 
          name: '', 
          lname: '', 
          email: '', 
          password: '', 
          phone: '',
          userType: 'agent'
        });
        setRegisterTermsAccepted(false);
        }
      } else {
        setLoginError('Error en el registro. Intente nuevamente.');
      }
    } catch (error) {
      setLoginError('Error al registrarse. Intente nuevamente.');
    } finally {
      setLoginLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    setIsLoggedIn(false);
    setUserInfo(null);
    setCurrentView('main'); // Navigate back to main page
    setViewMode('valuation'); // Reset to valuation mode
  };

  const openLoginModal = () => {
    setShowLoginModal(true);
    setLoginMode('login');
    setLoginError('');
    setLoginSuccess('');
  };
  
  const openRegisterModal = () => {
    setShowLoginModal(true);
    setLoginMode('register');
    setLoginError('');
    setLoginSuccess('');
  };

  const closeLoginModal = () => {
    setShowLoginModal(false);
    setLoginForm({ email: '', password: '' });
    setRegisterForm({ 
      name: '', 
      lname: '', 
      email: '', 
      password: '', 
      phone: '',
      userType: 'agent'
    });
    setRegisterTermsAccepted(false);
    setLoginError('');
    setLoginSuccess('');
    setLoginMode('login');
  };

  const switchToRegister = () => {
    setLoginMode('register');
    setLoginError('');
    setLoginSuccess('');
  };

  const switchToLogin = () => {
    setLoginMode('login');
    setLoginError('');
    setLoginSuccess('');
  };

  const handleNavigateToMetrics = () => {
    setCurrentView('dashboard-metricas');
  };
  
  const handleNavigateToUsers = () => {
    setCurrentView('users');
  };

  const handleNavigateToMain = () => {
    setCurrentView('main');
    // Reset all form states for a fresh start
    setCurrentStep(1);
    setGotPrice(false);
    setShowResult(false);
    setResultExists(false);
    setPremiumResults(null);
    setLoadingPrice(false);
    setLoadingPreview(false);
    setSelectedPaymentOption(null);
    setPricePreview(null);
    setAcceptedTerms(false);
    setShowTermsError(false);
    
    // Reset form data
    setAddress('');
    setAddressD('');
    setZone('');
    setOperation('venta'); // Reset to default
    setProperty('departamento'); // Reset to default
    setAmb('');
    setGarage('');
    setSc('');
    setSt('');
    setSd('');
    setSterreno(''); // Correct setter name
    setCondition('Estrenar'); // Reset to default
    setAntiguedad('');
    setValuationType('simple'); // Reset to default
    setBarbecue(false);
    setPool(false);
    setSum(false);
    setEmail('');
    setPhone('');
    setAddressSelected(false);
    setWhatsappStatus(null);
    setWhatsappMessage('');
    setValorPropUno(null);
    setValorPropDos(null);
    setRentData(null);
    
    // Scroll to top
    window.scrollTo(0, 0);
  };

  // Mobile slider navigation functions
  const goToNextStep = async () => {
    // If phone is not required, skip step 6 and calculate price directly
    if (currentStep === 5 && !requirePhoneNumber) {
      console.log('🔵 Phone not required - going to step 7 and calculating valuation');
      // First go to step 7 to show loading screen
      setCurrentStep(7);
      // Then calculate the valuation (this will show loading, then results)
      setTimeout(() => {
        get_price();
      }, 100); // Small delay to ensure step transition completes
      return;
    }
    
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  
  // Check if phone number has WhatsApp
  const checkWhatsApp = async (phoneNumber) => {
    console.log('checkWhatsApp called with:', phoneNumber);
    if (!phoneNumber || phoneNumber.trim() === '') {
      setWhatsappStatus(null);
      setWhatsappMessage('');
      return;
    }
    
    setWhatsappStatus('checking');
    setWhatsappMessage('Verificando...');
    console.log('Making WhatsApp check API call to:', `${url}/api/check-whatsapp`);
    
    try {
      const response = await axios.post(`${url}/api/check-whatsapp`, {
        phone: phoneNumber
      });
      
      console.log('WhatsApp check response:', response.data);
      
      if (response.data.hasWhatsApp) {
        setWhatsappStatus('valid');
        setWhatsappMessage('✓ Número verificado con WhatsApp');
      } else {
        setWhatsappStatus('invalid');
        setWhatsappMessage('✗ Este número no tiene WhatsApp');
      }
    } catch (error) {
      console.error('Error checking WhatsApp:', error);
      // Fail open - don't block submission on error
      setWhatsappStatus('valid');
      setWhatsappMessage('No se pudo verificar, pero puedes continuar');
    }
  };
  
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      // Reset selections when navigating to/from step 6
      setUserTypeSelection(null);
      setWhatsappStatus(null);
      setWhatsappMessage('');
      setAcceptedTerms(false);
      setShowTermsError(false);
      setPricePreview(null);
      setLoadingPreview(false);
      setSelectedPaymentOption(null);
      
      // Special handling for cocheras (skip steps 4 and 5)
      if (property === 'cocheras') {
        if (currentStep === 6) {
          // From phone step, go back to property type
          setCurrentStep(3);
        } else if (currentStep === 7) {
          // From results, go back to phone
          setCurrentStep(6);
        } else {
          // Normal navigation for steps 1-3
          setCurrentStep(currentStep - 1);
        }
      } else {
        // Normal navigation for other property types
        setCurrentStep(currentStep - 1);
      }
    }
  };

  const goToStep = (step) => {
    if (step >= 1 && step <= totalSteps) {
      // Reset user type selection if navigating away from step 6
      if (currentStep === 6 && step !== 6) {
        setUserTypeSelection(null);
        setAcceptedTerms(false);
        setShowTermsError(false);
      }
      setCurrentStep(step);
    }
  };

  // Validate current step before moving forward
  const canProceedToNextStep = () => {
    switch (currentStep) {
      case 1: // Address/Location step
        return address && addressSelected;
      case 2: // Operation Type step
        return operation;
      case 3: // Property Type step
        return property;
      case 4: // Valuation Type step
        return valuationType;
      case 5: // Details step
        // Cocheras skips this step
        if (property === 'cocheras') return true;
        if (valuationType === "simple") {
          // For basic valuaciones: only amb is required, cochera and antiguedad are optional
          return amb;
        } else {
          return amb && sc && antiguedad;
        }
      case 6: // Contact step
        // If phone is not required globally, skip validation
        if (!requirePhoneNumber) {
          return true;
        }
        // Agents don't need to provide phone, regular users do
        if (isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual')) {
          return true;
        }
        // Personal users need phone (WhatsApp will be validated when they click Tasar)
        return phone && phone.trim() !== '';
      case 7: // Results step
        return true; // Always allow moving forward from results
      default:
        return false;
    }
  };

  // Auto-advance when operation is selected (step 2) - both mobile and desktop
  const handleOperationSelect = (selectedOperation) => {
    setOperation(selectedOperation);
    
    // Log step 2 to backend
    axios.post(`${url}/api/log_action`, {
      action: 'form_step_2',
      details: {
        address: addressD || address,
        operation: selectedOperation
      }
    }).catch(() => {});
    
    // Auto-advance to step 3
    if (currentStep === 2) {
      setTimeout(() => {
        goToNextStep();
      }, 600);
    }
  };

  const handlePropertySelect = (selectedProperty) => {
    let autoValuationType = null;
    
    if (selectedProperty === 'casa') {
      setProperty('casa');
      setValuationType("advanced");
      autoValuationType = "advanced";
    } else if (selectedProperty === 'cocheras') {
      setProperty('cocheras');
      setValuationType("simple"); // Cocheras only supports simple valuation
      // Set default values for cocheras (not needed)
      setAmb('N/A');
      setAntiguedad('0');
      autoValuationType = "simple";
    } else {
      setProperty(selectedProperty);
    }
    
    // Log step 3 to backend
    axios.post(`${url}/api/log_action`, {
      action: 'form_step_3',
      details: {
        address: addressD || address,
        operation: operation,
        property: selectedProperty
      }
    }).catch(() => {});
    
    // If valuation type was auto-selected, log step 4
    if (autoValuationType) {
      axios.post(`${url}/api/log_action`, {
        action: 'form_step_4',
        details: {
          address: addressD || address,
          operation: operation,
          property: selectedProperty,
          valuationType: autoValuationType
        }
      }).catch(() => {});
    }
    
    // Auto-advance to step 4 (or step 6 for cocheras - phone only)
    if (currentStep === 3) {
      setTimeout(() => {
        if (selectedProperty === 'cocheras') {
          // Skip valuation type and property details for cocheras, go directly to phone
          setCurrentStep(6);
        } else {
          goToNextStep();
        }
      }, 600);
    }
  };

  // Auto-advance on mobile when valuation type is selected (step 4)
  const handleValuationTypeSelect = (type) => {
    if (type === "simple") {
      setValuationType("simple");
      setAmb(1);
    } else {
      setValuationType(type);
    }
    
    // Log step 4 to backend (valuation type selection)
    axios.post(`${url}/api/log_action`, {
      action: 'form_step_4',
      details: {
        address: addressD || address,
        operation: operation,
        property: property,
        valuationType: type
      }
    }).catch(() => {});
    
    // Auto-advance to step 5 on mobile
    if (isMobile && currentStep === 4) {
      setTimeout(() => {
        goToNextStep();
      }, 600);
    }
  };

const scrollToBottom = () => {
  // Try to find the results section
  const resultsSection = document.querySelector('[data-results-section]');
  if (resultsSection) {
    resultsSection.scrollIntoView({ 
      behavior: "smooth", 
      block: "start",
      inline: "nearest"
    });
  } else {
    // Fallback: scroll to bottom of page
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  }
};



  const openModalSample = () => setIsModalSampleOpen(true);
  const closeModalSample = () => setIsModalSampleOpen(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  //const userLogin = queryParams.get('user_login');
  //const usrNameU = queryParams.get('user');
  const [userLoginUrl, setUserLoginUrl] = useState(queryParams.get('user_login'));
  const [usrNameU, setUsrNameU] = useState(queryParams.get('user'));
  const [usrPu, setUsrPU] = useState(queryParams.get('token'));

  // Log page visit when app loads
  useEffect(() => {
    logPageVisit('homepage');
    
    // Simple page hit for real-time server monitoring
    axios.post(`${process.env.NODE_ENV === 'production' ? 'https://valuacionesya.com:8099' : 'http://localhost:8099'}/api/page_hit`)
      .catch(err => {});
  }, []);

  // Fetch agent credits when logged in as agent
  useEffect(() => {
    const fetchAgentCredits = async () => {
      if (isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual')) {
        try {
          const response = await axios.get(`${url}/api/agent/credits`, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('userToken')}`
            }
          });
          if (response.data.success) {
            setAgentCredits(response.data.premiumCredits);
          }
        } catch (error) {
          console.error('Error fetching agent credits:', error);
        }
      }
    };

    fetchAgentCredits();
  }, [isLoggedIn, userInfo]);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
      setIsMobile(isMobileDevice);
    };

    // Check on mount
    checkMobile();

    // Add resize listener to handle orientation changes
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Log when users reach step 5 or 6
  useEffect(() => {
    if (currentStep === 5) {
      // Step 5: Property details (rooms, garage, surfaces)
      axios.post(`${url}/api/log_action`, {
        action: 'form_step_5_reached',
        details: {
          address: addressD || address,
          operation: operation,
          property: property,
          valuationType: valuationType
        }
      }).catch(() => {});
    } else if (currentStep === 6) {
      // Step 6: Contact info page reached
      axios.post(`${url}/api/log_action`, {
        action: 'form_step_6_reached',
        details: {
          address: addressD || address,
          operation: operation,
          property: property,
          valuationType: valuationType,
          amb: amb,
          garage: garage,
          sc: sc,
          st: st,
          sd: sd
        }
      }).catch(() => {});
    }
  }, [currentStep]);

  // Step 7 removed - user type selection no longer exists (defaults to 'personal')

  // Auto-scroll to show submit button on mobile Step 6
  useEffect(() => {
    if (isMobile && currentStep === 6) {
      // Delay to ensure content is rendered
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight * 0.25, // Scroll 25% down
          behavior: 'smooth'
        });
      }, 300);
    }
  }, [currentStep, isMobile]);

  // Reset WhatsApp status when step changes or when user edits phone after seeing error
  useEffect(() => {
    // Clear validation status when leaving step 6
    if (currentStep !== 6) {
      setWhatsappStatus(null);
      setWhatsappMessage('');
    }
  }, [currentStep]);
  
  // Clear validation status when user changes phone (to allow retry)
  useEffect(() => {
    if (whatsappStatus) {
      // User is editing phone after validation - clear any previous status
      setWhatsappStatus(null);
      setWhatsappMessage('');
    }
  }, [phone]);

  useEffect(() => {
    if (isModalSampleOpen == false && userLoginUrl === 'true') {
      //onHide(); // Show the modal if user_login=true
    }else{
      //setIsModalSampleOpen(true);
      /*
      const timer = setTimeout(() => {
        setIsModalSampleOpen(true);
      }, 4000);

      // Cleanup timeout if the component unmounts or dependencies change
      return () => clearTimeout(timer);
      */
    }
  },[userLoginUrl]);

  // Effect to detect payment success and route to correct results page
  useEffect(() => {
    // Check URL params first (if they exist)
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment');
    const paymentId = urlParams.get('payment_id');
    const status = urlParams.get('status');
    const collectionStatus = urlParams.get('collection_status');
    const source = urlParams.get('source');
    const paymentType = urlParams.get('type'); // 'premium' or undefined (for SMP)
    const externalReference = urlParams.get('external_reference');
    
    // Check for pending payment in localStorage (fallback for auto_return)
    const pendingPaymentStr = localStorage.getItem('pendingMercadoPagoPayment');
    let shouldTriggerAnalysis = false;
    let triggerPaymentId = paymentId;
    
    // Check if we have a payment_id in URL AND evidence this is a valid payment return
    // Only trigger if we have proper MercadoPago return parameters
    if (paymentId && (paymentStatus === 'success' || status === 'approved' || source === 'mercadopago')) {
      shouldTriggerAnalysis = true;
      triggerPaymentId = paymentId;
    } else if (paymentId) {
    } else if (pendingPaymentStr) {
      // Check if we have a pending payment and user just returned
      try {
        const pendingPayment = JSON.parse(pendingPaymentStr);
        const timeSincePayment = Date.now() - pendingPayment.timestamp;
        const wasRecentPayment = timeSincePayment < 10 * 60 * 1000; // 10 minutes
        
        if (pendingPayment.pendingPayment && wasRecentPayment) {
          shouldTriggerAnalysis = true;
          triggerPaymentId = 'localStorage_fallback';
          
          // Mark as completed in localStorage
          pendingPayment.pendingPayment = false;
          pendingPayment.completedAt = Date.now();
          localStorage.setItem('pendingMercadoPagoPayment', JSON.stringify(pendingPayment));
        }
      } catch (error) {
        // Error parsing pending payment
      }
    }
    
    if (shouldTriggerAnalysis) {
      
      // Check if this is a PREMIUM payment or SMP Analysis
      if (paymentType === 'premium' && externalReference) {
        console.log('💎 Premium payment detected - fetching results...');
        
        // Fetch premium valuation results
        axios.get(`${url}/api/premium_valuation/status/${externalReference}`)
          .then(response => {
            if (response.data.success && response.data.valuationResults) {
              console.log('✅ Premium results received:', response.data.valuationResults);
              
              // Store premium results
              localStorage.setItem('premium_valuation_results', JSON.stringify(response.data.valuationResults));
              localStorage.setItem('premium_payment_success', 'true');
              
              // Set the valuation results to display
              const results = response.data.valuationResults;
              setPremiumResults(results); // Store full premium data
              
              // Check if this is a rent valuation with dual currency data
              if (results.isRent && results.preciosARS && results.preciosUSD) {
                // Premium rent valuation - populate rentData with both currencies
                setRentData({
                  ars: {
                    avgPrice: results.preciosARS.precioPromedio,
                    minPrice: results.preciosARS.precioMinimo,
                    maxPrice: results.preciosARS.precioMaximo
                  },
                  usd: {
                    avgPrice: results.preciosUSD.precioPromedio,
                    minPrice: results.preciosUSD.precioMinimo,
                    maxPrice: results.preciosUSD.precioMaximo
                  }
                });
                // Set primary values (use USD if available, fallback to ARS)
                setValorPropUno(results.preciosUSD.precioMinimo || results.preciosARS.precioMinimo);
                setValorPropDos(results.preciosUSD.precioMaximo || results.preciosARS.precioMaximo);
              } else {
                // Sale valuation or old format
                setValorPropUno(results.valorMinimo);
                setValorPropDos(results.valorMaximo);
              }
              
              setShowResult(true);
              setGotPrice(true);
              setResultExists(true);
              
              // Restore property info from payment
              const propertyInfo = response.data.property;
              if (propertyInfo) {
                // Basic info
                setAddressD(propertyInfo.address);
                setZone(propertyInfo.zone);
                setProperty(propertyInfo.type);
                setOperation(propertyInfo.operation);
                setAmb(propertyInfo.amb || 1);
                setGarage(propertyInfo.garage || 0);
                setCondition(propertyInfo.condition || 'Muy bueno');
                setAntiguedad(propertyInfo.antiguedad || 1);
                setValuationType(propertyInfo.valuationType || 'simple');
                
                // Advanced fields (surfaces)
                if (propertyInfo.valuationType === 'advanced') {
                  setSc(propertyInfo.sc || '');
                  setSt(propertyInfo.st || '');
                  setSd(propertyInfo.sd || '');
                  setSterreno(propertyInfo.sterre || '');
                  
                  // Amenities
                  setBarbecue(propertyInfo.barbecue || false);
                  setPool(propertyInfo.pool || false);
                  setSum(propertyInfo.sum || false);
                }
              }
              
              // Navigate to results step
              setCurrentStep(7);
              
              // Clean URL after processing
              window.history.replaceState({}, document.title, window.location.pathname);
            } else {
              console.warn('⚠️ Premium results not available yet');
              alert('Tu pago fue exitoso. Los resultados de tu valuación premium estarán disponibles en unos momentos.');
            }
          })
          .catch(error => {
            console.error('❌ Error fetching premium results:', error);
            alert('Tu pago fue exitoso pero hubo un error al cargar los resultados. Por favor contactanos.');
          });
        
      } else {
        // SMP Analysis payment - existing flow
        // BUT: Only process if we have actual payment URL params (not just localStorage fallback)
        if (paymentId && paymentId !== 'localStorage_fallback') {
          console.log('📊 SMP Analysis payment detected');
          
          // Save ALL URL parameters for DevelopmentAnalysis to use
          const allParams = {
            payment: paymentStatus,
            payment_id: paymentId,
            status: status,
            collection_status: collectionStatus,
            source: source,
            collection_id: urlParams.get('collection_id'),
            preference_id: urlParams.get('preference_id'),
            external_reference: externalReference
          };
          
          localStorage.setItem('mercadopago_url_params', JSON.stringify(allParams));
          
          // Set flags for DevelopmentAnalysis component to pick up
          localStorage.setItem('showDevelopmentResults', 'true');
          localStorage.setItem('paymentCompleted', 'true');
          if (triggerPaymentId) {
            localStorage.setItem('mercadopago_payment_id', triggerPaymentId);
          }
          
          // Switch to development tab
          setViewMode('development');
          
          // DO NOT clean URL - these params are the user's "ticket" to access results
        } else {
          // localStorage_fallback without proper URL params - just stay on normal landing page
          console.log('⚠️ localStorage_fallback without payment URL params - staying on landing page');
        }
      }
    }
  }, []);

  // Auto-show martillero modal after 3 seconds when results are shown
  // DISABLED - Replaced with selling advice modal
  /*
  useEffect(() => {
    let timer;
    if (showResult && gotPrice) {
      timer = setTimeout(() => {
        openMartilleroModal();
      }, 3000);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [showResult, gotPrice]);
  */

  // Reset modal when starting new valuation
  useEffect(() => {
    if (!showResult) {
      setIsMartilleroModalOpen(false);
    }
  }, [showResult]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const valor1 = urlParams.get('a');
    const valor2 = urlParams.get('b');
    const address = urlParams.get('c');
    const sc = urlParams.get('sc');
    const st = urlParams.get('st');
    const sd = urlParams.get('sd');
    const garage = urlParams.get('garage');
    const antiguedad = urlParams.get('antiguedad');
    const condicion = urlParams.get('condicion');

  
  
    if (valor1) {
      try {
        const formattedValor1 = new Intl.NumberFormat('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(Number(valor1));
        setValorPropUno(formattedValor1);
        setShowResult(true);
      } catch (error) {
        // Error formatting Valor1
      }
      setTimeout(() => {
        scrollToBottom();
      }, 1000);

      // Show selling advice modal after 5 seconds
      setTimeout(() => {
        openSellingAdviceModal();
      }, 5000);
      
    }
  
    if (valor2) {
      try {
        const formattedValor2 = new Intl.NumberFormat('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(Number(valor2));
        setValorPropDos(formattedValor2);
      } catch (error) {
        // Error formatting Valor2
      }
    }

    if (sc) {
      try {
        setSc(sc);
      } catch (error) {
        // Error setting sc
      }
    }

    if (st) {
      try {
        setSt(st);
      } catch (error) {
        // Error setting st
      }
    }

    if (sd) {
      try {
        setSd(sd);
      } catch (error) {
        // Error setting sd
      }
    }

    if (garage) {
      try {
        setGarage(garage);
      } catch (error) {
        // Error setting garage
      }
    }

    if (antiguedad) {
      try {
        setAntiguedad(antiguedad);
      } catch (error) {
        // Error setting antiguedad
      }
    }

    if (condicion) {
      try {
        setCondition(condicion);
      } catch (error) {
        // Error setting condition
      }
    }

    if (address) {
      try {
        setAddressD(address);
      } catch (error) {
        // Error setting address
      }
    }
  },[]); // Run only once
  
  

    

  const a = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setUser(res.data.ip);
  };

  const valuar_disabled = async () => {
    //const res = await axios.post(url+':8099/api/valuar_disabled');
    axios({
      method: 'POST',
              url: `${url}/api/valuar_disabled`,
      data: {
      },
  })
  .then((res) => {
  })
  .catch((error) => {
      // Error loading data
  })
  .finally(() => {
  });
  };

  // Generate or retrieve visitor ID
  const getVisitorId = () => {
    let visitorId = localStorage.getItem('visitorId');
    if (!visitorId) {
      visitorId = 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('visitorId', visitorId);
    }
    return visitorId;
  };

  // Extract UTM parameters from URL
  const getUTMParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utmSource: params.get('utm_source'),
      utmMedium: params.get('utm_medium'),
      utmCampaign: params.get('utm_campaign'),
      referrer: document.referrer
    };
  };

  useEffect(() => {
    a();
    
    // Track visitor with source information
    const visitorId = getVisitorId();
    const utmParams = getUTMParams();
    
    // Send visitor tracking with source info
    axios.post(`${url}/api/visitor`, {
      visitorId,
      address: window.location.pathname,
      ...utmParams,
      userAgent: navigator.userAgent
    }).catch(error => {
      // Silent fail on visitor tracking
    });
    
    // Check if user is already logged in
    const token = localStorage.getItem('userToken');
    console.log('🔍 Page load - Token found:', !!token);
    if (token) {
      try {
        // Decode the token (simple base64 encoded JSON)
        const decoded = JSON.parse(atob(token));
        console.log('✅ Token decoded successfully:', decoded.email, decoded.userType);
        setIsLoggedIn(true);
        setUserInfo({
          email: decoded.email,
          name: decoded.name,
          userType: decoded.userType,
          userId: decoded.userId
        });
      } catch (error) {
        console.error('❌ Token validation error:', error);
        localStorage.removeItem('userToken');
        setIsLoggedIn(false);
        setUserInfo(null);
        setCurrentView('main'); // Redirect to main on token error
      } finally {
        setIsAuthChecking(false); // Done checking
      }
    } else {
      console.log('ℹ️ No token found - user not logged in');
      setIsAuthChecking(false); // Done checking
    }
  }, []);

  // Save current view to localStorage
  useEffect(() => {
    localStorage.setItem('currentView', currentView);
  }, [currentView]);

  // Protect routes: redirect if user loses authentication or doesn't have permission
  useEffect(() => {
    // Only check after authentication is complete
    if (isAuthChecking) {
      return;
    }
    
    const isDashboardView = currentView.startsWith('dashboard-');
    const isAdminOnlyView = currentView === 'users' || currentView === 'metrics' || (isDashboardView && currentView !== 'dashboard-valuaciones');
    const isAgentView = currentView === 'agent-dashboard' || currentView === 'agent-credits' || currentView === 'agent-account' || currentView === 'dashboard-valuaciones';

    // Not logged in trying to access protected routes
    if (!isLoggedIn && (isAdminOnlyView || isAgentView)) {
      console.log('⚠️ Unauthorized access attempt - redirecting to main');
      setCurrentView('main');
    }

    // Non-admin trying to access admin-only views
    if (isLoggedIn && userInfo && isAdminOnlyView && userInfo.userType !== 'Admin') {
      console.log('⚠️ Non-admin trying to access admin view - redirecting to main');
      setCurrentView('main');
    }

    // Non-agent/admin/individual trying to access agent views
    if (isLoggedIn && userInfo && isAgentView && userInfo.userType !== 'agent' && userInfo.userType !== 'individual' && userInfo.userType !== 'Admin') {
      console.log('⚠️ Non-agent/individual/admin trying to access agent dashboard - redirecting to main');
      setCurrentView('main');
    }
  }, [isLoggedIn, currentView, userInfo, isAuthChecking]);

  // Removed automatic redirect to /vendor - users should stay on current page after login
  // useEffect(() => {
  //   const checkAuth = async () => {
  //     const authenticated = await verifyToken();
  //     if (!authenticated) {
  //       //navigate('/vendor');
  //     } else {
  //       navigate('/vendor');
  //     }
  //   };
  //   checkAuth();
  // }, [navigate]);

  // Load phone and email from cookies on page load
  useEffect(() => {
    const savedPhone = getCookie('userPhone');
    const savedEmail = getCookie('userEmail');
    
    if (savedPhone) {
      setPhone(savedPhone);
      // WhatsApp will be validated when user clicks Tasar button
    }
    if (savedEmail) {
      setEmail(savedEmail);
    }
  }, []);
  
  // WhatsApp validation removed - now only happens on Tasar button click

  // Activity tracking - connect to WebSocket for all users
  useEffect(() => {
    let socket = null;
    let activityInterval = null;
    let mouseActivityTimeout = null;

    const setupActivityTracking = async () => {
      try {
        // Import socket.io-client dynamically
        const { io } = await import('socket.io-client');
        
        // Connect to backend WebSocket
        socket = io(apiBaseUrl, { 
          transports: ['websocket', 'polling'],
          withCredentials: false,
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionAttempts: 5
        });

        setActivitySocket(socket);

        // Send activity ping every 30 seconds
        activityInterval = setInterval(() => {
          if (socket && socket.connected) {
            socket.emit('activity');
          }
        }, 30000);

        // Send activity on user interaction
        const sendActivity = () => {
          if (socket && socket.connected) {
            // Debounce: only send if no activity was sent in the last 5 seconds
            clearTimeout(mouseActivityTimeout);
            mouseActivityTimeout = setTimeout(() => {
              socket.emit('activity');
            }, 5000);
          }
        };

        // Track mouse movement, clicks, scrolls, and key presses
        window.addEventListener('mousemove', sendActivity);
        window.addEventListener('click', sendActivity);
        window.addEventListener('scroll', sendActivity);
        window.addEventListener('keypress', sendActivity);

      } catch (error) {
        // Silent error handling for activity tracking
      }
    };

    setupActivityTracking();

    // Cleanup on unmount
    return () => {
      if (activityInterval) clearInterval(activityInterval);
      if (mouseActivityTimeout) clearTimeout(mouseActivityTimeout);
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  /*
  useEffect(() => {
    // Clear results when operation changes
    setGotPrice(false);
    setValorProp(0);
    setValorPropUno(0);
    setValorPropDos(0);
  }, [operation]);
  */

  const handleChange = (event,num) => {

    const inputValue = event.target.value;

    if(num=="amb"){
      if (/^\d*$/.test(inputValue)) {
        setAmb(inputValue);
      }
    }else if(num=="garage"){
      if (/^\d*$/.test(inputValue)) {
        setGarage(inputValue);
      }
    }else if(num=="sc"){
      if (/^\d*$/.test(inputValue)) {
        setSc(inputValue);
      }
    }else if(num=="st"){
      if (/^\d*$/.test(inputValue)) {
        setSt(inputValue);
      }
    }else if(num=="sd"){
      if (/^\d*$/.test(inputValue)) {
        setSd(inputValue);
      }
    }else if(num=="sterre"){
      if (/^\d*$/.test(inputValue)) {
        setSterreno(inputValue);
      }
    }else if(num=="antiguedad"){
      if (/^\d*$/.test(inputValue)) {
        setAntiguedad(inputValue);
      }
    }
    

    // Check if the input value is a valid integer
    
  };
/*
  const get_price = () => {
    setLoadingPrice(true);
    axios({
      method: 'POST',
              url: url + '/api/get_price_11',
      data: {
        address: address,
        addressD: addressD,
        zone_c: zone,
        operation: operation,
        property: property,
        amb: amb,
        garage: garage,
        sc: sc,
        st: st,
        sd: sd,
        sterre: sterre,
        condition: condition,
        antiguedad: antiguedad,
        barbecue: barbecue,
        pool: pool,
        sum: sum,
        email: email,
        phone: phone,
        motive: motive,
      },
    })
      .then((res) => {
        if (res.data.error) {
          setGotPrice(false);
          setModalC(true); // Show the credits modal if there's an issue
        } else {
          setValorProp(res.data.valor);
          setValorPropUno(res.data.averagePriceARS || res.data.valorPropUno);
          setValorPropDos(res.data.averagePriceUSD || res.data.valorPropDos);
          //setGotPrice(true);
          setModalC(true);
          //setIsPriceModalOpen(true); // Open the price modal
        }
        setLoadingPrice(false);
      })
      .catch((error) => {
        setLoadingPrice(false);
        setModalC(true); // Handle errors gracefully
      });
  };

  */

  const get_price = async () => {
    // Log step 4 (valuation type - in case it was set by default and never explicitly clicked)
    axios.post(`${url}/api/log_action`, {
      action: 'form_step_4',
      details: {
        address: addressD || address,
        operation: operation,
        property: property,
        valuationType: valuationType
      }
    }).catch(() => {});
    
    // Agents don't need to provide phone
    const isAgent = isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual');
    
    // Validate required fields (phone only for non-agents and if phone is required, email will be auto-generated)
    if (requirePhoneNumber && !isAgent && (!phone || phone.trim() === '')) {
      alert("Por favor ingrese su número de teléfono");
      return;
    }
    
    // For non-agents, validate WhatsApp before proceeding (if enabled in settings and phone is required)
    if (requirePhoneNumber && !isAgent) {
      // Check if WhatsApp verification is enabled (fetch from backend)
      let isVerificationEnabled = true; // Default to true
      
      try {
        const settingsResponse = await axios.get(`${url}/api/settings/whatsapp-verification`);
        if (settingsResponse.data.success) {
          isVerificationEnabled = settingsResponse.data.enabled;
        }
      } catch (error) {
        console.log('Could not fetch WhatsApp verification setting, defaulting to enabled');
        // Default to enabled on error
      }
      
      if (isVerificationEnabled) {
        console.log('Non-agent user, validating WhatsApp before proceeding...');
        
        // Clear any previous status and validate now
        setWhatsappStatus('checking');
        setWhatsappMessage('Verificando WhatsApp...');
        
        try {
          const response = await axios.post(`${url}/api/check-whatsapp`, {
            phone: phone
          });
          
          console.log('WhatsApp check result:', response.data);
          
          if (!response.data.hasWhatsApp) {
            setWhatsappStatus('invalid');
            setWhatsappMessage('✗ Este número no tiene WhatsApp');
            console.log('WhatsApp validation failed - blocking valuación');
            // Don't proceed with valuación
            return;
          }
          
          // Valid WhatsApp number
          setWhatsappStatus('valid');
          setWhatsappMessage('✓ Número verificado con WhatsApp');
          console.log('WhatsApp validated successfully, proceeding with valuación');
          
        } catch (error) {
          console.error('Error validating WhatsApp:', error);
          // Fail open - allow submission on error
          setWhatsappStatus('valid');
          setWhatsappMessage('No se pudo verificar, continuando...');
          console.log('WhatsApp check failed, but allowing valuación to proceed');
        }
      } else {
        console.log('WhatsApp verification is disabled in settings - skipping validation');
        setWhatsappStatus('valid');
        setWhatsappMessage('');
      }
    }
    
    let cleanedPhone = '';
    let finalEmail = email;
    let formattedPhone = '';
    
    if (isAgent) {
      // For agents, use their registration info or generate defaults
      formattedPhone = '+549999999999'; // Placeholder for agents
      finalEmail = userInfo.email || 'agent@valuacionesya.com';
    } else if (requirePhoneNumber && phone) {
      // Validate phone number format for regular users (only if phone is required)
      cleanedPhone = phone.replace(/\D/g, ''); // Remove all non-digits
    if (cleanedPhone.startsWith('0')) {
      cleanedPhone = cleanedPhone.substring(1);
    }
    
    // Check if it's a valid Argentinian mobile number (10-11 digits after removing 0)
    if (cleanedPhone.length < 10 || cleanedPhone.length > 11) {
      alert("Por favor ingrese un número de teléfono argentino válido (ej: 11-2222-3333)");
      return;
      }
      
      // Auto-generate email from phone if not provided
      if (!finalEmail || finalEmail.trim() === '') {
        finalEmail = `user${cleanedPhone}@valuacionesya.com`;
        setEmail(finalEmail);
      }
      
      // Save phone and email to cookies for future use (1 year expiration)
      setCookie('userPhone', phone, 365);
      setCookie('userEmail', finalEmail, 365);
      
      // Format phone number for API
      formattedPhone = phone;
    } else if (!requirePhoneNumber) {
      // If phone is not required, use placeholder values
      formattedPhone = '';
      cleanedPhone = '';
      // Auto-generate a random email
      if (!finalEmail || finalEmail.trim() === '') {
        finalEmail = `user${Date.now()}@valuacionesya.com`;
        setEmail(finalEmail);
      }
    }
    
    // Track Google Ads conversion
    try {
      if (typeof window.gtag_report_conversion === 'function') {
        console.log('🎯 Tracking Google Ads conversion');
        window.gtag_report_conversion();
      }
    } catch (conversionError) {
      console.error('Error tracking Google Ads conversion:', conversionError);
    }
    
    // Track LinkedIn conversion
    try {
      if (typeof window.lintrk === 'function') {
        console.log('🎯 Tracking LinkedIn conversion');
        window.lintrk('track', { conversion_id: 19381530 });
      }
    } catch (linkedinError) {
      console.error('Error tracking LinkedIn conversion:', linkedinError);
    }
    
    setLoadingPrice(true);
    
    // Scroll to show loading state (desktop only)
    if (!isMobile) {
    setTimeout(() => {
      scrollToBottom();
    }, 100);
    }
    
    // Additional phone formatting for non-agents
    if (!isAgent && phone && phone.trim() !== '') {
      // Basic phone number formatting for Argentina
      let phoneFormatted = phone.replace(/\D/g, ''); // Remove all non-digits
      
      // If it starts with 0, remove it
      if (phoneFormatted.startsWith('0')) {
        phoneFormatted = phoneFormatted.substring(1);
      }
      
      // Special case: if it's the bypass number 1150543162, ensure it becomes +5491150543162
      if (phoneFormatted === '1150543162') {
        phoneFormatted = '5491150543162';
      }
      // If it doesn't start with 54, add it
      else if (!phoneFormatted.startsWith('54')) {
        phoneFormatted = '54' + phoneFormatted;
      }
      
      // If it doesn't start with +, add it
      if (!phoneFormatted.startsWith('+')) {
        phoneFormatted = '+' + phoneFormatted;
      }
      
      formattedPhone = phoneFormatted;
    }
    
    // Choose endpoint based on property type and operation
    let apiEndpoint;
    
    // Oficinas, Locales Comerciales, and Cocheras always use Gemini AI
    if (property === 'oficina' || property === 'local' || property === 'cocheras') {
        apiEndpoint = operation === 'alquiler' ? `${url}/api/get_rent` : `${url}/api/get_sale`;
    } 
    // Other properties use standard routing
    else {
        apiEndpoint = operation === 'alquiler' ? `${url}/api/get_rent` : `${url}/api/get_price_112`;
    }
    
    // Get visitor ID and UTM params for source tracking
    const visitorId = getVisitorId();
    const utmParams = getUTMParams();
    
    // Prepare headers with token if logged in
    const headers = {};
    const userToken = localStorage.getItem('userToken');
    if (userToken) {
      headers.Authorization = `Bearer ${userToken}`;
    }
    
    // Apply default values for optional fields in basic valuaciones
    const finalGarage = garage || '0';
    const finalAntiguedad = antiguedad || '1';
    const finalSt = st || '0'; // Superficie Semicubierta (optional)
    const finalSd = sd || '0'; // Superficie Descubierta (optional)
    const finalSterre = sterre || '0'; // Superficie Terreno (optional)
    
    // Prepare consent data
    const consentData = {
      acceptedTerms: isAgent ? true : (!requirePhoneNumber ? true : acceptedTerms), // Auto-accept if phone not required
      acceptedTermsDate: new Date().toISOString(),
      consentVersion: '2025-12-14',
      userType: isAgent ? 'agent' : 'personal'
    };
    
    axios({
        method: 'POST',
        url: apiEndpoint,
        headers: headers,
        data: {
            address: marker,
            addressD: addressD,
            zone_c: zone,
            operation: operation,
            property: property,
            amb: amb,
            garage: finalGarage,
            sc: sc,
            st: finalSt,
            sd: finalSd,
            sterre: finalSterre,
            condition: condition,
            antiguedad: finalAntiguedad,
            barbecue: barbecue,
            pool: pool,
            sum: sum,
            email: finalEmail,
            motive: motive,
            phone: formattedPhone,
            valuationType: valuationType,
            // Source tracking
            visitorId: visitorId,
            utmSource: utmParams.utmSource,
            utmMedium: utmParams.utmMedium,
            utmCampaign: utmParams.utmCampaign,
            referrer: utmParams.referrer,
            // Dev mode: Email control
            sendEmail: isDevelopment ? sendEmail : true,
            // Consent tracking
            ...consentData
        },
    })
    .then((res) => {
        // Handle rent estimation response
        if (operation === 'alquiler' && res.data.success) {
            setGotPrice(true);
            setResultExists(true);
            setRentData(res.data.data); // Store full rent data with ARS and USD
            setValorPropUno(res.data.data.ars?.avgPrice || res.data.data.avgPrice); // Fallback for old format
            setValorPropDos(res.data.data.ars?.maxPrice || res.data.data.maxPrice); // Fallback for old format
            setShowResult(true);
            
            // Advance to results step (both mobile and desktop now use step system)
            setTimeout(() => {
                setCurrentStep(7);
                if (!isMobile) {
                    setTimeout(() => scrollToBottom(), 200);
                }
            }, 300);
            
            // Show martillero modal ONLY if phone requirement is OFF (for lead capture)
            // Don't show if phone is required (already have contact info) or user is agent
            setTimeout(() => {
                console.log('Alquiler: Checking if should show martillero modal', {
                    isLoggedIn,
                    userInfo,
                    userType: userInfo?.userType,
                    requirePhoneNumber
                });
                if (!requirePhoneNumber && (!isLoggedIn || (userInfo && userInfo.userType !== 'agent'))) {
                    console.log('Alquiler: Showing martillero modal (phone requirement OFF)');
                    setMartilleroBookingData({
                        address: addressD || address,
                        phone: formattedPhone || phone,
                        email: finalEmail,
                        propertyType: property,
                        operation: 'alquiler',
                        estimatedValue: `ARS $${(res.data.data.ars?.avgPrice || res.data.data.avgPrice).toLocaleString('es-AR')}`
                    });
                    setShowMartilleroModal(true);
                } else {
                    console.log('Alquiler: Not showing modal - requirePhone:', requirePhoneNumber, 'isAgent:', (userInfo?.userType === 'agent' || userInfo?.userType === 'individual'));
                }
            }, 3000);
        }
        // Handle sale valuation response
        else if (res.data.resultsExist) {
            // If results exist, update the values and display them
            setGotPrice(true);
            setResultExists(true);
            setValorPropUno(res.data.valorPropUno); // Set the actual price values
            setValorPropDos(res.data.valorPropDos);
            setShowResult(true);
            handleConversion();
            
            // Advance to results step (both mobile and desktop now use step system)
            setTimeout(() => {
                setCurrentStep(7);
                if (!isMobile) {
                    setTimeout(() => scrollToBottom(), 200);
                }
                
            }, 300);

            // Show martillero modal ONLY if phone requirement is OFF (for lead capture)
            // Don't show if phone is required (already have contact info) or user is agent
            setTimeout(() => {
                console.log('Venta: Checking if should show martillero modal', {
                    isLoggedIn,
                    userInfo,
                    userType: userInfo?.userType,
                    requirePhoneNumber
                });
                if (!requirePhoneNumber && (!isLoggedIn || (userInfo && userInfo.userType !== 'agent'))) {
                    console.log('Venta: Showing martillero modal (phone requirement OFF)');
                    setMartilleroBookingData({
                        address: addressD || address,
                        phone: formattedPhone || phone,
                        email: finalEmail,
                        propertyType: property,
                        operation: 'venta',
                        estimatedValue: `USD $${res.data.valorPropUno.toLocaleString('es-AR')}`
                    });
                    setShowMartilleroModal(true);
                } else {
                    console.log('Venta: Not showing modal - requirePhone:', requirePhoneNumber, 'isAgent:', (userInfo?.userType === 'agent' || userInfo?.userType === 'individual'));
                }
            }, 3000);
        } else {
            // If results do not exist, show the alert message
            setResultExists(false);
            setGotPrice(false);
            setShowResult(false);
            openNotCoveredModal();
        }
    })
    .catch((error) => {
        console.error('❌ Valuation error:', error);
        console.error('Error response:', error.response?.data);
        setGotPrice(false);
        setShowResult(false);
        openNotCoveredModal();
    })
    .finally(() => {
        console.log('✅ Valuation request completed, loading = false');
        setLoadingPrice(false);
    });
};


const e_p = () => {
  axios({
    method: 'POST',
    url: `${url}/api/send_value_e`,
    data: {
        addressD: addressD,
        zone_c: zone
    },
})
.then((res) => {
    if (res.data.error) {
    } else {
    }
})
.catch((error) => {
});
}


const send = (a) => {
  axios({
    method:'POST',
    url: url+'/api/send_a',
    data:{
      address: a
    }
}).then(res =>  {
}).catch(error => {
});
}

useEffect(() => {
  if(gotPrice){
    scrollToBottom();
  }
},[valorProp])



/*
const onMapClick = (e) => {
  setMarkers((current) => [
      ...current,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
    ]);
    setCoordsArray(coordsArray+"{ lat: "+e.latLng.lat()+", lng: "+e.latLng.lng()+"},");
  };
  */


	const mapRef = useRef();
	const autocompleteRef = useRef();

  const styles = {
    formContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        paddingBottom: '10px'
    },
    buttonGroup: {
        display: 'flex',
        gap: '10px'
    },
    buttonAlqventa: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 20px',
        border: 'none',
        cursor: 'pointer',
        color: 'white',
        fontSize: '16px',
        borderRadius: '5px',
        transition: 'background-color 0.3s'
    },
    buttonAlqventaPrimary: {
        backgroundColor: '#2EBF91' // Primary button color
    },
    buttonAlqventaPrimaryHover: {
        backgroundColor: '#0056b3' // Darker color on hover
    },
    buttonAlqventaSecondary: {
        backgroundColor: '#6c757d' // Secondary button color
    },
    buttonAlqventaSecondaryHover: {
        backgroundColor: '#5a6268' // Darker color on hover
    },
    icon: {
        marginRight: '5px'
    },
    label: {
        fontWeight: 'bold',
        padding: '10px',
        color: 'white'
    }
};

const stylesForm1 = `
  .form-container {
    padding: 20px;
    border-radius: 8px;
    color: white;
  }
  .form-label {
    font-weight: bold;
    padding: 10px;
    color: white;
    display: flex;
    align-items: center;
  }
  .form-label i {
    padding-right: 12px;
  }
  .form-control {
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
  .form-control:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.25);
  }
  .form-group1 {
    margin-bottom: 1rem;
  }
  .form-group1.hidden {
    display: none;
  }
`;

	const containerStyle = {
        width: "95%",
        height: "100vh",
        margin:"auto",
        paddingTop: "10px",
        paddingRight:"0px",
        borderRadius:"20px",
        marginTop:"8%"
    }
    const mapContainerStyle = {
      width: "95%",
      height: "50vh",
      margin:"auto",
      paddingTop: "10px",
      paddingRight:"0px",
      borderRadius:"20px",
      marginTop:"8%"
  }

	const inputStyle = {
		boxSizing: 'border-box',
		border: '1px solid transparent',
		width: '240px',
		height: '38px',
		padding: '0 12px',
		borderRadius: '3px',
		boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
		fontSize: '14px',
		outline: 'none',
		textOverflow: 'ellipses',
		position: 'absolute',
		right: '8%',
		top: '11px',
		marginLeft: '-120px'
	}
  const buttonStyle = {
    backgroundColor: '#8360C3', // Primary color
    background:'none',
    width:'100%',
    border: 'none',
    color: 'white',
    padding: '12px 24px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '18px',
    fontWeight: 'bold',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: `0 4px 8px rgba(0, 0, 0, 0.2)`,
    transition: 'background-color 0.3s ease, transform 0.3s ease',
  };
  
  const buttonHoverStyle = {
    backgroundColor: '#2EBF91', // Secondary color
    transform: 'scale(1.05)',
  };

    const center = {
        lat: 28.626137,
        lng: 79.821603,
    }

	const onLoadMap = (map) => {
		mapRef.current = map
	}

	const onLoadAutocomplete = (autocomplete) => {
		autocompleteRef.current = autocomplete;
		
		// Restrict autocomplete to Argentina only
		autocomplete.setComponentRestrictions({
			country: ['ar'] // ISO 3166-1 Alpha-2 country code for Argentina
		});
	}

  const checkArea = (zone) => {
  }

  const handleConversion = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-10953946921/1FiwCPCqro4YEKnun-co"
      });
    }
  };
  

  const TasarBtn = () => {
    if(!loadingPrice){
      return(
        <div className="buttonContainer">
  
  <div
    className="tasarBtn"
    onMouseOver={(e) => e.currentTarget.style.backgroundColor = buttonHoverStyle.backgroundColor}
    onMouseOut={(e) => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
  >
    Valuar Gratis
  </div>
</div>

      )
    }else{
      return(
        <div><RotatingLines
        visible={true}
        height="45"
        width="45"
        color="grey"
        strokeWidth="5"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
        /></div>
      )
    }
  }

	const handlePlaceChanged = async () => {
    setShowResult(false);
    
    if (!autocompleteRef.current) {
      return;
    }

    const place = autocompleteRef.current.getPlace();
    
    if (!place.geometry) {
      return;
    }

    const { geometry, formatted_address } = place;
    
    // Extract the actual zone name from address components
    let zoneName = '';
    if (place.address_components && place.address_components.length > 0) {
      // Look for the neighborhood/locality component
      const neighborhood = place.address_components.find(component => 
        component.types.includes('neighborhood') || 
        component.types.includes('locality') ||
        component.types.includes('sublocality')
      );
      
      if (neighborhood) {
        zoneName = neighborhood.long_name;
      } else {
        // Fallback: use the first administrative_area_level_1 (province)
        const province = place.address_components.find(component => 
          component.types.includes('administrative_area_level_1')
        );
        if (province) {
          zoneName = province.long_name;
        }
      }
    }
    
    // If no zone found, use a default
    if (!zoneName) {
      zoneName = 'Unknown Zone';
    }
    
    setZone(zoneName);
    setAddressD(formatted_address);
    setAddressSelected(true); // Show property details form after address selection
    setIsTypingManually(false); // Reset manual typing flag
    
    // Auto-advance to step 2 after address selection (both mobile and desktop)
    if (currentStep === 1) {
      setTimeout(() => {
        goToNextStep();
      }, 600);
    }
    
    send(formatted_address);
    
    const bounds = new window.google.maps.LatLngBounds();
    if (geometry.viewport) {
      bounds.union(geometry.viewport);
    } else {
      bounds.extend(geometry.location);
    }
    
    if (mapRef.current) {
      mapRef.current.fitBounds(bounds);
    }
    
    setMarker(geometry.location);
    setAddress(geometry.location);
    

    // ��️ BUILDING ANALYSIS - Call the enhanced endpoint
    try {
        const buildingResponse = await axios.post(`${url}/api/analyze_building_potential`, {
            lat: geometry.location.lat(),
            lng: geometry.location.lng(),
            addressD: formatted_address
        });
    } catch (buildingError) {
        // Error calling building analysis
    }

    // Scroll to "Detalles de la Propiedad" section
    setTimeout(() => {
      const detallesSection = document.querySelector('[data-section="detalles"]');
      if (detallesSection) {
        detallesSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    }, 500);
  }

  useEffect(() => {
  },[addressD])

  const safeValue = value => value ? value : 0;

  const containsLoc = [];

  return (
    <>
      <div className="App" style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Show AdminSidebar for admins and agents, regular Navbar for others */}
        {isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual')) ? (
          <>
            {/* AdminSidebar - always render for event listeners */}
            <AdminSidebar
              activeView={currentView}
              onNavigate={(view) => {
                console.log('🔄 Navigating to:', view);
                // Simple navigation without App-level loading (Metrics handles it)
                if (view === 'main') {
                  handleNavigateToMain();
                } else if (view === 'users') {
                  handleNavigateToUsers();
                } else {
                  setCurrentView(view);
                }
              }}
              onLogout={handleLogout}
              userInfo={userInfo}
              logoSrc={logoMain}
              isMobile={isMobile}
              hideHeader={isMobile && currentView === 'dashboard-mensajes'}
              userType={userInfo?.userType} // Pass user type to sidebar
            />
          </>
        ) : (
          <>
            {/* Hide navbar on mobile when on messages page or when chat is open */}
            {!(isMobile && (currentView === 'dashboard-mensajes' || isMobileChatOpen)) && (
              <Navbar 
                isLoggedIn={isLoggedIn}
                onLoginClick={openLoginModal}
                onRegisterClick={openRegisterModal}
                onLogout={handleLogout}
                userInfo={userInfo}
                onNavigateToMetrics={handleNavigateToMetrics}
                onNavigateToUsers={handleNavigateToUsers}
                onAgentDashboardClick={() => setCurrentView('agent-dashboard')}
              />
            )}
          </>
        )}
        
        {/* Hero Section - Hidden on Mobile, for Admins/Agents, and after Step 1 */}
        {!isMobile && !(isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual'))) && currentStep === 1 && (
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '30px 20px',
          textAlign: 'center',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.3
          }}></div>
          
          <div style={{ 
            position: 'relative', 
            zIndex: 1,
            maxWidth: '100%',
            margin: '0 auto'
          }}>
            <img 
              src={logoMain} 
              alt="ValuacionesYa Logo" 
              style={{
                height: '80px',
                marginBottom: '15px',
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
              }}
            />
            <p style={{
              fontSize: '1.1rem',
              marginBottom: '0',
              opacity: 0.9
            }}>
              Valuación profesional de propiedades en Argentina
            </p>
              </div>
            </div>
        )}

        {/* Main Content */}
        <div style={{
          width: '100%',
          margin: '0 auto',
          padding: currentView === 'dashboard-mensajes' && isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual'))
            ? (isMobile ? '0' : '80px 0 0 0') // Messages view: no padding on mobile (custom header), desktop gets top padding
            : (isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual')) ? (currentView.startsWith('dashboard-') || currentView === 'agent-dashboard' || currentView === 'agent-credits' || currentView === 'agent-account' || currentView === 'users' ? '80px 20px 20px 20px' : '80px 0 0 0') : (isMobile ? '20px 10px' : '0')),
          flex: 1
        }}>
          
          {/* Logged In Status - Hidden for admins and agents (they have sidebar) */}

          {/* View Mode Toggle - Only show on Step 1 */}
          {currentView === 'main' && currentStep === 1 && (
            <div style={{
              background: 'white',
              borderRadius: isMobile ? '0' : '20px',
              boxShadow: isMobile ? 'none' : '0 15px 40px rgba(0,0,0,0.12)',
              padding: isMobile ? '15px 10px' : '0',
              marginBottom: isMobile ? '0' : '20px',
              margin: isMobile ? '0' : '0 20px 20px 20px'
            }}>
              <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: isMobile ? '0' : '40px'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px'
              }}>
                <button
                  onClick={() => setViewMode('valuation')}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: viewMode === 'valuation' ? '#007bff' : '#f8f9fa',
                    color: viewMode === 'valuation' ? 'white' : '#6c757d',
                    border: '2px solid #007bff',
                    borderRadius: '25px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FontAwesomeIcon icon={faRuler} />
                  Valuar Propiedad
                </button>
                <button
                  onClick={() => setViewMode('development')}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: viewMode === 'development' ? '#28a745' : '#f8f9fa',
                    color: viewMode === 'development' ? 'white' : '#6c757d',
                    border: '2px solid #28a745',
                    borderRadius: '25px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FontAwesomeIcon icon={faBuilding} />
                  Desarrollar
                </button>

              </div>
              </div>
            </div>
          )}

          {/* Metrics View */}
          {/* Dashboard Views */}
          {currentView === 'dashboard-metricas' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <div style={{ padding: '20px' }}>
              <Metrics key="platform" userToken={localStorage.getItem('userToken')} section="platform" />
            </div>
          )}

          {currentView === 'dashboard-finanzas' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <div style={{ padding: '20px' }}>
              <Finanzas userToken={localStorage.getItem('userToken')} />
            </div>
          )}

          {currentView === 'dashboard-valuaciones' && isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual')) && (
            <div style={{ padding: '20px' }}>
              <Metrics key="valuaciones" userToken={localStorage.getItem('userToken')} section="valuaciones" />
            </div>
          )}

          {currentView === 'dashboard-leads' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <div style={{ padding: '20px' }}>
              <Metrics key="leadSources" userToken={localStorage.getItem('userToken')} section="leadSources" />
            </div>
          )}

          {currentView === 'dashboard-citas' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <div style={{ padding: '20px' }}>
              <Metrics key="appointments" userToken={localStorage.getItem('userToken')} section="appointments" />
            </div>
          )}

          {currentView === 'dashboard-mensajes' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <Metrics 
              key="messages" 
              userToken={localStorage.getItem('userToken')} 
              section="messages" 
              onMobileChatOpenChange={setIsMobileChatOpen}
            />
          )}

          {currentView === 'dashboard-ajustes' && isLoggedIn && userInfo?.userType === 'Admin' && (
            <div style={{ padding: '20px' }}>
              <Metrics key="settings" userToken={localStorage.getItem('userToken')} section="settings" />
            </div>
          )}

          {/* Agent Dashboard View */}
          {currentView === 'agent-dashboard' && (
            <>
              {isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual') ? (
                <div>
                  {/* Agent Dashboard Content */}
                  <AgentDashboard userToken={localStorage.getItem('userToken')} />
                </div>
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#7f8c8d'
                }}>
                  <h3>Acceso Restringido</h3>
                  <p>Debes iniciar sesión como agente para ver esta página.</p>
                  <button
                    onClick={() => {
                      setCurrentView('main');
                      openLoginModal();
                    }}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: '600',
                      marginTop: '20px'
                    }}
                  >
                    Iniciar Sesión
                  </button>
                </div>
              )}
            </>
          )}

          {/* Agent Credits View */}
          {currentView === 'agent-credits' && (
            <>
              {isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual') ? (
                <div>
                  {/* Agent Credits Content */}
                  <AgentCredits userToken={localStorage.getItem('userToken')} />
                </div>
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#7f8c8d'
                }}>
                  <h3>Acceso Restringido</h3>
                  <p>Debes iniciar sesión como agente para ver esta página.</p>
                  <button
                    onClick={() => {
                      setCurrentView('main');
                      openLoginModal();
                    }}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: '600',
                      marginTop: '20px'
                    }}
                  >
                    Iniciar Sesión
                  </button>
                </div>
              )}
            </>
          )}

          {/* Agent Account View */}
          {currentView === 'agent-account' && (
            <>
              {isLoggedIn && (userInfo?.userType === 'agent' || userInfo?.userType === 'individual') ? (
                <div>
                  {/* Agent Account Content */}
                  <AgentAccount 
                    userToken={localStorage.getItem('userToken')} 
                    onLogout={handleLogout}
                  />
                </div>
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#7f8c8d'
                }}>
                  <h3>Acceso Restringido</h3>
                  <p>Debes iniciar sesión como agente para ver esta página.</p>
                  <button
                    onClick={() => {
                      setCurrentView('main');
                      openLoginModal();
                    }}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: '600',
                      marginTop: '20px'
                    }}
                  >
                    Iniciar Sesión
                  </button>
                </div>
              )}
            </>
          )}

          {/* Users View */}
          {currentView === 'users' && (
            <>
              {isLoggedIn && userInfo?.userType === 'Admin' ? (
                <Users onBack={handleNavigateToMetrics} />
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#7f8c8d'
                }}>
                  <h3>Acceso Restringido</h3>
                  <p>Debes iniciar sesión como administrador para ver esta página.</p>
                  <button
                    onClick={() => {
                      setCurrentView('main');
                      openLoginModal();
                    }}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: '600',
                      marginTop: '20px'
                    }}
                  >
                    Iniciar Sesión
                  </button>
                </div>
              )}
            </>
          )}

          {/* Development View */}
          {currentView === 'development' && (
            <div style={{ padding: '20px' }}>
              {isLoggedIn && userInfo?.userType === 'Admin' ? null : (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '20px'
                }}>
                  <h2 style={{
                    fontSize: '24px',
                    fontWeight: '600',
                    color: '#2c3e50',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <MdConstruction size={28} />
                    Análisis de Desarrollo
                  </h2>
                  <button
                    onClick={handleNavigateToMain}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#5a6fd8'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
                  >
                    ← Volver al Tasador
                  </button>
                </div>
              )}
              <DevelopmentAnalysis onClose={() => setCurrentView('main')} />
            </div>
          )}

          {/* Main Content View */}
          {currentView === 'main' && (
            <>
              {/* Valuation Mode */}
              {viewMode === 'valuation' && (
                <>
                  {/* Desktop Step-by-Step System */}
                  {!isMobile && (
                  <div style={{
                    background: 'white',
                    borderRadius: '20px',
                    boxShadow: '0 15px 40px rgba(0,0,0,0.12)',
                    padding: '0',
                    marginBottom: '30px',
                    margin: '0 20px 30px 20px'
                  }}>
                    <div style={{
                      maxWidth: '1200px',
                      margin: '0 auto',
                      padding: '40px'
                    }}>
                    {/* Desktop Progress Indicator */}
                    <div style={{
                      marginBottom: '40px',
                      padding: '20px',
                      background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                      borderRadius: '16px'
                    }}>
                      {/* Step Indicators with Labels */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        position: 'relative',
                        gap: '5px'
                      }}>
                        {[1, 2, 3, 4, 5, 6, 7]
                          .filter(step => {
                            // For cocheras, skip steps 4 and 5
                            if (property === 'cocheras' && (step === 4 || step === 5)) {
                              return false;
                            }
                            return true;
                          })
                          .map((step, index, filteredArray) => {
                            // Calculate display number for cocheras
                            let displayNumber = step;
                            if (property === 'cocheras') {
                              if (step <= 3) displayNumber = step;
                              else if (step === 6) displayNumber = 4;
                              else if (step === 7) displayNumber = 5;
                            }
                            
                            return (
                          <div key={step} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            flex: 1,
                            position: 'relative',
                            zIndex: 2,
                            minWidth: 0
                          }}>
                            <div style={{
                              width: 'clamp(40px, 5vw, 56px)',
                              height: 'clamp(40px, 5vw, 56px)',
                              borderRadius: '50%',
                              background: currentStep >= step 
                                ? (step === 7 ? 'linear-gradient(135deg, #28a745, #20c997)' : 'linear-gradient(135deg, #667eea, #764ba2)')
                                : '#dee2e6',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: '700',
                              fontSize: step === 7 ? 'clamp(1.2rem, 2vw, 1.8rem)' : 'clamp(1rem, 1.8vw, 1.5rem)',
                              boxShadow: currentStep === step ? '0 6px 20px rgba(102, 126, 234, 0.5)' : 'none',
                              transition: 'all 0.4s ease',
                              transform: currentStep === step ? 'scale(1.15)' : 'scale(1)',
                              cursor: currentStep > step ? 'pointer' : 'default',
                              flexShrink: 0
                            }}
                            onClick={() => {
                              if (currentStep > step) {
                                setCurrentStep(step);
                              }
                            }}
                            >
                              {step === 7 ? '🎉' : (currentStep > step ? '✓' : displayNumber)}
                            </div>
                            {/* Connection Line */}
                            {index < filteredArray.length - 1 && (
                              <div style={{
                                position: 'absolute',
                                top: 'clamp(20px, 2.5vw, 28px)',
                                left: 'calc(50% + clamp(20px, 2.5vw, 28px))',
                                width: 'calc(100% - clamp(40px, 5vw, 56px) + 5px)',
                                height: '4px',
                                background: currentStep > step ? 'linear-gradient(90deg, #667eea, #764ba2)' : '#dee2e6',
                                transition: 'background 0.4s ease',
                                zIndex: -1,
                                borderRadius: '2px'
                              }}></div>
                            )}
                          </div>
                        )})}
                      </div>
                      
                      {/* Overall Progress Bar */}
                      <div style={{
                        marginTop: '30px',
                        height: '8px',
                        background: '#dee2e6',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <div style={{
                          height: '100%',
                          background: 'linear-gradient(90deg, #667eea, #764ba2)',
                          width: `${(getDisplayStep() / getDisplayTotalSteps()) * 100}%`,
                          transition: 'width 0.5s ease',
                          borderRadius: '10px',
                          boxShadow: '0 2px 8px rgba(102, 126, 234, 0.4)'
                        }}></div>
                      </div>
                    </div>

                    {/* Step 1: Address/Location Section */}
                    {currentStep === 1 && (
                    <div 
                      className="desktop-step-enter"
                      style={{
                        marginBottom: '30px',
                        minHeight: '500px'
                      }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                  }}>
                    <h2 style={{
                          fontSize: '2rem',
                          fontWeight: '700',
                          marginBottom: '10px',
                          color: '#333',
                          textAlign: 'center'
                        }}>
                          Ubicación Aproximada de la Propiedad
                    </h2>
                    
                    <p style={{
                      fontSize: '0.95rem',
                      color: '#6c757d',
                      textAlign: 'center',
                      marginBottom: '25px',
                      padding: '0 20px'
                    }}>
                      No es necesario ser exacto - podés ingresar solo la zona, barrio o calle sin número
                    </p>
                    
                        {/* Search Input */}
                    <div style={{
                          marginBottom: '25px'
                        }}>
                      {isLoaded && (
                        <Autocomplete 
                          onLoad={onLoadAutocomplete} 
                          onPlaceChanged={handlePlaceChanged}
                        >
                          <div style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <input
                              type="text"
                              placeholder="Ej: Palermo, Av. Corrientes 1000, Belgrano..."
                              value={addressD || ''}
                              autoComplete="off"
                              autoCorrect="off"
                              autoCapitalize="off"
                              spellCheck="false"
                              name="google-places-address-desktop-unique"
                              onChange={(e) => {
                                setAddressD(e.target.value);
                                setIsTypingManually(true);
                                if (addressSelected) {
                                  setAddressSelected(false);
                                  setZone("");
                                }
                              }}
                              onKeyDown={() => {
                                setIsTypingManually(true);
                              }}
                              style={{
                                width: '100%',
                                padding: '18px 24px 18px 55px',
                                borderRadius: '14px',
                                border: '3px solid #e1e5e9',
                                fontSize: '1.1rem',
                                background: 'white',
                                outline: 'none',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 5px 15px rgba(0,0,0,0.12)',
                                cursor: 'text'
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#667eea';
                                e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                                e.target.style.transform = 'translateY(-3px)';
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#e1e5e9';
                                e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.12)';
                                e.target.style.transform = 'translateY(0)';
                              }}
                              onMouseEnter={(e) => {
                                if (document.activeElement !== e.target) {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.2)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (document.activeElement !== e.target) {
                                  e.target.style.borderColor = '#e1e5e9';
                                  e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.12)';
                                }
                              }}
                            />
                            <div style={{
                              position: 'absolute',
                              left: '20px',
                              color: '#667eea',
                              fontSize: '1.4rem',
                              pointerEvents: 'none',
                              display: 'flex',
                              alignItems: 'center'
                            }}>
                              <FaMapMarkerAlt size={20} />
                            </div>
                          </div>
                        </Autocomplete>
                      )}
                      
                      {/* Marketing Features */}
                      <div style={{
                        marginTop: '25px',
                        display: 'flex',
                        gap: '20px',
                        justifyContent: 'center',
                        flexWrap: 'wrap'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px 20px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '24px',
                          color: 'white',
                          fontSize: '1rem',
                          fontWeight: '600',
                          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                          alignItems: 'center'
                        }}>
                          <IoFlash size={22} />
                          <span>Resultados Instantáneos</span>
                    </div>
                    
                    <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px 20px',
                          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                          borderRadius: '24px',
                          color: 'white',
                          fontSize: '1rem',
                          fontWeight: '600',
                          boxShadow: '0 4px 12px rgba(40, 167, 69, 0.4)'
                        }}>
                          <span style={{ fontSize: '1.4rem' }}>✓</span>
                          <span>100% Gratis</span>
                        </div>
                        
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px 20px',
                          background: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)',
                          borderRadius: '24px',
                          color: 'white',
                          fontSize: '1rem',
                          fontWeight: '600',
                          boxShadow: '0 4px 12px rgba(243, 156, 18, 0.4)'
                        }}>
                          <span style={{ fontSize: '1.4rem' }}>🏆</span>
                          <span>Profesional y Confiable</span>
                        </div>
                      </div>
                      
                    </div>
                    
                    {/* Map for Step 1 */}
                    <div style={{
                      height: '450px',
                      borderRadius: '14px',
                      overflow: 'hidden',
                      border: '3px solid #e1e5e9',
                      marginTop: '30px',
                      boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
                    }}>
                      {!isLoaded ? (
                        <div style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#f8f9fa'
                        }}>
                          <RotatingLines width="60" strokeColor="#667eea" />
                        </div>
                      ) : (
                        <GoogleMap
                          mapContainerStyle={{ height: '100%', width: '100%' }}
                          center={marker}
                          zoom={15}
                          onLoad={onLoadMap}
                        >
                          <Marker position={marker} />
                        </GoogleMap>
                      )}
                    </div>
                  </div>
                    </div>
                    )}

                    {/* Step 2: Operation Type */}
                    {currentStep === 2 && (
                    <div className="desktop-step-enter" style={{ marginBottom: '30px', minHeight: '500px' }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <h2 style={{
                          fontSize: '2rem',
                          fontWeight: '700',
                          marginBottom: '25px',
                          color: '#333',
                          textAlign: 'center'
                        }}>
                          Tipo de Valuación
                        </h2>
                        
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gap: '25px',
                          marginTop: '40px'
                        }}>
                        {['venta', 'alquiler'].map((op) => (
                          <button
                            key={op}
                            onClick={() => handleOperationSelect(op)}
                    style={{
                              padding: '40px 30px',
                              background: operation === op 
                                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                                : 'white',
                              color: operation === op ? 'white' : '#333',
                              border: operation === op ? 'none' : '3px solid #e1e5e9',
                              borderRadius: '16px',
                              fontSize: '1.3rem',
                              fontWeight: '700',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: operation === op 
                                ? '0 8px 20px rgba(102, 126, 234, 0.4)' 
                                : '0 3px 10px rgba(0,0,0,0.1)',
                              transform: operation === op ? 'scale(1.05)' : 'scale(1)'
                            }}
                            onMouseEnter={(e) => {
                              if (operation !== op) {
                                e.target.style.borderColor = '#667eea';
                                e.target.style.transform = 'scale(1.03)';
                                e.target.style.boxShadow = '0 6px 15px rgba(102, 126, 234, 0.2)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (operation !== op) {
                                e.target.style.borderColor = '#e1e5e9';
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)';
                              }
                            }}
                          >
                            <div style={{ fontSize: '3rem', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                              {op === 'venta' ? <MdSell size={60} /> : <BsHouseDoor size={60} />}
                            </div>
                            {op === 'venta' ? 'Valor de Venta' : 'Valor de Alquiler'}
                          </button>
                        ))}
                        </div>
                      </div>
                    </div>
                    )}

                    {/* Step 3: Property Type */}
                    {currentStep === 3 && (
                    <div className="desktop-step-enter" style={{ marginBottom: '30px', minHeight: '500px' }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <h2 style={{
                          fontSize: '2rem',
                          fontWeight: '700',
                          marginBottom: '25px',
                          color: '#333',
                          textAlign: 'center'
                        }}>
                          Tipo de Propiedad
                        </h2>
                        
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gap: '25px',
                          marginTop: '40px'
                        }}>
                        {[
                          { value: 'departamento', icon: <FaBuilding size={50} />, label: 'Departamento' },
                          { value: 'casa', icon: <FaHome size={50} />, label: 'Casa' },
                          { value: 'oficina', icon: <FaBriefcase size={50} />, label: 'Oficina' },
                          { value: 'local', icon: <IoStorefrontOutline size={55} />, label: 'Local Comercial' },
                          { value: 'cocheras', icon: <MdDirectionsCar size={55} />, label: 'Cocheras' }
                        ].map((prop) => (
                          <button
                            key={prop.value}
                            onClick={() => handlePropertySelect(prop.value)}
                            style={{
                              padding: '35px 25px',
                              background: property === prop.value 
                                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                                : 'white',
                              color: property === prop.value ? 'white' : '#333',
                              border: property === prop.value ? 'none' : '3px solid #e1e5e9',
                              borderRadius: '16px',
                              fontSize: '1.2rem',
                              fontWeight: '700',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: property === prop.value 
                                ? '0 8px 20px rgba(102, 126, 234, 0.4)' 
                                : '0 3px 10px rgba(0,0,0,0.1)',
                              transform: property === prop.value ? 'scale(1.05)' : 'scale(1)'
                            }}
                            onMouseEnter={(e) => {
                              if (property !== prop.value) {
                                e.target.style.borderColor = '#667eea';
                                e.target.style.transform = 'scale(1.03)';
                                e.target.style.boxShadow = '0 6px 15px rgba(102, 126, 234, 0.2)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (property !== prop.value) {
                                e.target.style.borderColor = '#e1e5e9';
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)';
                              }
                            }}
                          >
                            <div style={{ fontSize: '2.5rem', marginBottom: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {prop.icon}
                            </div>
                            {prop.label}
                          </button>
                        ))}
                        </div>
                      </div>
                    </div>
                    )}

                    {/* Step 4: Valuation Type */}
                    {currentStep === 4 && (
                    <div className="desktop-step-enter" style={{ marginBottom: '30px', minHeight: '500px' }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <h2 style={{
                          fontSize: '2rem',
                          fontWeight: '700',
                          marginBottom: '25px',
                          color: '#333',
                          textAlign: 'center'
                        }}>
                          Tipo de Valuación
                        </h2>
                        
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: property === 'cocheras' ? '1fr' : 'repeat(2, 1fr)',
                          gap: '25px',
                          marginTop: '40px'
                        }}>
                        {[
                          { value: 'simple', label: 'Simple', desc: 'Valuación rápida y precisa' },
                          { value: 'advanced', label: 'Avanzada', desc: 'Valuación detallada con más datos' }
                        ].filter(val => property === 'cocheras' ? val.value === 'simple' : true).map((val) => (
                          <button
                            key={val.value}
                            onClick={() => {
                              handleValuationTypeSelect(val.value);
                              setTimeout(() => goToNextStep(), 600);
                            }}
                            style={{
                              padding: '40px 30px',
                              background: valuationType === val.value 
                                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                                : 'white',
                              color: valuationType === val.value ? 'white' : '#333',
                              border: valuationType === val.value ? 'none' : '3px solid #e1e5e9',
                              borderRadius: '16px',
                              fontSize: '1.3rem',
                              fontWeight: '700',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: valuationType === val.value 
                                ? '0 8px 20px rgba(102, 126, 234, 0.4)' 
                                : '0 3px 10px rgba(0,0,0,0.1)',
                              transform: valuationType === val.value ? 'scale(1.05)' : 'scale(1)'
                            }}
                            onMouseEnter={(e) => {
                              if (valuationType !== val.value) {
                                e.target.style.borderColor = '#667eea';
                                e.target.style.transform = 'scale(1.03)';
                                e.target.style.boxShadow = '0 6px 15px rgba(102, 126, 234, 0.2)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (valuationType !== val.value) {
                                e.target.style.borderColor = '#e1e5e9';
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)';
                              }
                            }}
                          >
                            <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {val.value === 'simple' ? <IoFlash size={50} /> : <MdGpsFixed size={50} />}
                            </div>
                            {val.label}
                            <div style={{ 
                              fontSize: '0.9rem', 
                              fontWeight: '500', 
                              marginTop: '10px',
                              opacity: 0.9
                            }}>
                              {val.desc}
                            </div>
                          </button>
                        ))}
                        </div>
                      </div>
                    </div>
                    )}

                    {/* Step 5: Property Details */}
                    {currentStep === 5 && (
                    <div className="desktop-step-enter" style={{ marginBottom: '30px', minHeight: '500px' }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <h2 style={{
                          fontSize: '2rem',
                          fontWeight: '700',
                          marginBottom: '35px',
                          color: '#2d3748',
                          textAlign: 'center',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                        }}>
                          Detalles de la Propiedad
                        </h2>
                        
                        <div style={{
                          background: 'linear-gradient(135deg, #f8f9ff 0%, #fff5f8 100%)',
                          padding: '35px',
                          borderRadius: '20px',
                          boxShadow: '0 10px 30px rgba(102, 126, 234, 0.1)',
                          border: '1px solid rgba(102, 126, 234, 0.1)'
                        }}>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                          gap: '25px'
                        }}>
                        {valuationType === "simple" ? (
                          <>
                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdMeetingRoom size={20} />
                                Ambientes
                              </label>
                              <select
                                value={amb}
                                onChange={(e) => setAmb(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  background: 'white',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                  cursor: 'pointer'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              >
                                <option value="">Seleccionar</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                              </select>
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdDirectionsCar size={20} />
                                Cochera/s
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={garage}
                                onChange={(e) => handleChange(e, "garage")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdSettings size={20} />
                                Estado
                              </label>
                              <select
                                value={condition}
                                onChange={(e) => setCondition(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  background: 'white',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                  cursor: 'pointer'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              >
                                <option value="Estrenar">Estrenar</option>
                                <option value="Muy bueno">Muy bueno</option>
                                <option value="Bueno">Bueno</option>
                                <option value="Regular">Regular</option>
                                <option value="Malo">Malo</option>
                              </select>
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <IoCalendarOutline size={20} />
                                Antigüedad (años)
                              </label>
                              <input
                                type="number"
                                placeholder="1"
                                value={antiguedad}
                                onChange={(e) => handleChange(e, "antiguedad")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          // Advanced valuation fields
                          <>
                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdMeetingRoom size={20} />
                                Ambientes
                              </label>
                              <input
                                type="number"
                                placeholder="1"
                                value={amb}
                                onChange={(e) => handleChange(e, "amb")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdDirectionsCar size={20} />
                                Cochera/s (cantidad)
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={garage}
                                onChange={(e) => handleChange(e, "garage")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdSquareFoot size={20} />
                                Superficie Cubierta (m²)
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={sc}
                                onChange={(e) => handleChange(e, "sc")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>

                            {/* Superficie Semicubierta - Always show in advanced mode */}
                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <IoHomeOutline size={20} />
                                Superficie Semicubierta (m²)
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={st}
                                onChange={(e) => handleChange(e, "st")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                              <small style={{ fontSize: '0.9rem', color: '#6c757d', marginTop: '6px', display: 'block' }}>
                                Balcones, galerías, espacios cubiertos parcialmente
                              </small>
                            </div>

                            {/* Superficie Descubierta - Always show in advanced mode */}
                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdLandscape size={20} />
                                Superficie Descubierta (m²)
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={sd}
                                onChange={(e) => handleChange(e, "sd")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                              <small style={{ fontSize: '0.9rem', color: '#6c757d', marginTop: '6px', display: 'block' }}>
                                Jardín, patio, terrazas descubiertas
                              </small>
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <MdSettings size={20} />
                                Estado
                              </label>
                              <select
                                value={condition}
                                onChange={(e) => setCondition(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  background: 'white',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                  cursor: 'pointer'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              >
                                <option value="Estrenar">Estrenar</option>
                                <option value="Muy bueno">Muy bueno</option>
                                <option value="Bueno">Bueno</option>
                                <option value="Regular">Regular</option>
                                <option value="Malo">Malo</option>
                              </select>
                            </div>

                            <div>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#4a5568'
                              }}>
                                <IoCalendarOutline size={20} />
                                Antigüedad (años)
                              </label>
                              <input
                                type="number"
                                placeholder="1"
                                value={antiguedad}
                                onChange={(e) => handleChange(e, "antiguedad")}
                                style={{
                                  width: '100%',
                                  padding: '14px',
                                  borderRadius: '12px',
                                  border: '2px solid #e3e8f0',
                                  fontSize: '1.05rem',
                                  transition: 'all 0.3s ease',
                                  background: 'white',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e3e8f0';
                                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                }}
                              />
                            </div>

                            {/* Optional amenities for advanced */}
                            <div style={{ gridColumn: '1 / -1' }}>
                              <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                marginBottom: '15px',
                                color: '#555'
                              }}>
                                <BsStars size={20} />
                                Amenidades (opcional)
                              </label>
                              <div style={{
                                display: 'flex',
                                gap: '20px',
                                flexWrap: 'wrap'
                              }}>
                                <label style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  cursor: 'pointer',
                                  fontSize: '1rem',
                                  padding: '12px 20px',
                                  borderRadius: '12px',
                                  background: barbecue ? 'linear-gradient(135deg, #e8f4fd, #f0e8fd)' : 'white',
                                  border: barbecue ? '2px solid #667eea' : '2px solid #e3e8f0',
                                  transition: 'all 0.3s ease',
                                  boxShadow: barbecue ? '0 4px 12px rgba(102, 126, 234, 0.15)' : '0 2px 8px rgba(0,0,0,0.04)'
                                }}>
                                  <input
                                    type="checkbox"
                                    checked={barbecue}
                                    onChange={(e) => setBarbecue(e.target.checked)}
                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                  />
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <GiBarbecue size={18} />
                                    Parrilla
                                  </span>
                                </label>
                                
                                <label style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  cursor: 'pointer',
                                  fontSize: '1rem',
                                  padding: '12px 20px',
                                  borderRadius: '12px',
                                  background: pool ? 'linear-gradient(135deg, #e8f4fd, #f0e8fd)' : 'white',
                                  border: pool ? '2px solid #667eea' : '2px solid #e3e8f0',
                                  transition: 'all 0.3s ease',
                                  boxShadow: pool ? '0 4px 12px rgba(102, 126, 234, 0.15)' : '0 2px 8px rgba(0,0,0,0.04)'
                                }}>
                                  <input
                                    type="checkbox"
                                    checked={pool}
                                    onChange={(e) => setPool(e.target.checked)}
                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                  />
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <GiPoolTriangle size={18} />
                                    Piscina
                                  </span>
                                </label>
                                
                                <label style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  cursor: 'pointer',
                                  fontSize: '1rem',
                                  padding: '12px 20px',
                                  borderRadius: '12px',
                                  background: sum ? 'linear-gradient(135deg, #e8f4fd, #f0e8fd)' : 'white',
                                  border: sum ? '2px solid #667eea' : '2px solid #e3e8f0',
                                  transition: 'all 0.3s ease',
                                  boxShadow: sum ? '0 4px 12px rgba(102, 126, 234, 0.15)' : '0 2px 8px rgba(0,0,0,0.04)'
                                }}>
                                  <input
                                    type="checkbox"
                                    checked={sum}
                                    onChange={(e) => setSum(e.target.checked)}
                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                  />
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <GiBarbecue size={18} />
                                    Quincho
                                  </span>
                                </label>
                              </div>
                            </div>
                          </>
                        )}
                        </div>
                        </div>
                      </div>
                    </div>
                    )}

                    {/* Step 6: Price Preview & Contact Information */}
                    {requirePhoneNumber && currentStep === 6 && (
                    <div className="desktop-step-enter" style={{ marginBottom: '30px', minHeight: '500px' }}>
                      <div style={{
                        width: '100%',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        {/* Payment Option Selection - Show if enablePayOption is true and no option selected */}
                        {enablePayOption && !selectedPaymentOption && !loadingPreview && (
                          <div style={{ padding: '20px 0', width: '100%' }}>
                            <h2 style={{ 
                              textAlign: 'center', 
                              fontSize: '1.8rem', 
                              color: '#2c3e50', 
                              marginBottom: '10px',
                              fontWeight: '700'
                            }}>
                              Seleccioná tu Opción
                            </h2>
                            <p style={{ 
                              textAlign: 'center', 
                              fontSize: '1rem', 
                              color: '#7f8c8d', 
                              marginBottom: '40px'
                            }}>
                              Elegí la valuación que mejor se adapte a tus necesidades
                            </p>

                            <div style={{ 
                              display: 'grid',
                              gridTemplateColumns: isLoggedIn ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                              gap: '30px',
                              width: '100%',
                              padding: '0 60px'
                            }}>
                              {/* FREE OPTION */}
                              <div 
                                onClick={() => enableFreeValuacion && setSelectedPaymentOption('free')}
                                style={{
                                  width: '100%',
                                  background: enableFreeValuacion ? 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' : 'linear-gradient(135deg, #e9ecef 0%, #d3d3d3 100%)',
                                  border: enableFreeValuacion ? '3px solid #10b981' : '3px solid #cccccc',
                                  borderRadius: '15px',
                                  padding: '30px 20px',
                                  cursor: enableFreeValuacion ? 'pointer' : 'not-allowed',
                                  transition: 'all 0.3s ease',
                                  boxShadow: enableFreeValuacion ? '0 4px 12px rgba(16, 185, 129, 0.2)' : 'none',
                                  position: 'relative',
                                  textAlign: 'center',
                                  opacity: enableFreeValuacion ? 1 : 0.6,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                  if (enableFreeValuacion) {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(16, 185, 129, 0.3)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (enableFreeValuacion) {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.2)';
                                  }
                                }}
                              >
                                <div style={{ fontSize: '3.5rem', marginBottom: '15px', color: '#10b981' }}>
                                  <FaGift />
                                </div>
                                <h3 style={{ 
                                  fontSize: '1.5rem', 
                                  color: '#2c3e50', 
                                  marginBottom: '10px',
                                  fontWeight: '700'
                                }}>
                                  GRATIS
                                </h3>
                                <p style={{ 
                                  fontSize: '0.95rem', 
                                  color: '#7f8c8d', 
                                  marginBottom: '15px'
                                }}>
                                  Valuación básica instantánea
                                </p>
                                
                                {/* Features List */}
                                <div style={{
                                  textAlign: 'left',
                                  marginBottom: '20px',
                                  padding: '15px',
                                  background: 'white',
                                  borderRadius: '8px',
                                  flex: 1
                                }}>
                                  <div style={{ fontSize: '0.85rem', color: '#2c3e50', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#10b981', minWidth: '16px' }}>✓</span>
                                    <span>Requiere número de teléfono</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: '#2c3e50', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#10b981', minWidth: '16px' }}>✓</span>
                                    <span>Valuación básica instantánea</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: '#2c3e50', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#10b981', minWidth: '16px' }}>✓</span>
                                    <span>Resultado en segundos</span>
                                  </div>
                                </div>
                                
                                <div style={{
                                  fontSize: '2rem',
                                  fontWeight: '700',
                                  color: '#10b981',
                                  marginBottom: '20px'
                                }}>
                                  $0
                                </div>
                                <button style={{
                                  width: '100%',
                                  padding: '12px',
                                  background: enableFreeValuacion ? '#10b981' : '#cccccc',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '8px',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  cursor: enableFreeValuacion ? 'pointer' : 'not-allowed'
                                }}>
                                  {enableFreeValuacion ? 'Seleccionar Gratis' : 'No Disponible'}
                                </button>
                                
                                {!enableFreeValuacion && (
                                  <div style={{
                                    marginTop: '15px',
                                    padding: '12px',
                                    background: '#fff3cd',
                                    border: '1px solid #ffc107',
                                    borderRadius: '8px',
                                    fontSize: '0.85rem',
                                    color: '#856404',
                                    lineHeight: '1.4'
                                  }}>
                                    ⚠️ Temporalmente no disponible debido a alta demanda. Podés optar por la opción Premium.
                                  </div>
                                )}
                              </div>

                              {/* REGISTER OPTION - Best Value */}
                              {!isLoggedIn && (
                              <div 
                                onClick={openRegisterModal}
                                style={{
                                  width: '100%',
                                  background: 'linear-gradient(135deg, #ff8c42 0%, #ff6b6b 100%)',
                                  border: '3px solid #ffd700',
                                  borderRadius: '15px',
                                  padding: '30px 20px',
                                  cursor: 'pointer',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 4px 12px rgba(255, 140, 66, 0.3)',
                                  position: 'relative',
                                  textAlign: 'center',
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-8px)';
                                  e.currentTarget.style.boxShadow = '0 12px 32px rgba(255, 140, 66, 0.5)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 140, 66, 0.3)';
                                }}
                              >
                                {/* IDEAL PARA AGENTES INMOBILIARIOS Badge */}
                                <div style={{
                                  position: 'absolute',
                                  top: '-12px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  background: '#2ecc71',
                                  color: 'white',
                                  padding: '8px 20px',
                                  borderRadius: '20px',
                                  fontSize: '0.85rem',
                                  fontWeight: '700',
                                  boxShadow: '0 4px 12px rgba(46, 204, 113, 0.4)',
                                  whiteSpace: 'nowrap'
                                }}>
                                  ⭐ IDEAL PARA AGENTES INMOBILIARIOS
                                </div>

                                <div style={{ fontSize: '3.5rem', marginBottom: '15px', color: '#ffd700' }}>
                                  <FaUserPlus />
                                </div>
                                <h3 style={{ 
                                  fontSize: '1.5rem', 
                                  color: 'white', 
                                  marginBottom: '10px',
                                  fontWeight: '700'
                                }}>
                                  REGISTRARME
                                </h3>
                                <p style={{ 
                                  fontSize: '0.95rem', 
                                  color: 'rgba(255, 255, 255, 0.95)', 
                                  marginBottom: '15px',
                                  fontWeight: '600'
                                }}>
                                  Obtén 2 valuaciones premium GRATIS
                                </p>
                                
                                {/* Features List */}
                                <div style={{
                                  textAlign: 'left',
                                  marginBottom: '15px',
                                  padding: '15px',
                                  background: 'rgba(255, 255, 255, 0.15)',
                                  borderRadius: '8px',
                                  backdropFilter: 'blur(10px)',
                                  flex: 1
                                }}>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px', fontWeight: 'bold' }}>✓</span>
                                    <span><strong>2 créditos premium</strong> al registrarte</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px', fontWeight: 'bold' }}>✓</span>
                                    <span><strong>Historial completo</strong> de valuaciones</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px', fontWeight: 'bold' }}>✓</span>
                                    <span><strong>Acceso a estadísticas</strong> y métricas</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px', fontWeight: 'bold' }}>✓</span>
                                    <span><strong>Panel exclusivo</strong> de agente</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px', fontWeight: 'bold' }}>✓</span>
                                    <span><strong>Sin límite</strong> de valuaciones básicas</span>
                                  </div>
                                </div>

                                <div style={{
                                  fontSize: '1.8rem',
                                  fontWeight: '700',
                                  color: '#ffd700',
                                  marginBottom: '30px'
                                }}>
                                  $0
                                </div>

                                <button style={{
                                  width: '100%',
                                  padding: '12px',
                                  background: '#ffd700',
                                  color: '#2c3e50',
                                  border: 'none',
                                  borderRadius: '8px',
                                  fontSize: '1rem',
                                  fontWeight: '700',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '8px'
                                }}>
                                  <FaUserPlus size={16} />
                                  Registrarse Ahora
                                </button>
                              </div>
                              )}

                              {/* PREMIUM OPTION */}
                              <div 
                                onClick={handlePremiumSelection}
                                style={{
                                  width: '100%',
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  border: '3px solid #ffd700',
                                  borderRadius: '15px',
                                  padding: '30px 20px',
                                  cursor: 'pointer',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                  position: 'relative',
                                  textAlign: 'center',
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-8px)';
                                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(102, 126, 234, 0.5)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                }}
                              >
                                {isAdmin() && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '-12px',
                                    right: '-12px',
                                    background: '#2ecc71',
                                    color: 'white',
                                    padding: '8px 15px',
                                    borderRadius: '20px',
                                    fontSize: '0.85rem',
                                    fontWeight: '700',
                                    boxShadow: '0 4px 12px rgba(46, 204, 113, 0.4)'
                                  }}>
                                    🔑 GRATIS ADMIN
                                  </div>
                                )}
                                {!isAdmin() && !((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) && payOptionDiscountPercent > 0 && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '-12px',
                                    right: '-12px',
                                    background: '#ff4757',
                                    color: 'white',
                                    padding: '8px 15px',
                                    borderRadius: '20px',
                                    fontSize: '0.85rem',
                                    fontWeight: '700',
                                    boxShadow: '0 4px 12px rgba(255, 71, 87, 0.4)'
                                  }}>
                                    -{payOptionDiscountPercent}% OFF
                                  </div>
                                )}
                                <div style={{ fontSize: '3.5rem', marginBottom: '15px', color: '#ffd700' }}>
                                  <RiVipCrownFill />
                                </div>
                                <h3 style={{ 
                                  fontSize: '1.5rem', 
                                  color: 'white', 
                                  marginBottom: '10px',
                                  fontWeight: '700'
                                }}>
                                  PREMIUM
                                </h3>
                                <p style={{ 
                                  fontSize: '0.95rem', 
                                  color: 'rgba(255, 255, 255, 0.9)', 
                                  marginBottom: '15px'
                                }}>
                                  Valuación detallada profesional
                                </p>
                                
                                {/* Features List */}
                                <div style={{
                                  textAlign: 'left',
                                  marginBottom: '15px',
                                  padding: '15px',
                                  background: 'rgba(255, 255, 255, 0.15)',
                                  borderRadius: '8px',
                                  backdropFilter: 'blur(10px)',
                                  flex: 1
                                }}>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span><strong>IA avanzada</strong> con búsqueda en tiempo real</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span>Compara <strong>{operation === 'alquiler' ? '20' : '10'}+ propiedades</strong> del mercado real</span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span>Algoritmo de <strong>martilleros profesionales</strong></span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span><strong>Valuación instantánea</strong></span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span><strong>Sin datos personales requeridos</strong></span>
                                  </div>
                                  <div style={{ fontSize: '0.85rem', color: 'white', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ color: '#ffd700', minWidth: '16px' }}>✓</span>
                                    <span><strong>Asesoramiento personalizado de martillero</strong> si no estás conforme</span>
                                  </div>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                  {isAdmin() ? (
                                    <div style={{
                                      fontSize: '2rem',
                                      fontWeight: '700',
                                      color: '#2ecc71'
                                    }}>
                                      GRATIS
                                    </div>
                                  ) : ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? (
                                    <div style={{
                                      fontSize: '0.9rem',
                                      color: '#2ecc71',
                                      fontWeight: '600'
                                    }}>
                                      💳 {agentCredits} {agentCredits === 1 ? 'crédito disponible' : 'créditos disponibles'}
                                    </div>
                                  ) : payOptionDiscountPercent > 0 ? (
                                    <>
                                      <div style={{
                                        fontSize: '1.2rem',
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        textDecoration: 'line-through',
                                        marginBottom: '5px'
                                      }}>
                                        ${payOptionPrice.toLocaleString('es-AR')}
                                      </div>
                                      <div style={{
                                        fontSize: '2rem',
                                        fontWeight: '700',
                                        color: '#ffd700'
                                      }}>
                                        ${Math.round(payOptionPrice * (1 - payOptionDiscountPercent / 100)).toLocaleString('es-AR')}
                                      </div>
                                      <div style={{
                                        fontSize: '0.9rem',
                                        color: '#ffd700',
                                        fontWeight: '600',
                                        marginTop: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '5px'
                                      }}>
                                        <HiSparkles /> Ahorrás ${Math.round(payOptionPrice * payOptionDiscountPercent / 100).toLocaleString('es-AR')}
                                      </div>
                                    </>
                                  ) : (
                                    <div style={{
                                      fontSize: '2rem',
                                      fontWeight: '700',
                                      color: '#ffd700'
                                    }}>
                                      ${payOptionPrice.toLocaleString('es-AR')}
                                    </div>
                                  )}
                                </div>
                                <button style={{
                                  width: '100%',
                                  padding: '12px',
                                  background: (isAdmin() || ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0)) ? '#2ecc71' : '#ffd700',
                                  color: '#2c3e50',
                                  border: 'none',
                                  borderRadius: '8px',
                                  fontSize: '1rem',
                                  fontWeight: '700',
                                  cursor: 'pointer'
                                }}>
                                  {isAdmin() ? (
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                      <BsStars size={18} /> Ver Valuación Gratis
                                    </span>
                                  ) : ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? (
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                      <BsStars size={18} /> Usar 1 Crédito
                                    </span>
                                  ) : 'Seleccionar Premium'}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Loading State */}
                        {loadingPreview && (
                          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                            <RotatingLines
                              strokeColor="#667eea"
                              strokeWidth="5"
                              animationDuration="0.75"
                              width="96"
                              visible={true}
                            />
                            <p style={{ 
                              marginTop: '20px', 
                              fontSize: '1.2rem', 
                              color: '#667eea',
                              fontWeight: '600'
                            }}>
                              Calculando tu valuación...
                            </p>
                          </div>
                        )}
                        
                        {/* Price Preview + Phone Input - Only show when free is selected */}
                        {!loadingPreview && pricePreview && selectedPaymentOption === 'free' && (
                        <>
                          {/* Address */}
                          <div style={{ 
                            textAlign: 'center', 
                            marginBottom: '20px',
                            fontSize: '1.1rem',
                            color: '#495057',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <FaMapMarkerAlt size={16} />
                            {pricePreview.address}
                          </div>
                          
                          {/* Blurred Price Range */}
                          <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            padding: '30px',
                            borderRadius: '15px',
                            textAlign: 'center',
                            marginBottom: '25px',
                            boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                          }}>
                            <div style={{ 
                              color: 'rgba(255, 255, 255, 0.9)', 
                              fontSize: '0.95rem', 
                              marginBottom: '10px',
                              fontWeight: '600',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}>
                              <MdAttachMoney size={20} />
                              Valor Estimado de {pricePreview.operation === 'venta' ? 'Venta' : 'Alquiler'}
                            </div>
                            <div style={{ 
                              color: 'white', 
                              fontSize: '2.2rem', 
                              fontWeight: '700',
                              textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}>
                              <span>U$</span>
                              <span style={{ filter: 'blur(6px)', userSelect: 'none', letterSpacing: '2px' }}>XXXXXX</span>
                              <span>-</span>
                              <span>U$</span>
                              <span style={{ filter: 'blur(6px)', userSelect: 'none', letterSpacing: '2px' }}>XXXXXXX</span>
                            </div>
                            <button 
                              onClick={() => {
                                document.getElementById('phone-input-desktop')?.scrollIntoView({ 
                                  behavior: 'smooth', 
                                  block: 'center' 
                                });
                                document.getElementById('phone-input-desktop')?.focus();
                              }}
                              style={{
                                marginTop: '15px',
                                fontSize: '1rem',
                                color: 'white',
                                fontWeight: '600',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: '2px solid rgba(255, 255, 255, 0.5)',
                                borderRadius: '25px',
                                padding: '10px 25px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                                e.target.style.transform = 'scale(1.05)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                e.target.style.transform = 'scale(1)';
                              }}
                            >
                              🔓 Ver resultado
                            </button>
                          </div>
                        </>
                        )}
                        
                        {/* Phone Input Section - Show when free is selected or pay option is disabled */}
                        {!loadingPreview && (!enablePayOption || selectedPaymentOption === 'free') && (
                        <>
                        {!isLoggedIn ? (
                          <div style={{
                            maxWidth: '500px',
                            margin: '0 auto'
                          }}>
                            {/* Phone Number Input */}
                            <div style={{
                              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                              padding: '30px',
                              borderRadius: '12px',
                              border: '3px solid #4A90E2',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 4px 12px rgba(74, 144, 226, 0.2)'
                            }}>
                              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <div style={{ 
                                  fontSize: '2.5rem', 
                                  marginBottom: '10px'
                                }}>
                                  📱
                                </div>
                                <div style={{
                                  display: 'inline-block',
                                  padding: '6px 16px',
                                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                  borderRadius: '20px',
                                  boxShadow: '0 3px 10px rgba(16, 185, 129, 0.3)'
                                }}>
                                  <span style={{ 
                                    fontSize: '0.9rem', 
                                    fontWeight: '700', 
                                    color: '#ffffff'
                                  }}>
                                    🎁 100% GRATIS
                                  </span>
                                </div>
                              </div>

                              {/* Upgrade to Premium button - Desktop */}
                              {enablePayOption && (
                                <div style={{ textAlign: 'center', marginTop: '15px', marginBottom: '15px' }}>
                                  <button
                                    onClick={handlePremiumSelection}
                                    style={{
                                      padding: '10px 25px',
                                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '8px',
                                      fontSize: '0.9rem',
                                      fontWeight: '600',
                                      cursor: 'pointer',
                                      transition: 'all 0.3s ease',
                                      boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.transform = 'translateY(-2px)';
                                      e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.transform = 'translateY(0)';
                                      e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                    }}
                                  >
                                    <RiVipCrownFill style={{ marginRight: '8px' }} /> Valuación Premium
                                  </button>
                                </div>
                              )}
                                
                              <div style={{
                                  background: 'white',
                                  padding: '20px',
                                  borderRadius: '10px',
                                  border: '3px solid #4A90E2'
                                }}>
                                  <label style={{
                                    display: 'block',
                                    fontSize: '0.85rem',
                                    fontWeight: '600',
                                    color: '#495057',
                                    marginBottom: '10px',
                                    textAlign: 'center'
                                  }}>
                                    Ingresá tu número de WhatsApp
                                  </label>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '2px solid #dee2e6',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    transition: 'all 0.3s ease',
                                    background: 'white'
                                  }}>
                                    <span style={{
                                      padding: '16px 12px',
                                      background: '#f8f9fa',
                                      fontSize: '1.05rem',
                                      fontWeight: '600',
                                      color: '#495057',
                                      borderRight: '2px solid #dee2e6'
                                    }}>
                                      +54
                                    </span>
                                    <input
                                      id="phone-input-desktop"
                                      type="tel"
                                      placeholder="11 2345 6789"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        flex: 1,
                                        padding: '16px',
                                        border: 'none',
                                        fontSize: '1.05rem',
                                        fontWeight: '500',
                                        outline: 'none',
                                        background: 'transparent'
                                      }}
                                    />
                                  </div>
                                  
                                  {/* WhatsApp Status Indicator */}
                                  {whatsappStatus && (
                                    <div style={{
                                      marginTop: '15px',
                                      padding: '12px 15px',
                                      borderRadius: '8px',
                                      border: '2px solid',
                                      borderColor: whatsappStatus === 'valid' ? '#4caf50' : whatsappStatus === 'invalid' ? '#f44336' : '#ff9800',
                                      background: whatsappStatus === 'valid' ? '#e8f5e9' : whatsappStatus === 'invalid' ? '#ffebee' : '#fff3e0',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px',
                                      transition: 'all 0.3s ease'
                                    }}>
                                      <span style={{ fontSize: '1.3rem', flexShrink: 0 }}>
                                        {whatsappStatus === 'checking' ? '⏳' : whatsappStatus === 'valid' ? '✅' : '❌'}
                                      </span>
                                      <div style={{ flex: 1 }}>
                                        <p style={{
                                          margin: 0,
                                          fontSize: '0.9rem',
                                          fontWeight: '600',
                                          color: whatsappStatus === 'valid' ? '#2e7d32' : whatsappStatus === 'invalid' ? '#c62828' : '#f57c00'
                                        }}>
                                          {whatsappMessage}
                                        </p>
                                        {whatsappStatus === 'invalid' && (
                                          <p style={{
                                            margin: '5px 0 0 0',
                                            fontSize: '0.8rem',
                                            color: '#c62828'
                                          }}>
                                            Por favor ingresá un número con WhatsApp activo
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                                    
                                    {/* Link to Inmobiliaria Registration */}
                                    <div style={{ 
                                      textAlign: 'center', 
                                      marginTop: '20px',
                                      paddingTop: '15px',
                                      borderTop: '1px solid #e9ecef'
                                    }}>
                                      <button
                                        onClick={() => {
                                          setLoginMode('register');
                                          setRegisterForm({ ...registerForm, userType: 'agent' });
                                          setShowLoginModal(true);
                                        }}
                                        style={{ 
                                          fontSize: '0.95rem',
                                          color: '#667eea',
                                          textDecoration: 'none',
                                          fontWeight: '500',
                                          transition: 'all 0.2s ease',
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          padding: 0
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.color = '#764ba2';
                                          e.target.style.textDecoration = 'underline';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.color = '#667eea';
                                          e.target.style.textDecoration = 'none';
                                        }}
                                      >
                                        ¿Sos agente inmobiliario? Registrate acá
                                      </button>
                                    </div>
                          </div>
                        ) : (
                          <>
                            {/* Already logged in - show agent info or phone field */}
                            <h2 style={{
                              fontSize: '2rem',
                              fontWeight: '700',
                              marginBottom: '25px',
                              color: '#333',
                              textAlign: 'center'
                            }}>
                              ¿Quién realizará la valuación?
                            </h2>
                            
                            {(userInfo?.userType === 'agent' || userInfo?.userType === 'individual') ? (
                              <div style={{
                                background: '#d4edda',
                                padding: '25px',
                                borderRadius: '12px',
                                marginBottom: '25px',
                                border: '2px solid #c3e6cb',
                                textAlign: 'center'
                              }}>
                                <div style={{ fontSize: '3rem', marginBottom: '15px' }}>✅</div>
                                <p style={{
                                  fontSize: '1.3rem',
                                  color: '#155724',
                                  margin: 0,
                                  fontWeight: '700'
                                }}>
                                  Sesión iniciada como agente
                                </p>
                                <p style={{
                                  fontSize: '1rem',
                                  color: '#155724',
                                  margin: '8px 0 0 0',
                                  fontWeight: '600'
                                }}>
                                  {userInfo.name || userInfo.email}
                                </p>
                                <p style={{
                                  fontSize: '0.9rem',
                                  color: '#155724',
                                  margin: '12px 0 0 0',
                                  opacity: 0.8
                                }}>
                                  Esta valuación se guardará en tu cuenta
                                </p>
                              </div>
                            ) : (
                              <div>
                                <div style={{ marginBottom: '25px' }}>
                                  <label style={{
                                    display: 'block',
                                    fontSize: '1.1rem',
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                    color: '#555'
                                  }}>
                                    Teléfono
                                  </label>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '2px solid #ddd',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    transition: 'all 0.3s ease',
                                    background: 'white'
                                  }}>
                                    <span style={{
                                      padding: '16px 12px',
                                      background: '#f8f9fa',
                                      fontSize: '1.05rem',
                                      fontWeight: '600',
                                      color: '#495057',
                                      borderRight: '2px solid #ddd'
                                    }}>
                                      +54
                                    </span>
                                    <input
                                      type="tel"
                                      placeholder="11 2345 6789"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        flex: 1,
                                        padding: '16px',
                                        border: 'none',
                                        fontSize: '1.05rem',
                                        outline: 'none',
                                        background: 'transparent'
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* Email hidden - but keep state */}
                        <div style={{ display: 'none' }}>
                          <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>

                        {/* Terms & Conditions Checkbox - Only for non-logged-in or non-agent users */}
                        {(!isLoggedIn || userInfo?.userType !== 'agent') && (
                        <div 
                          id="terms-checkbox-desktop"
                          style={{ 
                            marginTop: '30px', 
                            textAlign: 'center',
                            maxWidth: '600px',
                            margin: '30px auto 0',
                            animation: showTermsError ? 'shake 0.5s' : 'none'
                          }}
                        >
                          <label style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            gap: '10px',
                            fontSize: '0.8rem',
                            color: '#6c757d',
                            cursor: 'pointer',
                            padding: '12px 15px',
                            background: showTermsError ? '#fff3cd' : '#f8f9fa',
                            border: `2px solid ${showTermsError ? '#ffc107' : acceptedTerms ? '#667eea' : '#dee2e6'}`,
                            borderRadius: '8px',
                            fontWeight: '400',
                            transition: 'all 0.3s ease',
                            textAlign: 'left',
                            lineHeight: '1.5'
                          }}
                          onMouseEnter={(e) => {
                            if (!showTermsError) {
                              e.currentTarget.style.borderColor = '#667eea';
                              e.currentTarget.style.background = '#f0f2ff';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!showTermsError) {
                              e.currentTarget.style.borderColor = acceptedTerms ? '#667eea' : '#dee2e6';
                              e.currentTarget.style.background = '#f8f9fa';
                            }
                          }}
                          >
                            <input
                              type="checkbox"
                              checked={acceptedTerms}
                              onChange={(e) => {
                                setAcceptedTerms(e.target.checked);
                                if (e.target.checked) setShowTermsError(false);
                              }}
                              style={{
                                width: '16px',
                                height: '16px',
                                cursor: 'pointer',
                                marginTop: '1px',
                                flexShrink: 0,
                                accentColor: '#667eea'
                              }}
                            />
                            <span>
                              Acepto los{' '}
                              <a 
                                href="/terminos-y-condiciones" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#667eea', 
                                  fontWeight: '600',
                                  textDecoration: 'none',
                                  borderBottom: '1px solid #667eea'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.color = '#764ba2';
                                  e.target.style.borderBottomColor = '#764ba2';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.color = '#667eea';
                                  e.target.style.borderBottomColor = '#667eea';
                                }}
                              >
                                Términos y Condiciones
                              </a>
                              {' '}y la{' '}
                              <a 
                                href="/politica-de-privacidad" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#667eea', 
                                  fontWeight: '600',
                                  textDecoration: 'none',
                                  borderBottom: '1px solid #667eea'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.color = '#764ba2';
                                  e.target.style.borderBottomColor = '#764ba2';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.color = '#667eea';
                                  e.target.style.borderBottomColor = '#667eea';
                                }}
                              >
                                Política de Privacidad
                              </a>. Entiendo que mi número será utilizado para contactarme con fines comerciales.
                            </span>
                          </label>
                          
                          {/* Error message */}
                          {showTermsError && (
                            <div style={{
                              marginTop: '10px',
                              padding: '10px 15px',
                              background: '#fff3cd',
                              border: '2px solid #ffc107',
                              borderRadius: '8px',
                              color: '#856404',
                              fontSize: '0.85rem',
                              fontWeight: '600',
                              textAlign: 'center',
                              animation: 'fadeIn 0.3s ease-in'
                            }}>
                              ⚠️ Debes aceptar los términos y condiciones para continuar
                            </div>
                          )}
                        </div>
                        )}

                        {/* Development Mode: Send Email Checkbox */}
                        {isDevelopment && (
                          <div style={{ marginTop: '15px', textAlign: 'center' }}>
                            <label style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px',
                              fontSize: '0.95rem',
                              color: '#6c757d',
                              cursor: 'pointer',
                              padding: '12px',
                              background: '#fff3cd',
                              border: '2px solid #ffc107',
                              borderRadius: '8px',
                              fontWeight: '500'
                            }}>
                              <input
                                type="checkbox"
                                checked={sendEmail}
                                onChange={(e) => setSendEmail(e.target.checked)}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  cursor: 'pointer'
                                }}
                              />
                              <span>📧 Enviar email (Dev Mode)</span>
                            </label>
                          </div>
                        )}

                        {/* Valuar Button */}
                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                          <button
                            onClick={(e) => {
                              // For logged-in agents, terms were accepted during registration
                              const needsTermsAcceptance = !isLoggedIn || userInfo?.userType !== 'agent';
                              
                              if (needsTermsAcceptance && !acceptedTerms) {
                                e.preventDefault();
                                setShowTermsError(true);
                                // Scroll to checkbox
                                document.getElementById('terms-checkbox-desktop')?.scrollIntoView({ 
                                  behavior: 'smooth', 
                                  block: 'center' 
                                });
                                // Clear error after 3 seconds
                                setTimeout(() => setShowTermsError(false), 3000);
                              } else {
                                get_price(e);
                              }
                            }}
                            disabled={!canProceedToNextStep() || loadingPrice}
                            style={{
                              padding: '18px 50px',
                              background: (() => {
                                const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                                const canSubmit = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                                return canSubmit ? 'linear-gradient(135deg, #667eea, #764ba2)' : '#a0a0a0';
                              })(),
                              color: 'white',
                              border: (() => {
                                const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                                const canSubmit = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                                return canSubmit ? 'none' : '3px solid #5cb85c';
                              })(),
                              borderRadius: '14px',
                              fontSize: '1.2rem',
                              fontWeight: '700',
                              cursor: (() => {
                                const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                                const canSubmit = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                                return canSubmit ? 'pointer' : 'not-allowed';
                              })(),
                              transition: 'all 0.3s ease',
                              boxShadow: (() => {
                                const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                                const canSubmit = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                                return canSubmit ? '0 6px 20px rgba(102, 126, 234, 0.4)' : '0 4px 15px rgba(0, 0, 0, 0.2)';
                              })(),
                              opacity: 1,
                              minWidth: '280px'
                            }}
                            onMouseEnter={(e) => {
                              const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                              const canHover = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                              if (canHover) {
                                e.target.style.transform = 'translateY(-3px)';
                                e.target.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.5)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                              const canHover = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                              if (canHover) {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                              }
                            }}
                          >
                            {loadingPrice ? (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                <RotatingLines width="24" strokeColor="white" />
                                <span>Procesando...</span>
                              </div>
                            ) : (
                              <>
                                {(() => {
                                  const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                                  const isActive = canProceedToNextStep() && !loadingPrice && (needsTerms ? acceptedTerms : true);
                                  return isActive ? '🔓' : '🔒';
                                })()} Ver Valuación
                              </>
                            )}
                          </button>
                          
                          {/* Loading info message */}
                          {loadingPrice && (
                            <div style={{
                              marginTop: '20px',
                              padding: '15px 20px',
                              background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                              borderRadius: '12px',
                              fontSize: '0.95rem',
                              color: '#6c757d',
                              animation: 'fadeIn 0.3s ease-in'
                            }}>
                              ⏳ Estamos calculando el valor de tu propiedad...
                            </div>
                          )}
                        </div>
                        </>
                        )}

                        {/* Premium Payment Section - Show when premium is selected (not admin) */}
                        {!loadingPreview && enablePayOption && selectedPaymentOption === 'premium' && !isAdmin() && (
                          <div style={{ padding: '20px 0' }}>
                            {/* Back to selection button */}
                            <button
                              onClick={() => setSelectedPaymentOption(null)}
                              style={{
                                marginBottom: '20px',
                                padding: '10px 20px',
                                background: 'transparent',
                                color: '#667eea',
                                border: '2px solid #667eea',
                                borderRadius: '8px',
                                fontSize: '0.9rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = '#667eea';
                                e.target.style.color = 'white';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = 'transparent';
                                e.target.style.color = '#667eea';
                              }}
                            >
                              ← Volver a opciones
                            </button>

                            <h2 style={{ 
                              textAlign: 'center', 
                              fontSize: '1.8rem', 
                              color: '#2c3e50', 
                              marginBottom: '30px',
                              fontWeight: '700',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px'
                            }}>
                              <RiVipCrownFill style={{ color: '#ffd700', fontSize: '2rem' }} /> Valuación Premium
                            </h2>

                            {/* MercadoPago Payment Component */}
                            <MercadoPagoPayment
                              title="Valuación Premium - TasacionesYa"
                              price={Math.round(payOptionPrice * (1 - payOptionDiscountPercent / 100))}
                              originalPrice={payOptionPrice}
                              discountPercent={((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? 0 : payOptionDiscountPercent}
                              description={`Valuación detallada profesional para ${addressD || 'tu propiedad'}`}
                              userEmail={email}
                              smp={addressD}
                              paymentType="premium_valuation"
                              propertyData={{
                                address: marker,
                                addressD: addressD,
                                zone_c: zone,
                                operation: operation,
                                property: property,
                                amb: amb,
                                garage: garage || '0',
                                sc: sc,
                                st: st || '0',
                                sd: sd || '0',
                                sterre: sterre || '0',
                                condition: condition,
                                antiguedad: antiguedad || '1',
                                valuationType: valuationType,
                                barbecue: barbecue,
                                pool: pool,
                                sum: sum
                              }}
                              onPaymentSuccess={(paymentData) => {
                                console.log('✅ Payment successful - proceeding to valuation');
                                
                                // Check if this is a free payment (100% promo code discount)
                                if (paymentData?.isFree && paymentData?.valuationResults) {
                                  console.log('🎉 Free payment with promo code - showing results immediately');
                                  console.log('📊 Valuation results:', paymentData.valuationResults);
                                  
                                  // Store premium results
                                  const results = paymentData.valuationResults;
                                  setPremiumResults(results);
                                  localStorage.setItem('premium_valuation_results', JSON.stringify(results));
                                  localStorage.setItem('premium_payment_success', 'true');
                                  
                                  // Set basic price results for display
                                  if (results.isRent && results.preciosARS && results.preciosUSD) {
                                    // Rent valuation - set both currencies
                                    setRentData({
                                      preciosARS: results.preciosARS,
                                      preciosUSD: results.preciosUSD
                                    });
                                  } else {
                                    // Sale valuation - set USD prices
                                    setValorPropUno(results.valorMinimo || 0);
                                    setValorPropDos(results.valorMaximo || 0);
                                  }
                                  
                                  // Mark that we got the price and show results
                                  setGotPrice(true);
                                  setShowResult(true);
                                  setResultExists(true);
                                  
                                  // Stop loading and go to results step
                                  setLoadingPreview(false);
                                  setLoadingPrice(false);
                                  setCurrentStep(7);
                                  
                                  console.log('✅ Results displayed - currentStep set to 7');
                                } else {
                                  // Regular paid flow - wait for MercadoPago return
                                  get_price();
                                }
                              }}
                              onPaymentError={(error) => {
                                console.error('❌ Payment error:', error);
                                alert('Error al procesar el pago. Por favor intentá de nuevo.');
                              }}
                            />

                            {/* Discount information box */}
                            {payOptionDiscountPercent > 0 && (
                              <div style={{
                                marginTop: '20px',
                                padding: '15px',
                                background: '#e8f5e9',
                                border: '2px solid #10b981',
                                borderRadius: '10px',
                                textAlign: 'center'
                              }}>
                                <div style={{ 
                                  fontSize: '1.1rem', 
                                  color: '#10b981', 
                                  fontWeight: '700',
                                  marginBottom: '5px'
                                }}>
                                  🎉 ¡Precio especial con {payOptionDiscountPercent}% de descuento!
                                </div>
                                <div style={{ fontSize: '0.9rem', color: '#2c3e50' }}>
                                  Precio normal: <span style={{ textDecoration: 'line-through' }}>${payOptionPrice.toLocaleString('es-AR')}</span>
                                  {' '}→ Ahorrás: <strong style={{ color: '#10b981' }}>${Math.round(payOptionPrice * payOptionDiscountPercent / 100).toLocaleString('es-AR')}</strong>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    )}

                    {/* Step 7: Results - Will be shown by the results section below */}
                    {currentStep === 7 && !showResult && (
                    <div className="desktop-step-enter" style={{ 
                      marginBottom: '30px',
                      minHeight: '500px',
                      textAlign: 'center',
                      padding: '60px 20px'
                    }}>
                      <div style={{
                        width: '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <div style={{
                          marginBottom: '30px',
                          display: 'flex',
                          justifyContent: 'center'
                        }}>
                          <RotatingLines width="80" strokeColor="#667eea" />
                        </div>
                      <h2 style={{
                        fontSize: '2rem',
                        fontWeight: '700',
                        color: '#333',
                        marginBottom: '15px'
                      }}>
                        Calculando Valuación
                      </h2>
                      <p style={{
                        fontSize: '1.1rem',
                        color: '#6c757d',
                        marginBottom: '10px'
                      }}>
                        Estamos analizando los datos de tu propiedad
                      </p>
                      <p style={{
                        fontSize: '0.95rem',
                        color: '#adb5bd'
                      }}>
                        Esto puede tomar unos segundos...
                      </p>
                      </div>
                    </div>
                    )}

                    {/* Navigation Buttons */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: '40px',
                      gap: '20px'
                    }}>
                      {currentStep > 1 && currentStep < 7 && (
                        <button
                          onClick={goToPreviousStep}
                          style={{
                            padding: '16px 32px',
                            background: 'white',
                            color: '#667eea',
                            border: '3px solid #667eea',
                            borderRadius: '12px',
                            fontSize: '1.1rem',
                            fontWeight: '700',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 3px 10px rgba(0,0,0,0.1)'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = '#667eea';
                            e.target.style.color = 'white';
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 15px rgba(102, 126, 234, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = 'white';
                            e.target.style.color = '#667eea';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)';
                          }}
                        >
                          ← Anterior
                        </button>
                      )}
                      
                      {currentStep < 6 && (
                        <button
                          onClick={goToNextStep}
                          disabled={!canProceedToNextStep()}
                          style={{
                            padding: '16px 32px',
                            background: canProceedToNextStep() 
                              ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                              : '#dee2e6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '1.1rem',
                            fontWeight: '700',
                            cursor: canProceedToNextStep() ? 'pointer' : 'not-allowed',
                            transition: 'all 0.3s ease',
                            boxShadow: canProceedToNextStep() 
                              ? '0 5px 15px rgba(102, 126, 234, 0.4)' 
                              : 'none',
                            marginLeft: 'auto',
                            opacity: canProceedToNextStep() ? 1 : 0.6
                          }}
                          onMouseEnter={(e) => {
                            if (canProceedToNextStep()) {
                              e.target.style.transform = 'translateY(-2px)';
                              e.target.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.5)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (canProceedToNextStep()) {
                              e.target.style.transform = 'translateY(0)';
                              e.target.style.boxShadow = '0 5px 15px rgba(102, 126, 234, 0.4)';
                            }
                          }}
                        >
                          Siguiente →
                        </button>
                      )}
                    </div>
                  </div>
                  </div>
                  )}

                  {/* Valuation Form - Show ONLY on mobile */}
                  {isMobile && (
                  <div 
                    data-section="detalles"
                    style={{
                      background: 'white',
                      borderRadius: isMobile ? '0' : '16px',
                      boxShadow: isMobile ? 'none' : '0 10px 30px rgba(0,0,0,0.1)',
                      padding: isMobile ? '20px 15px' : '30px',
                      marginBottom: isMobile ? '0' : '30px'
                    }}
                  >
                    {/* Hide heading on mobile */}
                    {!isMobile && (
                      <h2 style={{
                        fontSize: '1.8rem',
                        fontWeight: '600',
                        marginBottom: '30px',
                        color: '#333',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px'
                      }}>
                        <IoHomeOutline size={32} />
                        Detalles de la Propiedad
                      </h2>
                    )}

                    {/* Mobile Progress Indicator */}
                    {isMobile && (
                    <div style={{
                        marginBottom: '30px',
                        padding: '20px',
                        background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                        borderRadius: '12px'
                      }}>
                        {/* Step Indicators */}
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '15px'
                        }}>
                          {[1, 2, 3, 4, 5, 6, 7]
                            .filter(step => {
                              // For cocheras, skip steps 4 and 5
                              if (property === 'cocheras' && (step === 4 || step === 5)) {
                                return false;
                              }
                              return true;
                            })
                            .map((step, index, filteredArray) => {
                              // Calculate display number for cocheras
                              let displayNumber = step;
                              if (property === 'cocheras') {
                                if (step <= 3) displayNumber = step;
                                else if (step === 6) displayNumber = 4;
                                else if (step === 7) displayNumber = 5;
                              }
                              
                              return (
                            <div key={step} style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              flex: 1
                            }}>
                              <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: currentStep >= step 
                                  ? (step === 7 ? 'linear-gradient(135deg, #28a745, #20c997)' : 'linear-gradient(135deg, #667eea, #764ba2)')
                                  : '#dee2e6',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: '700',
                                fontSize: step === 7 ? '1.3rem' : '1.1rem',
                                boxShadow: currentStep === step ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none',
                                transition: 'all 0.3s ease'
                              }}>
                                {step === 7 ? '🎉' : (currentStep > step ? '✓' : displayNumber)}
                              </div>
                              {index < filteredArray.length - 1 && (
                                <div style={{
                                  position: 'absolute',
                                  width: `${100 / filteredArray.length}%`,
                                  height: '2px',
                                  background: currentStep > step ? '#667eea' : '#dee2e6',
                                  top: '20px',
                                  left: `${(index) * (100 / filteredArray.length) + (50 / filteredArray.length)}%`,
                                  transform: 'translateY(0)',
                                  transition: 'background 0.3s ease',
                                  zIndex: -1
                                }}></div>
                              )}
                            </div>
                          )})}
                        </div>
                        
                        {/* Step Title */}
                        <div style={{
                          textAlign: 'center',
                          fontSize: '1rem',
                          fontWeight: '600',
                          color: '#495057',
                          marginTop: '15px'
                        }}>
                          {currentStep === 1 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <IoLocationSharp size={18} /> Ubicación Aproximada
                            </span>
                          )}
                          {currentStep === 2 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <IoBriefcaseOutline size={18} /> Tipo de Valuación
                            </span>
                          )}
                          {currentStep === 3 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <IoBusinessOutline size={18} /> Tipo de Propiedad
                            </span>
                          )}
                          {currentStep === 4 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <MdConstruction size={18} /> Tipo de Valuación
                            </span>
                          )}
                          {currentStep === 5 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <BsRulers size={18} /> Detalles de la Propiedad
                            </span>
                          )}
                          {currentStep === 6 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <MdPerson size={18} /> ¿Quién realizará la valuación?
                            </span>
                          )}
                          {currentStep === 7 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                              <BsStars size={18} /> Resultado de la Valuación
                            </span>
                          )}
                        </div>
                        
                        {/* Progress Bar */}
                        <div style={{
                          marginTop: '15px',
                          height: '6px',
                          background: '#dee2e6',
                          borderRadius: '10px',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            height: '100%',
                            background: 'linear-gradient(90deg, #667eea, #764ba2)',
                            width: `${(getDisplayStep() / getDisplayTotalSteps()) * 100}%`,
                            transition: 'width 0.4s ease',
                            borderRadius: '10px'
                          }}></div>
                        </div>
                      </div>
                    )}

                    {/* Address Section - Step 1 for mobile only */}
                    {(isMobile && currentStep === 1) && (
                    <div 
                      className="mobile-step-enter"
                      style={{
                      marginBottom: '30px'
                    }}>
                      <p style={{
                        fontSize: '0.9rem',
                        color: '#6c757d',
                        textAlign: 'center',
                        marginBottom: '20px',
                        padding: '0 15px',
                        lineHeight: '1.5'
                      }}>
                        No es necesario ser exacto<br/>
                        Podés ingresar solo la zona o barrio
                      </p>
                      {isLoaded && (
                        <Autocomplete 
                          onLoad={onLoadAutocomplete} 
                          onPlaceChanged={handlePlaceChanged}
                        >
                          <div style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <input
                              type="text"
                              placeholder="Ej: Palermo, Belgrano, Recoleta..."
                              value={addressD || ''}
                              autoComplete="off"
                              autoCorrect="off"
                              autoCapitalize="off"
                              spellCheck="false"
                              name="google-places-address-unique-12345"
                              onChange={(e) => {
                                setAddressD(e.target.value);
                                setIsTypingManually(true);
                                if (addressSelected) {
                                  setAddressSelected(false);
                                  setZone("");
                                }
                              }}
                              onKeyDown={() => {
                                setIsTypingManually(true);
                              }}
                              style={{
                                width: '100%',
                                padding: '16px 20px 16px 50px',
                                borderRadius: '12px',
                                border: '2px solid #e1e5e9',
                                fontSize: '1rem',
                                background: 'white',
                                outline: 'none',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                cursor: 'text'
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#667eea';
                                e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.25)';
                                e.target.style.transform = 'translateY(-2px)';
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#e1e5e9';
                                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                e.target.style.transform = 'translateY(0)';
                              }}
                              onMouseEnter={(e) => {
                                if (document.activeElement !== e.target) {
                                  e.target.style.borderColor = '#667eea';
                                  e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.15)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (document.activeElement !== e.target) {
                                  e.target.style.borderColor = '#e1e5e9';
                                  e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                }
                              }}
                            />
                            <div style={{
                              position: 'absolute',
                              left: '16px',
                              color: '#667eea',
                              fontSize: '1.2rem',
                              pointerEvents: 'none',
                              display: 'flex',
                              alignItems: 'center'
                            }}>
                              <FaMapMarkerAlt size={18} />
                            </div>
                          </div>
                        </Autocomplete>
                      )}
                      
                      {/* Marketing Features - Only show on mobile */}
                      {isMobile && (
                      <div style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '8px 12px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '20px',
                          color: 'white',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                          alignItems: 'center'
                        }}>
                          <IoFlash size={18} />
                          <span>Resultados Instantáneos</span>
                        </div>
                        
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '8px 12px',
                          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                          borderRadius: '20px',
                          color: 'white',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
                        }}>
                          <span style={{ fontSize: '1.2rem' }}>✓</span>
                          <span>100% Gratis</span>
                        </div>
                        
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '8px 12px',
                          background: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)',
                          borderRadius: '20px',
                          color: 'white',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          boxShadow: '0 2px 8px rgba(243, 156, 18, 0.3)'
                        }}>
                          <span style={{ fontSize: '1.2rem' }}>🏆</span>
                          <span>Profesional y Confiable</span>
                        </div>
                      </div>
                      )}
                    </div>
                    )}

                    {/* Operation & Property Type Container - Desktop shows both, Mobile shows separately */}
                    <div style={{
                      display: isMobile ? 'block' : 'grid',
                      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
                      gap: isMobile ? '0' : '20px',
                      marginBottom: '30px'
                    }}>
                      {/* Operation Type - Step 2 for mobile, always show for desktop */}
                      {(!isMobile || currentStep === 2) && (
                      <div 
                        className={isMobile ? 'mobile-step-enter' : ''}
                        style={{
                          marginBottom: isMobile ? '30px' : '0'
                      }}>
                        <label style={{
                          display: 'block',
                          fontSize: '1rem',
                          fontWeight: '600',
                          marginBottom: '10px',
                          color: '#555'
                        }}>
                          Tipo de Valuación
                        </label>
                        <div style={{
                          display: 'flex',
                          gap: '10px'
                        }}>
                          <button
                            onClick={() => handleOperationSelect('venta')}
                            style={{
                              flex: 1,
                              padding: '12px 15px',
                              borderRadius: '8px',
                              border: 'none',
                              background: operation === 'venta' ? '#667eea' : '#f8f9fa',
                              color: operation === 'venta' ? 'white' : '#555',
                              fontWeight: '600',
                              fontSize: '0.9rem',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: operation === 'venta' ? '0 4px 6px rgba(102, 126, 234, 0.4)' : 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                          >
                            <MdSell size={18} />
                            Valor de Venta
                          </button>
                          <button
                            onClick={() => handleOperationSelect('alquiler')}
                            style={{
                              flex: 1,
                              padding: '12px 15px',
                              borderRadius: '8px',
                              border: 'none',
                              background: operation === 'alquiler' ? '#667eea' : '#f8f9fa',
                              color: operation === 'alquiler' ? 'white' : '#555',
                              fontWeight: '600',
                              fontSize: '0.9rem',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: operation === 'alquiler' ? '0 4px 6px rgba(102, 126, 234, 0.4)' : 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                          >
                            <BsHouseDoor size={18} />
                            Valor de Alquiler
                          </button>
                        </div>
                      </div>
                      )}

                      {/* Property Type - Step 3 for mobile, always show for desktop */}
                      {(!isMobile || currentStep === 3) && (
                      <div 
                        className={isMobile ? 'mobile-step-enter' : ''}
                        style={{
                          marginBottom: isMobile ? '30px' : '0'
                      }}>
                        <label style={{
                          display: 'block',
                          fontSize: '1rem',
                          fontWeight: '600',
                          marginBottom: '10px',
                          color: '#555'
                        }}>
                          Tipo de Propiedad
                        </label>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: '10px'
                        }}>
                          <button
                            onClick={() => handlePropertySelect('departamento')}
                            style={{
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: 'none',
                              background: property === 'departamento' ? '#667eea' : '#f8f9fa',
                              color: property === 'departamento' ? 'white' : '#555',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <FaBuilding size={14} />
                            Departamento
                          </button>
                          <button
                            onClick={() => handlePropertySelect('casa')}
                            style={{
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: 'none',
                              background: property === 'casa' ? '#667eea' : '#f8f9fa',
                              color: property === 'casa' ? 'white' : '#555',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <FaHome size={14} />
                            Casa
                          </button>
                          <button
                            onClick={() => handlePropertySelect('oficina')}
                            style={{
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: 'none',
                              background: property === 'oficina' ? '#667eea' : '#f8f9fa',
                              color: property === 'oficina' ? 'white' : '#555',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <FaBriefcase size={14} />
                            Oficina
                          </button>
                          <button
                            onClick={() => handlePropertySelect('local')}
                            style={{
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: 'none',
                              background: property === 'local' ? '#667eea' : '#f8f9fa',
                              color: property === 'local' ? 'white' : '#555',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <IoStorefrontOutline size={16} />
                            Local Comercial
                          </button>
                          <button
                            onClick={() => handlePropertySelect('cocheras')}
                            style={{
                              padding: '12px 20px',
                              borderRadius: '8px',
                              border: 'none',
                              background: property === 'cocheras' ? '#667eea' : '#f8f9fa',
                              color: property === 'cocheras' ? 'white' : '#555',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <MdDirectionsCar size={16} />
                            Cocheras
                          </button>
                        </div>
                      </div>
                      )}
                    </div>

                    {/* Valuation Type - Step 4 for mobile, always show for desktop */}
                    {(!isMobile || currentStep === 4) && (
                    <div 
                      className={isMobile ? 'mobile-step-enter' : ''}
                      style={{
                      background: '#f8f9fa',
                      padding: '20px',
                      borderRadius: '12px',
                      marginBottom: '30px'
                    }}>
                      <label style={{
                        display: 'block',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '15px',
                        color: '#555'
                      }}>
                        Tipo de Valuación
                      </label>
                      <div style={{
                        display: 'flex',
                        gap: '15px'
                      }}>
                        <button
                          onClick={() => handleValuationTypeSelect("simple")}
                          style={{
                            flex: 1,
                            padding: '15px 20px',
                            borderRadius: '8px',
                            border: 'none',
                            background: valuationType === "simple" ? '#28a745' : '#e9ecef',
                            color: valuationType === "simple" ? 'white' : '#495057',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          Valuación Simple
                        </button>
                        {property !== 'cocheras' && (
                        <button
                            onClick={() => handleValuationTypeSelect("advanced")}
                          style={{
                            flex: 1,
                            padding: '15px 20px',
                            borderRadius: '8px',
                            border: 'none',
                            background: valuationType === "advanced" ? '#28a745' : '#e9ecef',
                            color: valuationType === "advanced" ? 'white' : '#495057',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          Valuación Avanzada
                        </button>
                        )}
                      </div>
                    </div>
                    )}

                    {/* Form Fields - Step 5 for mobile ONLY */}
                    {(isMobile && currentStep === 5) && (
                    <div 
                      className={isMobile ? 'mobile-step-enter' : ''}
                      style={{
                        background: 'linear-gradient(135deg, #f8f9ff 0%, #fff5f8 100%)',
                        padding: '25px',
                        borderRadius: '16px',
                        boxShadow: '0 8px 24px rgba(102, 126, 234, 0.1)',
                        border: '1px solid rgba(102, 126, 234, 0.1)',
                        marginBottom: '20px'
                      }}>
                    <div 
                      style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                      gap: '20px'
                    }}>
                      {/* Simple Valuation Fields */}
                      {valuationType === "simple" ? (
                        <>
                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdMeetingRoom size={16} />
                              Ambientes
                            </label>
                            <select
                              value={amb}
                              onChange={(e) => setAmb(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                fontSize: '1rem',
                                background: 'white'
                              }}
                            >
                              <option value="">Seleccionar</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdDirectionsCar size={16} />
                              Cochera/s
                            </label>
                            <input
                              type="number"
                              placeholder="0"
                              value={garage}
                              onChange={(e) => handleChange(e, "garage")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdSettings size={16} />
                              Estado
                            </label>
                            <select
                              onChange={(e) => setCondition(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                fontSize: '1rem',
                                background: 'white'
                              }}
                            >
                              <option value="Estrenar">Estrenar</option>
                              <option value="Muy bueno">Muy bueno</option>
                              <option value="Bueno">Bueno</option>
                              <option value="Regular">Regular</option>
                              <option value="Malo">Malo</option>
                            </select>
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <IoCalendarOutline size={16} />
                              Antigüedad (años)
                            </label>
                            <input
                              type="number"
                              placeholder="1"
                              value={antiguedad}
                              onChange={(e) => handleChange(e, "antiguedad")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        // Advanced valuation fields
                        <>
                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdMeetingRoom size={16} />
                              Ambientes
                            </label>
                            <input
                              type="number"
                              placeholder="1"
                              value={amb}
                              onChange={(e) => handleChange(e, "amb")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdDirectionsCar size={16} />
                              Cochera/s (cantidad)
                            </label>
                            <input
                              type="number"
                              placeholder="0"
                              value={garage}
                              onChange={(e) => handleChange(e, "garage")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdSquareFoot size={16} />
                              Superficie Cubierta (m²)
                            </label>
                            <input
                              type="number"
                              placeholder="0"
                              value={sc}
                              onChange={(e) => handleChange(e, "sc")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>

                          {/* Superficie Semicubierta - Always show in advanced mode */}
                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <IoHomeOutline size={16} />
                              Superficie Semicubierta (m²)
                            </label>
                            <input
                              type="number"
                              placeholder="0"
                              value={st}
                              onChange={(e) => handleChange(e, "st")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                            <small style={{ 
                              fontSize: '0.8rem', 
                              color: '#6c757d', 
                              marginTop: '4px', 
                              display: 'block' 
                            }}>
                              Balcones, galerías, espacios cubiertos parcialmente
                            </small>
                          </div>

                          {/* Superficie Descubierta - Always show in advanced mode */}
                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#555'
                            }}>
                              🌳 Superficie Descubierta (m²)
                            </label>
                            <input
                              type="number"
                              placeholder="0"
                              value={sd}
                              onChange={(e) => handleChange(e, "sd")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                            <small style={{ 
                              fontSize: '0.8rem', 
                              color: '#6c757d', 
                              marginTop: '4px', 
                              display: 'block' 
                            }}>
                              Jardín, patio, terrazas descubiertas
                            </small>
                          </div>

                          {/* Superficie Terreno - Only show for houses */}
                          {property === 'casa' && (
                            <div>
                              <label style={{
                                display: 'block',
                                fontSize: '1rem',
                                fontWeight: '600',
                                marginBottom: '8px',
                                color: '#555'
                              }}>
                                🏞️ Superficie Terreno (m²)
                              </label>
                              <input
                                type="number"
                                placeholder="0"
                                value={sterre}
                                onChange={(e) => handleChange(e, "sterre")}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  borderRadius: '8px',
                                  border: '1px solid #ddd',
                                  fontSize: '1rem'
                                }}
                              />
                              <small style={{ 
                                fontSize: '0.8rem', 
                                color: '#6c757d', 
                                marginTop: '4px', 
                                display: 'block' 
                              }}>
                                Medidas del lote frente x fondo
                              </small>
                            </div>
                          )}

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <MdSettings size={16} />
                              Estado
                            </label>
                            <select
                              value={condition}
                              onChange={(e) => setCondition(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                fontSize: '1rem',
                                background: 'white'
                              }}
                            >
                              <option value="Estrenar">Estrenar</option>
                              <option value="Muy bueno">Muy bueno</option>
                              <option value="Bueno">Bueno</option>
                              <option value="Regular">Regular</option>
                              <option value="Malo">Malo</option>
                              <option value="Restauracion">Restauración</option>
                              <option value="Demolicion">Demolición</option>
                            </select>
                          </div>

                          <div>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <IoCalendarOutline size={16} />
                              Antigüedad (años)
                            </label>
                            <input
                              type="number"
                              placeholder="1"
                              value={antiguedad}
                              onChange={(e) => handleChange(e, "antiguedad")}
                              style={{
                                width: '100%',
                                padding: '12px',
                                borderRadius: '10px',
                                border: '2px solid #e3e8f0',
                                fontSize: '1rem',
                                background: 'white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.3s ease'
                              }}
                            />
                          </div>

                          {/* Amenities */}
                          <div style={{ gridColumn: '1 / -1' }}>
                            <label style={{
                              display: 'block',
                              fontSize: '1rem',
                              fontWeight: '600',
                              marginBottom: '12px',
                              color: '#4a5568',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <BsStars size={16} />
                              Amenities
                            </label>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                              gap: '15px'
                            }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                              }}>
                                <input
                                  type="checkbox"
                                  checked={barbecue}
                                  onChange={(e) => setBarbecue(e.target.checked)}
                                  style={{
                                    width: '18px',
                                    height: '18px'
                                  }}
                                />
                                <label style={{ fontSize: '0.9rem', color: '#4a5568', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <GiBarbecue size={16} />
                                  Parrilla
                                </label>
                              </div>
                              
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                              }}>
                                <input
                                  type="checkbox"
                                  checked={pool}
                                  onChange={(e) => setPool(e.target.checked)}
                                  style={{
                                    width: '18px',
                                    height: '18px'
                                  }}
                                />
                                <label style={{ fontSize: '0.9rem', color: '#4a5568', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <GiPoolTriangle size={16} />
                                  Piscina
                                </label>
                              </div>
                              
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                              }}>
                                <input
                                  type="checkbox"
                                  checked={sum}
                                  onChange={(e) => setSum(e.target.checked)}
                                  style={{
                                    width: '18px',
                                    height: '18px'
                                  }}
                                />
                                <label style={{ fontSize: '0.9rem', color: '#4a5568', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <GiBarbecue size={16} />
                                  Quincho
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    </div>
                    )}

                      {/* Contact Information - Step 6 for mobile ONLY */}
                      {requirePhoneNumber && (isMobile && currentStep === 6) && (
                      <div 
                        className={isMobile ? 'mobile-step-enter' : ''}
                        style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        padding: '0 15px'
                      }}>

                      {/* Payment Option Selection - Mobile */}
                      {(() => {
                        console.log('🔍 Step 6 Mobile State:', { 
                          enablePayOption, 
                          selectedPaymentOption, 
                          loadingPreview,
                          shouldShowOptions: enablePayOption && !selectedPaymentOption && !loadingPreview
                        });
                        return null;
                      })()}
                      {enablePayOption && !selectedPaymentOption && !loadingPreview && (
                        <div style={{ padding: '10px 0' }}>
                          <h2 style={{ 
                            textAlign: 'center', 
                            fontSize: '1.2rem', 
                            color: '#2c3e50', 
                            marginBottom: '5px',
                            fontWeight: '700'
                          }}>
                            Seleccioná tu Opción
                          </h2>
                          <p style={{ 
                            textAlign: 'center', 
                            fontSize: '0.8rem', 
                            color: '#7f8c8d', 
                            marginBottom: '15px'
                          }}>
                            Elegí la valuación que mejor se adapte a tus necesidades
                          </p>

                          {/* FREE OPTION - Mobile Compact */}
                          <div 
                            onClick={() => enableFreeValuacion && setSelectedPaymentOption('free')}
                            style={{
                              background: enableFreeValuacion ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : 'linear-gradient(135deg, #e9ecef 0%, #d3d3d3 100%)',
                              borderRadius: '10px',
                              padding: '15px 20px',
                              marginBottom: '12px',
                              cursor: enableFreeValuacion ? 'pointer' : 'not-allowed',
                              transition: 'all 0.3s ease',
                              boxShadow: enableFreeValuacion ? '0 3px 10px rgba(16, 185, 129, 0.3)' : 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '15px',
                              opacity: enableFreeValuacion ? 1 : 0.6
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                              <div style={{ fontSize: '2rem', color: enableFreeValuacion ? 'white' : '#7f8c8d' }}>
                                <FaGift />
                              </div>
                              <div style={{ textAlign: 'left' }}>
                                <h3 style={{ 
                                  fontSize: '1.1rem', 
                                  color: enableFreeValuacion ? 'white' : '#2c3e50', 
                                  marginBottom: '2px',
                                  fontWeight: '700'
                                }}>
                                  GRATIS
                                </h3>
                                <p style={{ 
                                  fontSize: '0.75rem', 
                                  color: enableFreeValuacion ? 'rgba(255,255,255,0.9)' : '#7f8c8d', 
                                  marginBottom: '0'
                                }}>
                                  Valuación básica
                                </p>
                              </div>
                            </div>
                            <div style={{
                              fontSize: '1.2rem',
                              fontWeight: '700',
                              color: enableFreeValuacion ? 'white' : '#7f8c8d'
                            }}>
                              $0
                            </div>
                          </div>

                          {/* REGISTER OPTION - Mobile Compact */}
                          {!isLoggedIn && (
                          <div 
                            onClick={openRegisterModal}
                            style={{
                              background: 'linear-gradient(135deg, #ff8c42 0%, #ff6b6b 100%)',
                              borderRadius: '10px',
                              padding: '15px 20px',
                              marginBottom: '12px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 3px 10px rgba(255, 140, 66, 0.3)',
                              position: 'relative',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '15px'
                            }}
                          >
                            {/* Best Value Badge - Compact */}
                            <div style={{
                              position: 'absolute',
                              top: '-8px',
                              right: '10px',
                              background: '#2ecc71',
                              color: 'white',
                              padding: '3px 10px',
                              borderRadius: '10px',
                              fontSize: '0.65rem',
                              fontWeight: '700',
                              boxShadow: '0 2px 8px rgba(46, 204, 113, 0.4)'
                            }}>
                              ⭐ IDEAL
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                              <div style={{ fontSize: '2rem', color: '#ffd700' }}>
                                <FaUserPlus />
                              </div>
                              <div style={{ textAlign: 'left' }}>
                                <h3 style={{ 
                                  fontSize: '1.1rem', 
                                  color: 'white', 
                                  marginBottom: '2px',
                                  fontWeight: '700'
                                }}>
                                  REGISTRARME
                                </h3>
                                <p style={{ 
                                  fontSize: '0.75rem', 
                                  color: 'rgba(255,255,255,0.9)', 
                                  marginBottom: '0'
                                }}>
                                  2 créditos premium gratis
                                </p>
                              </div>
                            </div>
                            <div style={{
                              fontSize: '1.2rem',
                              fontWeight: '700',
                              color: '#ffd700'
                            }}>
                              $0
                            </div>
                          </div>
                          )}

                          {/* PREMIUM OPTION - Mobile Compact */}
                          <div 
                            onClick={handlePremiumSelection}
                            style={{
                              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              borderRadius: '10px',
                              padding: '15px 20px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 3px 10px rgba(102, 126, 234, 0.3)',
                              position: 'relative',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '15px'
                            }}
                          >
                            {/* Badges - Compact */}
                            {isAdmin() && (
                              <div style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '10px',
                                background: '#2ecc71',
                                color: 'white',
                                padding: '3px 10px',
                                borderRadius: '10px',
                                fontSize: '0.65rem',
                                fontWeight: '700',
                                boxShadow: '0 2px 8px rgba(46, 204, 113, 0.4)'
                              }}>
                                🔑 GRATIS
                              </div>
                            )}
                            {!isAdmin() && !((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) && payOptionDiscountPercent > 0 && (
                              <div style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '10px',
                                background: '#ff4757',
                                color: 'white',
                                padding: '3px 10px',
                                borderRadius: '10px',
                                fontSize: '0.65rem',
                                fontWeight: '700',
                                boxShadow: '0 2px 8px rgba(255, 71, 87, 0.4)'
                              }}>
                                -{payOptionDiscountPercent}% OFF
                              </div>
                            )}
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                              <div style={{ fontSize: '2rem', color: '#ffd700' }}>
                                <RiVipCrownFill />
                              </div>
                              <div style={{ textAlign: 'left' }}>
                                <h3 style={{ 
                                  fontSize: '1.1rem', 
                                  color: 'white', 
                                  marginBottom: '2px',
                                  fontWeight: '700'
                                }}>
                                  PREMIUM
                                </h3>
                                <p style={{ 
                                  fontSize: '0.75rem', 
                                  color: 'rgba(255,255,255,0.9)', 
                                  marginBottom: '0'
                                }}>
                                  {isAdmin() ? 'Gratis para admin' : ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? `${agentCredits} ${agentCredits === 1 ? 'crédito' : 'créditos'}` : 'Valuación detallada'}
                                </p>
                              </div>
                            </div>
                            
                            <div style={{
                              fontSize: '1.2rem',
                              fontWeight: '700',
                              color: '#ffd700',
                              textAlign: 'right'
                            }}>
                              {isAdmin() ? (
                                <span style={{ fontSize: '0.9rem', color: '#2ecc71' }}>GRATIS</span>
                              ) : ((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? (
                                <span style={{ fontSize: '0.9rem', color: '#2ecc71' }}>USAR</span>
                              ) : payOptionDiscountPercent > 0 ? (
                                <div>
                                  <div style={{ fontSize: '0.7rem', textDecoration: 'line-through', color: 'rgba(255,255,255,0.6)' }}>
                                    ${payOptionPrice.toLocaleString('es-AR')}
                                  </div>
                                  <div>${Math.round(payOptionPrice * (1 - payOptionDiscountPercent / 100)).toLocaleString('es-AR')}</div>
                                </div>
                              ) : (
                                <div>${payOptionPrice.toLocaleString('es-AR')}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      
                      {/* Loading State - Mobile */}
                      {loadingPreview && (
                        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                          <RotatingLines
                            strokeColor="#667eea"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="80"
                            visible={true}
                          />
                          <p style={{ 
                            marginTop: '20px', 
                            fontSize: '1.1rem', 
                            color: '#667eea',
                            fontWeight: '600'
                          }}>
                            Calculando tu valuación...
                          </p>
                        </div>
                      )}
                      
                      {/* Price Preview - Mobile - Only show when free is selected */}
                      {!loadingPreview && pricePreview && selectedPaymentOption === 'free' && (
                        <>
                          {/* Address */}
                          <div style={{ 
                            textAlign: 'center', 
                            fontSize: '1rem',
                            color: '#495057',
                            marginTop: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <FaMapMarkerAlt size={16} />
                            {pricePreview.address}
                          </div>
                          
                          {/* Blurred Price Range */}
                          <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            padding: '25px 20px',
                            borderRadius: '12px',
                            textAlign: 'center',
                            boxShadow: '0 6px 16px rgba(102, 126, 234, 0.3)'
                          }}>
                            <div style={{ 
                              color: 'rgba(255, 255, 255, 0.9)', 
                              fontSize: '0.85rem', 
                              marginBottom: '10px',
                              fontWeight: '600',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}>
                              <MdAttachMoney size={18} />
                              Valor Estimado de {pricePreview.operation === 'venta' ? 'Venta' : 'Alquiler'}
                            </div>
                            <div style={{ 
                              color: 'white', 
                              fontSize: '1.1rem', 
                              fontWeight: '700',
                              textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '4px',
                              flexWrap: 'wrap'
                            }}>
                              <span>U$</span>
                              <span style={{ filter: 'blur(4px)', userSelect: 'none' }}>XXXXXX</span>
                              <span>-</span>
                              <span>U$</span>
                              <span style={{ filter: 'blur(4px)', userSelect: 'none' }}>XXXXXXX</span>
                            </div>
                            <button 
                              onClick={() => {
                                document.getElementById('phone-input-mobile')?.scrollIntoView({ 
                                  behavior: 'smooth', 
                                  block: 'center' 
                                });
                                document.getElementById('phone-input-mobile')?.focus();
                              }}
                              style={{
                                marginTop: '15px',
                                fontSize: '0.9rem',
                                color: 'white',
                                fontWeight: '600',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: '2px solid rgba(255, 255, 255, 0.5)',
                                borderRadius: '20px',
                                padding: '8px 20px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              🔓 Ver resultado
                            </button>
                          </div>
                        </>
                      )}
                      
                      {/* Phone Input Section - Mobile - Show when free is selected or pay option disabled */}
                      {!loadingPreview && (!enablePayOption || selectedPaymentOption === 'free') && (
                      <>
                      {!isLoggedIn ? (
                        <>
                          {/* Phone Number - Mobile */}
                          <div style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            padding: '20px',
                            borderRadius: '12px',
                            border: '3px solid #4A90E2',
                            boxShadow: '0 4px 12px rgba(74, 144, 226, 0.2)'
                          }}>
                            <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                              <div style={{ 
                                fontSize: '2.5rem', 
                                marginBottom: '8px'
                              }}>
                                📱
                              </div>
                              <div style={{
                                display: 'inline-block',
                                padding: '6px 14px',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                borderRadius: '20px',
                                boxShadow: '0 3px 8px rgba(16, 185, 129, 0.3)'
                              }}>
                                <span style={{ 
                                  fontSize: '0.85rem', 
                                  fontWeight: '700', 
                                  color: '#ffffff'
                                }}>
                                  🎁 100% GRATIS
                                </span>
                              </div>
                            </div>

                            {/* Upgrade to Premium button - Mobile */}
                            {enablePayOption && (
                              <div style={{ textAlign: 'center', marginTop: '12px', marginBottom: '12px' }}>
                                <button
                                  onClick={handlePremiumSelection}
                                  style={{
                                    width: '100%',
                                    padding: '10px 20px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '0.85rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                                  }}
                                >
                                  <RiVipCrownFill style={{ marginRight: '8px' }} /> Valuación Premium
                                </button>
                              </div>
                            )}

                            <div style={{
                              background: 'white',
                              padding: '15px',
                              borderRadius: '10px',
                              border: '2px solid #4A90E2'
                            }}>
                              <label style={{
                                display: 'block',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                color: '#495057',
                                marginBottom: '10px',
                                textAlign: 'center'
                              }}>
                                Ingresá tu número de WhatsApp
                              </label>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                border: '2px solid #dee2e6',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                transition: 'all 0.3s ease',
                                background: 'white',
                                width: '100%'
                              }}>
                                <span style={{
                                  padding: '14px 12px',
                                  background: '#f8f9fa',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  color: '#495057',
                                  borderRight: '2px solid #dee2e6',
                                  flexShrink: 0
                                }}>
                                  +54
                                </span>
                                <input
                                  id="phone-input-mobile"
                                  type="tel"
                                  placeholder="11 2345 6789"
                                  value={phone || ''}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    flex: 1,
                                    padding: '14px 12px',
                                    border: 'none',
                                    fontSize: '1rem',
                                    fontWeight: '500',
                                    outline: 'none',
                                    background: 'transparent',
                                    minWidth: 0
                                  }}
                                />
                              </div>
                              
                              {/* WhatsApp Status Indicator - Mobile */}
                              {whatsappStatus && (
                                <div style={{
                                  marginTop: '15px',
                                  padding: '10px 12px',
                                  borderRadius: '8px',
                                  border: '2px solid',
                                  borderColor: whatsappStatus === 'valid' ? '#4caf50' : whatsappStatus === 'invalid' ? '#f44336' : '#ff9800',
                                  background: whatsappStatus === 'valid' ? '#e8f5e9' : whatsappStatus === 'invalid' ? '#ffebee' : '#fff3e0',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px'
                                }}>
                                  <span style={{ fontSize: '1.2rem', flexShrink: 0 }}>
                                    {whatsappStatus === 'checking' ? '⏳' : whatsappStatus === 'valid' ? '✅' : '❌'}
                                  </span>
                                  <div style={{ flex: 1 }}>
                                    <p style={{
                                      margin: 0,
                                      fontSize: '0.85rem',
                                      fontWeight: '600',
                                      color: whatsappStatus === 'valid' ? '#2e7d32' : whatsappStatus === 'invalid' ? '#c62828' : '#f57c00'
                                    }}>
                                      {whatsappMessage}
                                    </p>
                                    {whatsappStatus === 'invalid' && (
                                      <p style={{
                                        margin: '4px 0 0 0',
                                        fontSize: '0.75rem',
                                        color: '#c62828'
                                      }}>
                                        Ingresá un número con WhatsApp
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Already logged in - Mobile */}
                          {(userInfo?.userType === 'agent' || userInfo?.userType === 'individual') ? (
                            <div style={{
                              background: '#d4edda',
                              padding: '20px',
                              borderRadius: '12px',
                              border: '2px solid #c3e6cb',
                              textAlign: 'center'
                            }}>
                              <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>✅</div>
                              <p style={{
                                fontSize: '1.1rem',
                                color: '#155724',
                                margin: 0,
                                fontWeight: '700'
                              }}>
                                Sesión iniciada como agente
                              </p>
                              <p style={{
                                fontSize: '0.95rem',
                                color: '#155724',
                                margin: '5px 0 0 0',
                                fontWeight: '600'
                              }}>
                                {userInfo.name || userInfo.email}
                              </p>
                              <p style={{
                                fontSize: '0.85rem',
                                color: '#155724',
                                margin: '10px 0 0 0',
                                opacity: 0.8
                              }}>
                                Esta valuación se guardará en tu cuenta
                              </p>
                            </div>
                          ) : (
                            /* Phone Number - Mobile logged in (non-agent) */
                            <div style={{
                              background: 'linear-gradient(135deg, #667eea, #764ba2)',
                              padding: '20px',
                              borderRadius: '12px',
                              color: 'white'
                            }}>
                              <label style={{
                                display: 'block',
                                fontSize: '1rem',
                                fontWeight: '600',
                                marginBottom: '10px',
                                textAlign: 'center'
                              }}>
                                📱 Teléfono
                              </label>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                border: '2px solid #ddd',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                background: 'white'
                              }}>
                                <span style={{
                                  padding: '14px 10px',
                                  background: '#f8f9fa',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  color: '#495057',
                                  borderRight: '2px solid #ddd'
                                }}>
                                  +54
                                </span>
                                <input
                                  type="tel"
                                  placeholder="11 2345 6789"
                                  value={phone || ''}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    flex: 1,
                                    padding: '14px',
                                    border: 'none',
                                    fontSize: '1rem',
                                    outline: 'none',
                                    background: 'transparent',
                                    color: '#333'
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {/* Email Field - Hidden - Mobile */}
                      <div style={{ display: 'none' }}>
                        <input
                          type="email"
                          value={email || ''}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>

                      {/* Terms & Conditions Checkbox - Mobile - Only for non-logged-in or non-agent users */}
                      {(!isLoggedIn || userInfo?.userType !== 'agent') && (
                      <div 
                        id="terms-checkbox-mobile"
                        style={{ 
                          marginTop: '20px',
                          animation: showTermsError ? 'shake 0.5s' : 'none'
                        }}
                      >
                        <label style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '8px',
                          fontSize: '0.75rem',
                          color: '#6c757d',
                          cursor: 'pointer',
                          padding: '12px',
                          background: showTermsError ? '#fff3cd' : '#f8f9fa',
                          border: `2px solid ${showTermsError ? '#ffc107' : acceptedTerms ? '#667eea' : '#dee2e6'}`,
                          borderRadius: '8px',
                          fontWeight: '400',
                          lineHeight: '1.4',
                          textAlign: 'left'
                        }}>
                          <input
                            type="checkbox"
                            checked={acceptedTerms}
                            onChange={(e) => {
                              setAcceptedTerms(e.target.checked);
                              if (e.target.checked) setShowTermsError(false);
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                              marginTop: '1px',
                              flexShrink: 0,
                              accentColor: '#667eea'
                            }}
                          />
                          <span>
                            Acepto los{' '}
                            <a 
                              href="/terminos-y-condiciones" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ 
                                color: '#667eea', 
                                fontWeight: '600',
                                textDecoration: 'underline'
                              }}
                            >
                              Términos y Condiciones
                            </a>
                            {' '}y la{' '}
                            <a 
                              href="/politica-de-privacidad" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ 
                                color: '#667eea', 
                                fontWeight: '600',
                                textDecoration: 'underline'
                              }}
                            >
                              Política de Privacidad
                            </a>. Entiendo que mi número será utilizado para contactarme con fines comerciales.
                          </span>
                        </label>
                        
                        {/* Error message - Mobile */}
                        {showTermsError && (
                          <div style={{
                            marginTop: '10px',
                            padding: '10px 12px',
                            background: '#fff3cd',
                            border: '2px solid #ffc107',
                            borderRadius: '8px',
                            color: '#856404',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            textAlign: 'center',
                            animation: 'fadeIn 0.3s ease-in'
                          }}>
                            ⚠️ Debes aceptar los términos para continuar
                          </div>
                        )}
                      </div>
                      )}

                      {/* Development Mode: Send Email Checkbox - Mobile */}
                      {isDevelopment && (
                        <div style={{ marginTop: '15px' }}>
                          <label style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            fontSize: '0.9rem',
                            color: '#6c757d',
                            cursor: 'pointer',
                            padding: '12px',
                            background: '#fff3cd',
                            border: '2px solid #ffc107',
                            borderRadius: '8px',
                            fontWeight: '500'
                          }}>
                            <input
                              type="checkbox"
                              checked={sendEmail}
                              onChange={(e) => setSendEmail(e.target.checked)}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer'
                              }}
                            />
                            <span>📧 Enviar email (Dev Mode)</span>
                          </label>
                        </div>
                      )}
                      
                      {/* Link to Inmobiliaria Registration - Mobile */}
                      <div style={{ 
                        textAlign: 'center', 
                        marginTop: '20px',
                        paddingTop: '15px',
                        borderTop: '1px solid #e9ecef'
                      }}>
                        <button
                          onClick={() => {
                            setLoginMode('register');
                            setRegisterForm({ ...registerForm, userType: 'agent' });
                            setShowLoginModal(true);
                          }}
                          style={{ 
                            fontSize: '0.9rem',
                            color: '#667eea',
                            textDecoration: 'none',
                            fontWeight: '500',
                            transition: 'all 0.2s ease',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0
                          }}
                          onTouchStart={(e) => {
                            e.target.style.color = '#764ba2';
                            e.target.style.textDecoration = 'underline';
                          }}
                          onTouchEnd={(e) => {
                            e.target.style.color = '#667eea';
                            e.target.style.textDecoration = 'none';
                          }}
                        >
                          ¿Sos agente inmobiliario? Registrate acá
                        </button>
                      </div>
                      </>
                      )}

                      {/* Premium Payment Section - Mobile (not admin) */}
                      {!loadingPreview && enablePayOption && selectedPaymentOption === 'premium' && !isAdmin() && (
                        <div style={{ padding: '15px 0' }}>
                          {/* Back button */}
                          <button
                            onClick={() => setSelectedPaymentOption(null)}
                            style={{
                              marginBottom: '20px',
                              padding: '10px 20px',
                              background: 'transparent',
                              color: '#667eea',
                              border: '2px solid #667eea',
                              borderRadius: '8px',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              cursor: 'pointer'
                            }}
                          >
                            ← Volver a opciones
                          </button>

                          <h2 style={{ 
                            textAlign: 'center', 
                            fontSize: '1.5rem', 
                            color: '#2c3e50', 
                            marginBottom: '20px',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                          }}>
                            <RiVipCrownFill style={{ color: '#ffd700', fontSize: '1.8rem' }} /> Valuación Premium
                          </h2>

                          {/* MercadoPago Payment Component */}
                          <MercadoPagoPayment
                            title="Valuación Premium - TasacionesYa"
                            price={Math.round(payOptionPrice * (1 - payOptionDiscountPercent / 100))}
                            originalPrice={payOptionPrice}
                            discountPercent={((userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && agentCredits > 0) ? 0 : payOptionDiscountPercent}
                            description={`Valuación detallada profesional para ${addressD || 'tu propiedad'}`}
                            userEmail={email}
                            smp={addressD}
                            paymentType="premium_valuation"
                            propertyData={{
                              address: marker,
                              addressD: addressD,
                              zone_c: zone,
                              operation: operation,
                              property: property,
                              amb: amb,
                              garage: garage || '0',
                              sc: sc,
                              st: st || '0',
                              sd: sd || '0',
                              sterre: sterre || '0',
                              condition: condition,
                              antiguedad: antiguedad || '1',
                              valuationType: valuationType,
                              barbecue: barbecue,
                              pool: pool,
                              sum: sum
                            }}
                            onPaymentSuccess={(paymentData) => {
                              console.log('✅ Payment successful - proceeding to valuation');
                              
                              // Check if this is a free payment (100% promo code discount)
                              if (paymentData?.isFree && paymentData?.valuationResults) {
                                console.log('🎉 Free payment with promo code - showing results immediately');
                                console.log('📊 Valuation results:', paymentData.valuationResults);
                                
                                // Store premium results
                                const results = paymentData.valuationResults;
                                setPremiumResults(results);
                                localStorage.setItem('premium_valuation_results', JSON.stringify(results));
                                localStorage.setItem('premium_payment_success', 'true');
                                
                                // Set basic price results for display
                                if (results.isRent && results.preciosARS && results.preciosUSD) {
                                  // Rent valuation - set both currencies
                                  setRentData({
                                    preciosARS: results.preciosARS,
                                    preciosUSD: results.preciosUSD
                                  });
                                } else {
                                  // Sale valuation - set USD prices
                                  setValorPropUno(results.valorMinimo || 0);
                                  setValorPropDos(results.valorMaximo || 0);
                                }
                                
                                // Mark that we got the price and show results
                                setGotPrice(true);
                                setShowResult(true);
                                setResultExists(true);
                                
                                // Stop loading and go to results step
                                setLoadingPreview(false);
                                setLoadingPrice(false);
                                setCurrentStep(7);
                                
                                console.log('✅ Results displayed - currentStep set to 7');
                              } else {
                                // Regular paid flow - wait for MercadoPago return
                                get_price();
                              }
                            }}
                            onPaymentError={(error) => {
                              console.error('❌ Payment error:', error);
                              alert('Error al procesar el pago. Por favor intentá de nuevo.');
                            }}
                          />

                          {/* Discount information box - Mobile */}
                          {payOptionDiscountPercent > 0 && (
                            <div style={{
                              marginTop: '15px',
                              padding: '12px',
                              background: '#e8f5e9',
                              border: '2px solid #10b981',
                              borderRadius: '8px',
                              textAlign: 'center'
                            }}>
                              <div style={{ 
                                fontSize: '1rem', 
                                color: '#10b981', 
                                fontWeight: '700',
                                marginBottom: '5px'
                              }}>
                                🎉 ¡Precio especial con {payOptionDiscountPercent}% OFF!
                              </div>
                              <div style={{ fontSize: '0.85rem', color: '#2c3e50' }}>
                                Precio normal: <span style={{ textDecoration: 'line-through' }}>${payOptionPrice.toLocaleString('es-AR')}</span>
                                {' '}→ Ahorrás: <strong style={{ color: '#10b981' }}>${Math.round(payOptionPrice * payOptionDiscountPercent / 100).toLocaleString('es-AR')}</strong>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    )}

                    {/* Mobile Navigation Buttons */}
                    {isMobile && currentStep !== 6 && (
                      <>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '12px',
                          marginTop: '30px',
                          marginBottom: '20px'
                        }}>
                          {currentStep < 6 && (
                            <button
                              onClick={goToNextStep}
                              disabled={!canProceedToNextStep()}
                              style={{
                                width: '100%',
                                padding: '15px 25px',
                                borderRadius: '10px',
                                border: 'none',
                                background: canProceedToNextStep() 
                                  ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                                  : '#dee2e6',
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '1rem',
                                cursor: canProceedToNextStep() ? 'pointer' : 'not-allowed',
                                transition: 'all 0.3s ease',
                                boxShadow: canProceedToNextStep() ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none',
                                opacity: canProceedToNextStep() ? 1 : 0.6
                              }}
                            >
                              Siguiente →
                            </button>
                          )}
                          {currentStep > 1 && currentStep !== 7 && (
                            <button
                              onClick={goToPreviousStep}
                              style={{
                                width: '100%',
                                padding: '15px 25px',
                                borderRadius: '10px',
                                border: '2px solid #667eea',
                                background: 'white',
                                color: '#667eea',
                                fontWeight: '700',
                                fontSize: '1rem',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                              }}
                            >
                              ← Anterior
                            </button>
                          )}
                        </div>
                      </>
                    )}

                    {/* Submit Button - Only show on step 6 for mobile when free is selected or pay option disabled */}
                    {requirePhoneNumber && (isMobile && currentStep === 6) && (!enablePayOption || selectedPaymentOption === 'free') && (
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                      <button
                        onClick={(e) => {
                          // For logged-in agents, terms were accepted during registration
                          const needsTermsAcceptance = !isLoggedIn || userInfo?.userType !== 'agent';
                          
                          if (needsTermsAcceptance && !acceptedTerms) {
                            e.preventDefault();
                            setShowTermsError(true);
                            // Scroll to checkbox
                            document.getElementById('terms-checkbox-mobile')?.scrollIntoView({ 
                              behavior: 'smooth', 
                              block: 'center' 
                            });
                            // Clear error after 3 seconds
                            setTimeout(() => setShowTermsError(false), 3000);
                          } else {
                            get_price(e);
                          }
                        }}
                        disabled={!address || loadingPrice}
                        style={{
                          background: (() => {
                            const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                            const canSubmit = address && !loadingPrice && (needsTerms ? acceptedTerms : true);
                            return canSubmit ? 'linear-gradient(135deg, #667eea, #764ba2)' : '#a0a0a0';
                          })(),
                          color: 'white',
                          border: (() => {
                            const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                            const canSubmit = address && !loadingPrice && (needsTerms ? acceptedTerms : true);
                            return canSubmit ? 'none' : '3px solid #5cb85c';
                          })(),
                          padding: '18px 40px',
                          borderRadius: '12px',
                          fontSize: '1.2rem',
                          fontWeight: '600',
                          cursor: (() => {
                            const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                            const canSubmit = address && !loadingPrice && (needsTerms ? acceptedTerms : true);
                            return canSubmit ? 'pointer' : 'not-allowed';
                          })(),
                          boxShadow: (() => {
                            const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                            const canSubmit = address && !loadingPrice && (needsTerms ? acceptedTerms : true);
                            return canSubmit ? '0 8px 25px rgba(102, 126, 234, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.2)';
                          })(),
                          transition: 'all 0.3s ease',
                          opacity: 1
                        }}
                      >
                        {loadingPrice ? (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <RotatingLines width="20" strokeColor="white" style={{ marginRight: '10px' }} />
                            Procesando...
                          </div>
                        ) : (
                          <>
                            {(() => {
                              const needsTerms = !isLoggedIn || userInfo?.userType !== 'agent';
                              const isActive = address && !loadingPrice && (needsTerms ? acceptedTerms : true);
                              return isActive ? '🔓' : '🔒';
                            })()} Ver Valuación
                          </>
                        )}
                      </button>
                      
                      {/* Loading Progress Info */}
                    {loadingPrice && (
                      <div style={{
                        marginTop: '15px',
                        padding: '15px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '10px' }}>
                          <RotatingLines width="16" strokeColor="#667eea" />
                          <span style={{ color: '#495057', fontSize: '0.9rem' }}>Calculando valuación...</span>
                        </div>
                        <div style={{ fontSize: '0.8rem', color: '#6c757d', textAlign: 'center' }}>
                          🔍 Analizando zona • 📊 Calculando precios • 📱 Preparando envío
                        </div>
                        
                        {/* Scroll Hint */}
                        <div style={{
                          marginTop: '15px',
                          padding: '10px',
                          background: 'linear-gradient(135deg, #667eea, #764ba2)',
                          color: 'white',
                          borderRadius: '6px',
                          fontSize: '0.8rem',
                          textAlign: 'center'
                        }}>
                          ⬇️ Los resultados aparecerán abajo automáticamente
                        </div>
                      </div>
                    )}
                    
                    {/* Anterior button for step 6 */}
                    <button
                      onClick={goToPreviousStep}
                      style={{
                        width: '100%',
                        padding: '15px 25px',
                        borderRadius: '10px',
                        border: '2px solid #667eea',
                        background: 'white',
                        color: '#667eea',
                        fontWeight: '700',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        marginTop: '15px'
                      }}
                    >
                      ← Anterior
                    </button>
                    </div>
                    )}
                  </div>
                  )}

                  {/* Step 7: Loading State - Show while calculating (mobile) */}
                  {isMobile && currentStep === 7 && !showResult && (
                    <div className="mobile-step-enter" style={{ 
                      marginBottom: '30px',
                      minHeight: '400px',
                      textAlign: 'center',
                      padding: '40px 20px',
                      background: 'white',
                      borderRadius: '0'
                    }}>
                      <div style={{
                        width: '100%',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                        <div style={{
                          marginBottom: '25px',
                          display: 'flex',
                          justifyContent: 'center'
                        }}>
                          <RotatingLines width="60" strokeColor="#667eea" />
                        </div>
                        <h2 style={{
                          fontSize: '1.5rem',
                          fontWeight: '700',
                          color: '#333',
                          marginBottom: '12px'
                        }}>
                          Calculando Valuación
                        </h2>
                        <p style={{
                          fontSize: '1rem',
                          color: '#6c757d',
                          marginBottom: '8px'
                        }}>
                          Estamos analizando los datos de tu propiedad
                        </p>
                        <p style={{
                          fontSize: '0.9rem',
                          color: '#adb5bd'
                        }}>
                          Esto puede tomar unos segundos...
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Results Section - Show ONLY on step 7 (both mobile and desktop) */}
                  {(currentStep === 7 && showResult) && (
                    <div 
                      data-results-section
                      className={isMobile ? 'mobile-step-enter' : 'desktop-step-enter'}
                      style={{
                        background: 'white',
                        borderRadius: isMobile ? '0' : '20px',
                        boxShadow: isMobile ? 'none' : '0 15px 40px rgba(0,0,0,0.12)',
                        padding: isMobile ? '20px 15px' : '40px',
                        marginBottom: isMobile ? '0' : '30px',
                        width: '100%',
                        minHeight: isMobile ? 'auto' : '500px',
                        transform: 'translateY(0)',
                        opacity: 1
                      }}
                    >
                      <div style={{
                        width: isMobile ? '100%' : '900px',
                        maxWidth: '100%',
                        margin: '0 auto'
                      }}>
                      {gotPrice ? (
                        <div style={{ textAlign: 'center' }}>
                          <div style={{
                            background: 'linear-gradient(135deg, #28a745, #20c997)',
                            color: 'white',
                            padding: '20px',
                            borderRadius: '12px',
                            marginBottom: '20px'
                          }}>
                            <h3 style={{ margin: '0', fontSize: '1.5rem' }}>
                              🎉 ¡Valuación Completada!
                            </h3>
                          </div>
                          
                          {/* Property Details */}
                          <div style={{
                            background: '#f8f9fa',
                            padding: '20px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            textAlign: 'left'
                          }}>
                            <h4 style={{ color: '#495057', marginBottom: '15px' }}>📋 Detalles de la Propiedad</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '0.9rem' }}>
                              <div><strong>Dirección:</strong> {addressD}</div>
                              <div><strong>Zona:</strong> {zone}</div>
                              <div><strong>Propiedad:</strong> {property}</div>
                              <div><strong>Ambientes:</strong> {amb}</div>
                              <div><strong>Operación:</strong> {operation === 'venta' ? 'Venta' : 'Alquiler'}</div>
                              <div><strong>Estado:</strong> {condition}</div>
                            </div>
                          </div>

                          {/* Valuation Results */}
                          <div style={{
                            background: 'linear-gradient(135deg, #667eea, #764ba2)',
                            color: 'white',
                            padding: '25px',
                            borderRadius: '12px',
                            marginBottom: '20px'
                          }}>
                            <h4 style={{ margin: '0 0 15px 0', fontSize: '1.3rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <MdAttachMoney size={24} />
                              Resultado de la Valuación
                            </h4>
                            {operation === 'venta' ? (
                              <div>
                                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '10px' }}>
                                  Entre USD {Math.round(valorPropUno || 0).toLocaleString('es-AR')} y USD {Math.round(valorPropDos || 0).toLocaleString('es-AR')}
                                </div>
                                <div style={{ fontSize: '1rem', opacity: 0.9 }}>
                                  Rango de valuación para {property} de {amb} ambiente(s)
                                </div>
                              </div>
                            ) : (
                              <div>
                                {/* ARS Section */}
                                <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}>
                                  <div style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '8px', opacity: 0.9 }}>
                                    💵 Pesos Argentinos (ARS)
                                </div>
                                  <div style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '8px' }}>
                                    ${Math.round(rentData?.ars?.avgPrice || valorPropUno || 0).toLocaleString('es-AR')}/mes
                                  </div>
                                  <div style={{ fontSize: '0.95rem', opacity: 0.85 }}>
                                    Rango: ${Math.round(rentData?.ars?.minPrice || (valorPropUno * 0.87) || 0).toLocaleString('es-AR')} - ${Math.round(rentData?.ars?.maxPrice || valorPropDos || 0).toLocaleString('es-AR')}
                                  </div>
                                </div>

                                {/* USD Section */}
                                <div style={{ marginBottom: '15px', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}>
                                  <div style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '8px', opacity: 0.9 }}>
                                    💵 Dólares (USD)
                                  </div>
                                  <div style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '8px' }}>
                                    USD {Math.round(rentData?.usd?.avgPrice || 0).toLocaleString('es-AR')}/mes
                                  </div>
                                  <div style={{ fontSize: '0.95rem', opacity: 0.85 }}>
                                    Rango: USD {Math.round(rentData?.usd?.minPrice || 0).toLocaleString('es-AR')} - USD {Math.round(rentData?.usd?.maxPrice || 0).toLocaleString('es-AR')}
                                  </div>
                                </div>
                              </div>
                            )}
                            
                            {/* Share and Copy Buttons */}
                            <div style={{ 
                              display: 'flex', 
                              gap: '10px', 
                              marginTop: '15px',
                              flexWrap: 'wrap',
                              justifyContent: 'center'
                            }}>
                              <button
                                onClick={() => {
                                  let shareText = `📋 VALUACIÓN INMOBILIARIA - ValuacionesYA\n\n📍 Dirección: ${addressD || address}\n🗺️ Zona: ${zone || 'N/A'}\n\n🏢 Tipo: ${property === 'departamento' ? 'Departamento' : 
                                    property === 'casa' ? 'Casa' : 
                                    property === 'oficina' ? 'Oficina' : 
                                    property === 'local' ? 'Local Comercial' : 
                                    property === 'cocheras' ? 'Cocheras' : property}\n💼 Operación: ${operation === 'alquiler' ? 'Alquiler' : 'Venta'}\n\n`;

                                  if (operation === 'venta') {
                                    shareText += `💵 RANGO DE PRECIO:\nUSD ${Math.round(valorPropUno || 0).toLocaleString('es-AR')} - USD ${Math.round(valorPropDos || 0).toLocaleString('es-AR')}`;
                                  } else {
                                    const arsAvg = Math.round(rentData?.ars?.avgPrice || valorPropUno || 0).toLocaleString('es-AR');
                                    const arsMin = Math.round(rentData?.ars?.minPrice || (valorPropUno * 0.87) || 0).toLocaleString('es-AR');
                                    const arsMax = Math.round(rentData?.ars?.maxPrice || valorPropDos || 0).toLocaleString('es-AR');
                                    const usdAvg = Math.round(rentData?.usd?.avgPrice || 0).toLocaleString('es-AR');
                                    const usdMin = Math.round(rentData?.usd?.minPrice || 0).toLocaleString('es-AR');
                                    const usdMax = Math.round(rentData?.usd?.maxPrice || 0).toLocaleString('es-AR');

                                    shareText += `💵 PRECIO MENSUAL ESTIMADO:\n\n` +
                                      `Pesos (ARS): $${arsAvg}\nRango: $${arsMin} - $${arsMax}\n\n` +
                                      `Dólares (USD): $${usdAvg}\nRango: $${usdMin} - $${usdMax}`;
                                  }

                                  if (amb) shareText += `\n\n🚪 Ambientes: ${amb}`;
                                  if (garage) shareText += `\n🚗 Cocheras: ${garage}`;
                                  if (sc) shareText += `\n📐 Superficie Cubierta: ${sc} m²`;
                                  if (st) shareText += `\n📏 Superficie Total: ${st} m²`;
                                  if (condition) shareText += `\n⚙️ Condición: ${condition}`;
                                  if (antiguedad) shareText += `\n📅 Antigüedad: ${antiguedad} años`;

                                  shareText += `\n\n---\nValuación profesional realizada por ValuacionesYA\nwww.valuacionesya.com`;

                                  // Use Web Share API
                                  if (navigator.share) {
                                    navigator.share({
                                      title: 'Valuación Inmobiliaria',
                                      text: shareText
                                    }).catch((err) => {
                                      console.log('Share cancelled or failed:', err);
                                    });
                                  } else {
                                    alert('La función de compartir no está disponible en este navegador');
                                  }
                                }}
                                style={{
                                  background: 'rgba(255, 255, 255, 0.2)',
                                  color: 'white',
                                  border: '1px solid rgba(255, 255, 255, 0.3)',
                                  padding: '10px 20px',
                                  borderRadius: '8px',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  transition: 'all 0.3s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  flex: '1',
                                  justifyContent: 'center',
                                  minWidth: '140px'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                                  e.target.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                  e.target.style.transform = 'translateY(0)';
                                }}
                              >
                                <IoShareSocial size={18} />
                                Compartir
                              </button>
                              <button
                                onClick={() => {
                                  let shareText = `📋 VALUACIÓN INMOBILIARIA - ValuacionesYA\n\n📍 Dirección: ${addressD || address}\n🗺️ Zona: ${zone || 'N/A'}\n\n🏢 Tipo: ${property === 'departamento' ? 'Departamento' : 
                                    property === 'casa' ? 'Casa' : 
                                    property === 'oficina' ? 'Oficina' : 
                                    property === 'local' ? 'Local Comercial' : 
                                    property === 'cocheras' ? 'Cocheras' : property}\n💼 Operación: ${operation === 'alquiler' ? 'Alquiler' : 'Venta'}\n\n`;

                                  if (operation === 'venta') {
                                    shareText += `💵 RANGO DE PRECIO:\nUSD ${Math.round(valorPropUno || 0).toLocaleString('es-AR')} - USD ${Math.round(valorPropDos || 0).toLocaleString('es-AR')}`;
                                  } else {
                                    const arsAvg = Math.round(rentData?.ars?.avgPrice || valorPropUno || 0).toLocaleString('es-AR');
                                    const arsMin = Math.round(rentData?.ars?.minPrice || (valorPropUno * 0.87) || 0).toLocaleString('es-AR');
                                    const arsMax = Math.round(rentData?.ars?.maxPrice || valorPropDos || 0).toLocaleString('es-AR');
                                    const usdAvg = Math.round(rentData?.usd?.avgPrice || 0).toLocaleString('es-AR');
                                    const usdMin = Math.round(rentData?.usd?.minPrice || 0).toLocaleString('es-AR');
                                    const usdMax = Math.round(rentData?.usd?.maxPrice || 0).toLocaleString('es-AR');

                                    shareText += `💵 PRECIO MENSUAL ESTIMADO:\n\n` +
                                      `Pesos (ARS): $${arsAvg}\nRango: $${arsMin} - $${arsMax}\n\n` +
                                      `Dólares (USD): $${usdAvg}\nRango: $${usdMin} - $${usdMax}`;
                                  }

                                  if (amb) shareText += `\n\n🚪 Ambientes: ${amb}`;
                                  if (garage) shareText += `\n🚗 Cocheras: ${garage}`;
                                  if (sc) shareText += `\n📐 Superficie Cubierta: ${sc} m²`;
                                  if (st) shareText += `\n📏 Superficie Total: ${st} m²`;
                                  if (condition) shareText += `\n⚙️ Condición: ${condition}`;
                                  if (antiguedad) shareText += `\n📅 Antigüedad: ${antiguedad} años`;

                                  shareText += `\n\n---\nValuación profesional realizada por ValuacionesYA\nwww.valuacionesya.com`;

                                  // Copy to clipboard
                                  navigator.clipboard.writeText(shareText).then(() => {
                                    alert('✅ Valuación copiada al portapapeles');
                                  }).catch(() => {
                                    alert('Error al copiar la valuación');
                                  });
                                }}
                                style={{
                                  background: 'rgba(255, 255, 255, 0.2)',
                                  color: 'white',
                                  border: '1px solid rgba(255, 255, 255, 0.3)',
                                  padding: '10px 20px',
                                  borderRadius: '8px',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  transition: 'all 0.3s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  flex: '1',
                                  justifyContent: 'center',
                                  minWidth: '140px'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                                  e.target.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                  e.target.style.transform = 'translateY(0)';
                                }}
                              >
                                <IoCopyOutline size={18} />
                                Copiar
                              </button>
                            </div>

                            {/* Professional Advisory Section - Premium Feature */}
                            {premiumResults && (
                              <div style={{
                                marginTop: '20px',
                                padding: '20px',
                                background: 'linear-gradient(135deg, rgba(255,215,0,0.1), rgba(255,165,0,0.1))',
                                borderRadius: '12px',
                                border: '2px solid #ffd700',
                                boxShadow: '0 4px 20px rgba(255, 215, 0, 0.2)'
                              }}>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '8px',
                                  marginBottom: '8px'
                                }}>
                                  <span style={{ 
                                    background: 'linear-gradient(135deg, #ffd700, #ffed4e)',
                                    color: '#000',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '0.75rem',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                  }}>
                                    ⭐ Incluido en tu compra
                                  </span>
                                </div>
                                
                                <p style={{
                                  color: '#2c3e50',
                                  fontSize: '1.1rem',
                                  fontWeight: '600',
                                  textAlign: 'center',
                                  margin: '12px 0 15px 0',
                                  lineHeight: '1.5'
                                }}>
                                  ¿Tenés dudas sobre la valuación o necesitás asesoramiento profesional?
                                </p>

                                <button
                                  onClick={() => {
                                    let priceRange;
                                    if (operation === 'venta') {
                                      priceRange = `USD ${Math.round(valorPropUno || 0).toLocaleString('es-AR')} - USD ${Math.round(valorPropDos || 0).toLocaleString('es-AR')}`;
                                    } else {
                                      const arsMin = Math.round(rentData?.ars?.minPrice || (valorPropUno * 0.87) || 0).toLocaleString('es-AR');
                                      const arsMax = Math.round(rentData?.ars?.maxPrice || valorPropDos || 0).toLocaleString('es-AR');
                                      const usdMin = Math.round(rentData?.usd?.minPrice || 0).toLocaleString('es-AR');
                                      const usdMax = Math.round(rentData?.usd?.maxPrice || 0).toLocaleString('es-AR');
                                      priceRange = `ARS $${arsMin}-$${arsMax} / USD $${usdMin}-$${usdMax}`;
                                    }
                                    
                                    const message = `Hola! Recibí mi valuación premium y necesito asesoramiento profesional personalizado.%0A%0A📍 *Dirección:* ${addressD}%0A💰 *Valuación:* ${priceRange}%0A🏠 *Operación:* ${operation === 'venta' ? 'Venta' : 'Alquiler'}`;
                                    
                                    window.open(`https://wa.me/5491151048360?text=${message}`, '_blank');
                                  }}
                                  style={{
                                    background: 'linear-gradient(135deg, #25D366, #128C7E)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '14px 24px',
                                    borderRadius: '10px',
                                    fontSize: '1.05rem',
                                    fontWeight: '700',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    justifyContent: 'center',
                                    width: '100%'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(37, 211, 102, 0.5)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.4)';
                                  }}
                                >
                                  <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: '1.3rem' }} />
                                  Hablar con un Profesional Ahora
                                </button>
                                
                                <p style={{
                                  color: 'white',
                                  fontSize: '0.85rem',
                                  textAlign: 'center',
                                  margin: '10px 0 0 0'
                                }}>
                                  💼 Respuesta en minutos • 🎯 Asesoramiento personalizado
                                </p>
                              </div>
                            )}
                          </div>

                          {/* New Valuation Button */}
                          <button
                            onClick={() => {
                              setShowResult(false);
                              setGotPrice(false);
                              setValorPropUno("");
                              setValorPropDos("");
                              setRentData(null); // Clear rent data
                              setShowSellingAdviceModal(false);
                              setAddress("");
                              setAddressD("");
                              setZone("");
                              setAddressSelected(false);
                              setIsTypingManually(false);
                              
                              // Clear the Google Places autocomplete input fields (both mobile and desktop)
                              const mobileAddressInput = document.querySelector('input[name="google-places-address-unique-12345"]');
                              if (mobileAddressInput) {
                                mobileAddressInput.value = '';
                              }
                              const desktopAddressInput = document.querySelector('input[name="google-places-address-desktop-unique"]');
                              if (desktopAddressInput) {
                                desktopAddressInput.value = '';
                              }
                              setOperation("venta");
                              setProperty("departamento");
                              setValuationType("simple");
                              setAmb(1);
                              setGarage(0);
                              setSc(0);
                              setSt(0);
                              setSd(0);
                              setSterreno(0);
                              setCondition("Estrenar");
                              setAntiguedad(1);
                              setBarbecue(false);
                              setPool(false);
                              setSum(false);
                              // Don't reset email/phone - keep saved values from cookies
                              setMotive("Personal");
                              setMarker({ lat: -34.6037345, lng: -58.3841453 });
                              
                              // Reset to step 1 (both mobile and desktop now use step system)
                              setCurrentStep(1);
                              setShowResult(false);
                              setGotPrice(false);
                              setResultExists(false);
                              setValorPropUno("");
                              setValorPropDos("");
                              setRentData(null);
                              
                              // Reset user type selection and WhatsApp status in Step 6
                              setUserTypeSelection(null);
                              setWhatsappStatus(null);
                              setWhatsappMessage('');
                              
                              // Scroll to top for better UX
                              setTimeout(() => {
                                window.scrollTo({
                                  top: 0,
                                  behavior: 'smooth'
                                });
                              }, 100);
                            }}
                            style={{
                              background: 'linear-gradient(135deg, #28a745, #20c997)',
                              color: 'white',
                              border: 'none',
                              padding: '12px 24px',
                              borderRadius: '8px',
                              fontSize: '1rem',
                              cursor: 'pointer',
                              marginTop: '20px',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                          >
                            <FaHome size={16} />
                            Nueva Valuación
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: 'center' }}>
                          <div style={{
                            background: 'linear-gradient(135deg, #dc3545, #fd7e14)',
                            color: 'white',
                            padding: '20px',
                            borderRadius: '12px'
                          }}>
                            <h3 style={{ margin: '0', fontSize: '1.5rem' }}>
                              ⚠️ Zona no cubierta
                            </h3>
                          </div>
                          <p style={{ fontSize: '1.1rem', color: '#666', marginTop: '20px' }}>
                            Lamentablemente no cubrimos esta zona por el momento.
                          </p>
                        </div>
                      )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Development Mode */}
              {viewMode === 'development' && (
                <DevelopmentAnalysis onClose={() => setViewMode('valuation')} />
              )}


            </>
          )}
        </div>

        {/* Footer - Hidden when viewing messages */}
        {!(currentView === 'dashboard-mensajes' && isLoggedIn && (userInfo?.userType === 'Admin' || (userInfo?.userType === 'agent' || userInfo?.userType === 'individual'))) && (
        <div style={{
          background: '#2c3e50',
          color: 'white',
          textAlign: 'center'
        }}>
          <div style={{ maxWidth: isMobile ? '100%' : '100%', margin: '0 auto', padding: isMobile ? '30px 15px' : '40px 20px' }}>
            <p style={{ marginBottom: '10px' }}>
              <strong>info@valuacionesya.com</strong>
            </p>
            <p style={{ marginBottom: '10px', fontSize: '0.95rem' }}>
              <a href="/terminos-y-condiciones" style={{ color: '#667eea', textDecoration: 'none', marginRight: '15px' }}>
                Términos y Condiciones
              </a>
              <span style={{ opacity: 0.5, marginRight: '15px' }}>|</span>
              <a href="/politica-de-privacidad" style={{ color: '#667eea', textDecoration: 'none' }}>
                Política de Privacidad
              </a>
            </p>
            <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>
              Copyright © valuacionesya.com {new Date().getFullYear()}
            </p>
          </div>
        </div>
        )}

        {/* WhatsApp Float Button - Hidden for Admin/Agent Users and Premium Results Page */}
        {currentView !== 'metrics' && userInfo?.userType !== 'Admin' && userInfo?.userType !== 'agent' && !premiumResults && (
        <div 
          onClick={request_wpp}
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            background: '#25d366',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            zIndex: 1000
          }}
        >
          <a href="https://wa.me/+5491151048360" style={{ color: 'white', textDecoration: 'none' }}>
            <img src={wpp_png} style={{ width: '35px', height: '35px' }} alt="WhatsApp" />
          </a>
        </div>
        )}

        {/* Not Covered Modal */}
        {showNotCoveredModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            padding: '20px'
          }} onClick={closeNotCoveredModal}>
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '40px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              position: 'relative'
            }} onClick={(e) => e.stopPropagation()}>
              
              {/* Close Button */}
              <button
                onClick={closeNotCoveredModal}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '20px',
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f0f0f0';
                  e.target.style.color = '#333';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#666';
                }}
              >
                ×
              </button>

              {/* Icon */}
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #dc3545, #fd7e14)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                boxShadow: '0 8px 25px rgba(220, 53, 69, 0.3)'
              }}>
                <span style={{ fontSize: '40px', color: 'white' }}>⚠️</span>
              </div>

              {/* Title */}
              <h2 style={{
                margin: '0 0 15px 0',
                fontSize: '1.8rem',
                fontWeight: '700',
                color: '#dc3545'
              }}>
                Zona no cubierta
              </h2>

              {/* Message */}
              <p style={{
                fontSize: '1.1rem',
                color: '#666',
                lineHeight: '1.6',
                margin: '0 0 25px 0'
              }}>
                Lamentablemente no cubrimos esta zona por el momento, pero no te preocupes.
              </p>

              {/* Additional Info */}
              <div style={{
                background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                borderRadius: '12px',
                padding: '20px',
                margin: '20px 0',
                border: '1px solid #dee2e6'
              }}>
                <p style={{
                  fontSize: '1rem',
                  color: '#495057',
                  margin: '0 0 10px 0',
                  fontWeight: '600'
                }}>
                  💡 ¿Qué puedes hacer?
                </p>
                <ul style={{
                  textAlign: 'left',
                  margin: '0',
                  paddingLeft: '20px',
                  color: '#6c757d'
                }}>
                  <li>Contactar directamente con un martillero</li>
                  <li>Recibir una valuación manual por email</li>
                  <li>Consultar sobre otras zonas cercanas</li>
                </ul>
              </div>

              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                gap: '15px',
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>
                <button
                  onClick={() => {
                    window.open('https://wa.me/5491151048360', '_blank');
                    closeNotCoveredModal();
                  }}
                  style={{
                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  💬 Contactar por WhatsApp
                </button>
                
                <button
                  onClick={closeNotCoveredModal}
                  style={{
                    background: 'white',
                    color: '#667eea',
                    border: '2px solid #667eea',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#667eea';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = '#667eea';
                  }}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Existing Modals */}
        <ModalCredits status={modalC} setModalC={setModalC} url={url} found={foundZone} valorProp1={valorPropUno} valorProp2={valorPropDos} />
        <ServiceModal status={isModalSampleOpen} setStatus={setIsModalSampleOpen} url={url} />
        <SampleResultModal isOpen={isModalSampleOpen} onClose={closeModalSample} onRegister={() => setModalC(true)} />
        
        {/* Martillero Professional Valuation Modal */}
        {showMartilleroModal && (
          <>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                @keyframes fadeInUp {
                  from {
                    opacity: 0;
                    transform: translateY(30px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
                @keyframes pulse {
                  0%, 100% {
                    transform: scale(1);
                  }
                  50% {
                    transform: scale(1.05);
                  }
                }
              `}
            </style>
            <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: isMobile ? '15px 10px' : '40px 20px',
            backdropFilter: 'blur(8px)',
            overflowY: 'auto',
            overflowX: 'hidden'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #ffffff, #f8f9fa)',
              borderRadius: isMobile ? '16px' : '20px',
              padding: isMobile ? '20px 15px' : '30px 35px',
              maxWidth: isMobile ? '100%' : '600px',
              width: isMobile ? 'calc(100% - 20px)' : '100%',
              textAlign: 'center',
              boxShadow: '0 25px 80px rgba(0, 0, 0, 0.5)',
              animation: 'fadeInUp 0.5s ease-out',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              position: 'relative',
              overflow: 'auto',
              maxHeight: isMobile ? '90vh' : '90vh',
              margin: 'auto',
              boxSizing: 'border-box'
            }}>
              {/* Background decoration */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '100px',
                height: '100px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                borderRadius: '50%',
                opacity: 0.1,
                zIndex: -1
              }} />
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '-30px',
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #28a745, #20c997)',
                borderRadius: '50%',
                opacity: 0.1,
                zIndex: -1
              }} />

              {/* Icon */}
              <div style={{
                width: isMobile ? '55px' : '60px',
                height: isMobile ? '55px' : '60px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 12px auto',
                fontSize: isMobile ? '24px' : '26px',
                color: 'white',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)'
              }}>
                🏛️
              </div>

              {/* Main message */}
              <h2 style={{
                margin: '0 0 15px 0',
                fontSize: isMobile ? '1.35rem' : '1.65rem',
                fontWeight: '700',
                color: '#2c3e50',
                lineHeight: '1.3'
              }}>
                ¿Querés {martilleroBookingData?.operation === 'venta' ? 'Vender' : 'Alquilar'} tu Propiedad?
              </h2>

              {/* Subtitle */}
              <p style={{
                margin: '0 0 20px 0',
                fontSize: isMobile ? '0.95rem' : '1.05rem',
                color: '#495057',
                lineHeight: '1.5',
                fontWeight: '500'
              }}>
                ¡Nosotros nos encargamos de todo por vos!
              </p>

              {/* Benefits list */}
              <div style={{
                textAlign: 'left',
                margin: '0 auto 20px auto',
                maxWidth: '480px',
                background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                padding: isMobile ? '15px' : '18px 20px',
                borderRadius: '12px',
                border: '2px solid #dee2e6',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
              }}>
                <p style={{
                  margin: '0 0 12px 0',
                  fontSize: isMobile ? '0.9rem' : '0.95rem',
                  color: '#2c3e50',
                  fontWeight: '700',
                  textAlign: 'center'
                }}>
                  ✨ Servicios Incluidos:
                </p>
                {[
                  { icon: '🏛️', text: 'Valuación con martillero profesional' },
                  { icon: '📸', text: 'Sesión fotográfica profesional' },
                  { icon: '📝', text: 'Publicación en todos los portales' },
                  { icon: '🏢', text: 'Gestión completa de la operación' },
                  { icon: '🤝', text: 'Asesoramiento personalizado' }
                ].map((benefit, idx) => (
                  <div key={idx} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    margin: '8px 0',
                    padding: isMobile ? '8px' : '10px',
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)'
                  }}>
                    <span style={{ fontSize: isMobile ? '1.2rem' : '1.3rem' }}>{benefit.icon}</span>
                    <p style={{
                      margin: 0,
                      fontSize: isMobile ? '0.85rem' : '0.9rem',
                      color: '#495057',
                      fontWeight: '600',
                      flex: 1
                    }}>
                      {benefit.text}
                    </p>
                  </div>
                ))}
              </div>

              {/* Value proposition */}
              <div style={{
                background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)',
                padding: isMobile ? '10px 12px' : '12px 15px',
                borderRadius: '10px',
                margin: '0 0 18px 0',
                border: '2px solid #81c784'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: isMobile ? '0.9rem' : '0.95rem',
                  color: '#2e7d32',
                  fontWeight: '700',
                  lineHeight: '1.4'
                }}>
                  💚 Sin costos iniciales • Cobramos solo si se concreta la operación
                </p>
              </div>

              {/* CTA Button */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '0' }}>
                <button
                onClick={async () => {
                  if (sellingAdviceLoading) return; // Prevent multiple clicks
                  
                  try {
                    setSellingAdviceLoading(true); // Start loading
                    
                    // Send booking request with isMobile flag
                    const response = await axios.post(`${apiBaseUrl}/api/book-martillero`, {
                      ...martilleroBookingData,
                      isMobile: isMobile
                    });
                    
                    if (response.data.success) {
                      setShowMartilleroModal(false);
                      
                      // Prepare WhatsApp message
                      const propertyTypeText = martilleroBookingData.propertyType === 'departamento' ? 'departamento' : 
                                               martilleroBookingData.propertyType === 'casa' ? 'casa' : 
                                               martilleroBookingData.propertyType === 'ph' ? 'PH' :
                                               martilleroBookingData.propertyType === 'local' ? 'local comercial' :
                                               martilleroBookingData.propertyType === 'oficina' ? 'oficina' :
                                               'propiedad';
                      const operationText = martilleroBookingData.operation === 'venta' ? 'vender' : 'alquilar';
                      const operationNoun = martilleroBookingData.operation === 'venta' ? 'venta' : 'alquiler';
                      
                      const whatsappMessage = `Hola! Quiero ${operationText} mi ${propertyTypeText} en *${martilleroBookingData.address}*.

📋 Detalles:
• Tipo: ${propertyTypeText.charAt(0).toUpperCase() + propertyTypeText.slice(1)}
• Operación: ${operationNoun.charAt(0).toUpperCase() + operationNoun.slice(1)}
• Valuación estimada: ${martilleroBookingData.estimatedValue}

Me interesa que se encarguen de todo (fotos, publicación, gestión). ¿Podemos coordinar?

¡Gracias!`;
                      
                      const whatsappUrl = `https://wa.me/5491139540333?text=${encodeURIComponent(whatsappMessage)}`;
                      window.open(whatsappUrl, '_blank');
                      
                      if (!isMobile) {
                        // Desktop: Show success message
                        alert('¡Perfecto! 🎉\n\nTe redirigimos a WhatsApp para que puedas contactarnos directamente.');
                      }
                    } else {
                      alert('Error al enviar la reserva. Por favor, inténtalo nuevamente.');
                    }
                  } catch (error) {
                    console.error('Error booking martillero:', error);
                    alert('Error al enviar la reserva. Por favor, inténtalo nuevamente.');
                  } finally {
                    setSellingAdviceLoading(false); // Stop loading
                  }
                }}
                disabled={sellingAdviceLoading}
                style={{
                  background: sellingAdviceLoading 
                    ? '#95a5a6' 
                    : martilleroBookingData?.operation === 'venta' 
                      ? 'linear-gradient(135deg, #28a745, #20c997)' 
                      : 'linear-gradient(135deg, #667eea, #764ba2)',
                  color: 'white',
                  border: 'none',
                  padding: isMobile ? '14px 24px' : '16px 32px',
                  borderRadius: '50px',
                  fontSize: isMobile ? '1rem' : '1.1rem',
                  fontWeight: '700',
                  cursor: sellingAdviceLoading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: sellingAdviceLoading 
                    ? '0 4px 15px rgba(0, 0, 0, 0.2)' 
                    : martilleroBookingData?.operation === 'venta'
                      ? '0 8px 25px rgba(40, 167, 69, 0.5)'
                      : '0 8px 25px rgba(102, 126, 234, 0.5)',
                  opacity: sellingAdviceLoading ? 0.7 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  width: '100%'
                }}
                onMouseEnter={(e) => {
                  if (!sellingAdviceLoading) {
                    e.target.style.transform = 'translateY(-3px) scale(1.02)';
                    e.target.style.boxShadow = martilleroBookingData?.operation === 'venta'
                      ? '0 12px 35px rgba(40, 167, 69, 0.6)'
                      : '0 12px 35px rgba(102, 126, 234, 0.6)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!sellingAdviceLoading) {
                    e.target.style.transform = 'translateY(0) scale(1)';
                    e.target.style.boxShadow = martilleroBookingData?.operation === 'venta'
                      ? '0 8px 25px rgba(40, 167, 69, 0.5)'
                      : '0 8px 25px rgba(102, 126, 234, 0.5)';
                  }
                }}
              >
                {sellingAdviceLoading ? (
                  <>
                    <div style={{
                      width: '18px',
                      height: '18px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <span>Enviando...</span>
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: isMobile ? '1.2rem' : '1.3rem' }}>
                      {martilleroBookingData?.operation === 'venta' ? '🏡' : '🔑'}
                    </span>
                    <span>
                      Sí, quiero {martilleroBookingData?.operation === 'venta' ? 'vender' : 'alquilar'}
                    </span>
                  </>
                )}
              </button>
              
              <button
                onClick={() => setShowMartilleroModal(false)}
                style={{
                  background: 'transparent',
                  color: '#6c757d',
                  border: '2px solid #dee2e6',
                  padding: isMobile ? '10px 18px' : '12px 25px',
                  borderRadius: '50px',
                  fontSize: isMobile ? '0.85rem' : '0.9rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  width: '100%'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f8f9fa';
                  e.target.style.borderColor = '#adb5bd';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.borderColor = '#dee2e6';
                }}
              >
                Ahora no, gracias
              </button>
              </div>

              {/* Close button */}
              <button
                onClick={() => setShowMartilleroModal(false)}
                style={{
                  position: 'absolute',
                  top: isMobile ? '8px' : '12px',
                  right: isMobile ? '8px' : '12px',
                  background: 'rgba(248, 249, 250, 0.9)',
                  border: 'none',
                  fontSize: isMobile ? '18px' : '22px',
                  color: '#6c757d',
                  cursor: 'pointer',
                  padding: '6px',
                  borderRadius: '50%',
                  transition: 'all 0.3s ease',
                  width: isMobile ? '32px' : '36px',
                  height: isMobile ? '32px' : '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  zIndex: 10
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#e9ecef';
                  e.target.style.color = '#495057';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(248, 249, 250, 0.9)';
                  e.target.style.color = '#6c757d';
                }}
              >
                ✕
              </button>
            </div>
          </div>
          </>
        )}
        
        {/* Martillero Contact Modal */}
        {isMartilleroModalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '10px'
          }}>
            <div 
              className="modal-scroll"
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '20px',
                maxWidth: '500px',
                width: '100%',
                maxHeight: '90vh',
                overflowY: 'auto',
                textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                animation: 'fadeInUp 0.4s ease-out'
              }}
            >
              {/* Header */}
              <div style={{ 
                marginBottom: '20px',
                padding: '15px',
                background: 'linear-gradient(135deg, #fff5f5, #fed7d7)',
                border: '2px solid #feb2b2',
                borderRadius: '12px'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  background: 'linear-gradient(135deg, #ffc107, #ff8c00)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 12px auto',
                  fontSize: '20px'
                }}>
                  ⚖️
                </div>
                <h3 style={{
                  margin: '0 0 8px 0',
                  color: '#dc3545',
                  fontSize: '1.3rem',
                  fontWeight: '700',
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                  ⚠️ ¡OJO! Solo un martillero matriculado puede operar
                </h3>
                <p style={{
                  margin: 0,
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  lineHeight: '1.4'
                }}>
                  Es <strong>obligatorio por ley</strong> que las operaciones inmobiliarias sean realizadas por un martillero matriculado. Sin esto, la operación puede ser declarada nula.
                </p>
              </div>

              {/* Legal Requirements */}
              <div style={{
                background: '#fff3cd',
                border: '2px solid #ffc107',
                padding: '15px',
                borderRadius: '12px',
                marginBottom: '20px',
                textAlign: 'left'
              }}>
                <h4 style={{
                  margin: '0 0 12px 0',
                  color: '#856404',
                  fontSize: '1rem',
                  fontWeight: '600'
                }}>
                  ⚖️ ¿Por qué es OBLIGATORIO un martillero matriculado?
                </h4>
                <ul style={{
                  margin: 0,
                  paddingLeft: '18px',
                  color: '#856404',
                  fontSize: '0.9rem',
                  lineHeight: '1.5'
                }}>
                  <li><strong>Ley 25.028:</strong> Solo martilleros matriculados pueden operar</li>
                  <li><strong>Protección legal:</strong> Tu operación queda protegida</li>
                  <li><strong>Evita estafas:</strong> Verificación de documentación y títulos</li>
                  <li><strong>Responsabilidad civil:</strong> El martillero responde por la operación</li>
                </ul>
              </div>

              {/* Free Service Highlight */}
              <div style={{
                background: 'linear-gradient(135deg, #d4edda, #c3e6cb)',
                border: '2px solid #28a745',
                padding: '15px',
                borderRadius: '12px',
                marginBottom: '20px',
                textAlign: 'center'
              }}>
                <h4 style={{
                  margin: '0 0 8px 0',
                  color: '#155724',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}>
                  <MdAttachMoney size={22} />
                  ¡SERVICIO COMPLETAMENTE GRATIS!
                </h4>
                <p style={{
                  margin: 0,
                  color: '#155724',
                  fontSize: '0.95rem',
                  fontWeight: '500'
                }}>
                  El asesoramiento con martillero matriculado es <strong>100% sin costo</strong> por haber usado nuestra plataforma
                </p>
              </div>



              {/* WhatsApp Button */}
              <button
                onClick={() => {
                  window.open('https://wa.me/5491151048360', '_blank');
                  closeMartilleroModal();
                }}
                style={{
                  background: 'linear-gradient(135deg, #25d366, #128c7e)',
                  color: 'white',
                  border: '3px solid #1ea952',
                  padding: '16px 28px',
                  borderRadius: '16px',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(37, 211, 102, 0.4), inset 0 1px 0 rgba(255,255,255,0.2)',
                  width: '100%',
                  marginBottom: '12px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px) scale(1.02)';
                  e.target.style.boxShadow = '0 12px 35px rgba(37, 211, 102, 0.5), inset 0 1px 0 rgba(255,255,255,0.3)';
                  e.target.style.borderColor = '#1a9f4a';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0) scale(1)';
                  e.target.style.boxShadow = '0 8px 25px rgba(37, 211, 102, 0.4), inset 0 1px 0 rgba(255,255,255,0.2)';
                  e.target.style.borderColor = '#1ea952';
                }}
                onMouseDown={(e) => {
                  e.target.style.transform = 'translateY(-1px) scale(0.98)';
                }}
                onMouseUp={(e) => {
                  e.target.style.transform = 'translateY(-3px) scale(1.02)';
                }}
              >
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  ⚖️ Asesórate con martillero matriculado
                  <span style={{ fontSize: '0.9rem', opacity: '0.9' }}>→</span>
                </span>
              </button>

              {/* Close Button */}
              <button
                onClick={closeMartilleroModal}
                style={{
                  background: 'transparent',
                  color: '#6c757d',
                  border: '2px solid #e9ecef',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  width: '100%'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f8f9fa';
                  e.target.style.borderColor = '#dee2e6';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.borderColor = '#e9ecef';
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        )}

        {/* Enhanced Login/Register Modal */}
        {showLoginModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
            padding: '20px',
            backdropFilter: 'blur(5px)'
          }}>
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '0',
              maxWidth: '450px',
              width: '90%',
              maxHeight: '90vh',
              boxShadow: '0 25px 80px rgba(0, 0, 0, 0.4)',
              overflow: 'hidden',
              position: 'relative'
            }}>
              {/* Header */}
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '20px 20px 15px',
                textAlign: 'center',
                color: 'white'
              }}>
                <div style={{
                  fontSize: '28px',
                  marginBottom: '8px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  {loginMode === 'login' ? <FaLock /> : <FaUserPlus />}
                </div>
                <h3 style={{
                  margin: 0,
                  fontSize: '20px',
                  fontWeight: '700'
                }}>
                  {loginMode === 'login' ? 'Iniciar Sesión' : 'Crear Cuenta'}
                </h3>
                <p style={{
                  margin: '8px 0 0 0',
                  opacity: '0.9',
                  fontSize: '13px'
                }}>
                  {loginMode === 'login' ? 'Accede a tu cuenta de ValuacionesYa' : 'Únete a ValuacionesYa'}
                </p>
              </div>

              {/* Close Button */}
              <button
                onClick={closeLoginModal}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '18px',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <FaTimes />
              </button>

              {/* Form Content */}
              <div style={{ padding: '20px', overflowY: 'auto', maxHeight: 'calc(90vh - 120px)' }}>
                {loginMode === 'login' ? (
                  <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaEnvelope style={{ marginRight: '8px', color: '#667eea' }} /> Email
                      </label>
                      <input
                        type="email"
                        value={loginForm.email}
                        onChange={(e) => setLoginForm({...loginForm, email: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="tu@email.com"
                        required
                      />
                    </div>
                    
                    <div style={{ marginBottom: '20px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaLock style={{ marginRight: '8px', color: '#667eea' }} /> Contraseña
                      </label>
                      <input
                        type="password"
                        value={loginForm.password}
                        onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="••••••••"
                        required
                      />
                    </div>
                    
                    {loginError && (
                      <div style={{
                        background: '#f8d7da',
                        color: '#721c24',
                        padding: '12px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        border: '1px solid #f5c6cb'
                      }}>
                        <FaTimesCircle style={{ marginRight: '6px' }} /> {loginError}
                      </div>
                    )}

                    {loginSuccess && (
                      <div style={{
                        background: '#d4edda',
                        color: '#155724',
                        padding: '12px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        border: '1px solid #c3e6cb'
                      }}>
                        <FaCheckCircle style={{ marginRight: '6px' }} /> {loginSuccess}
                      </div>
                    )}
                    
                                         <button
                       type="submit"
                       disabled={loginLoading}
                       style={{
                         width: '100%',
                         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                         color: 'white',
                         border: 'none',
                         padding: '16px',
                         borderRadius: '12px',
                         fontSize: '16px',
                         fontWeight: '600',
                         cursor: loginLoading ? 'not-allowed' : 'pointer',
                         opacity: loginLoading ? 0.7 : 1,
                         transition: 'all 0.3s ease',
                         marginBottom: '30px'
                       }}
                       onMouseEnter={(e) => {
                         if (!loginLoading) {
                           e.target.style.transform = 'translateY(-2px)';
                           e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.4)';
                         }
                       }}
                       onMouseLeave={(e) => {
                         if (!loginLoading) {
                           e.target.style.transform = 'translateY(0)';
                           e.target.style.boxShadow = 'none';
                         }
                       }}
                     >
                       {loginLoading ? <><FaClock style={{ marginRight: '8px' }} /> Iniciando...</> : <><FaRocket style={{ marginRight: '8px' }} /> Iniciar Sesión</>}
                     </button>

                    <div style={{
                      textAlign: 'center',
                      padding: '20px 0',
                      borderTop: '1px solid #e9ecef'
                    }}>
                      <p style={{ margin: '0 0 15px 0', color: '#6c757d', fontSize: '14px' }}>
                        ¿No tienes cuenta?
                      </p>
                      <button
                        type="button"
                        onClick={switchToRegister}
                        style={{
                          background: 'transparent',
                          color: '#667eea',
                          border: '2px solid #667eea',
                          padding: '12px 24px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#667eea';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'transparent';
                          e.target.style.color = '#667eea';
                        }}
                      >
                        <FaUserPlus style={{ marginRight: '6px' }} /> Crear Cuenta
                      </button>
                    </div>
                  </form>
                ) : (
                  <form onSubmit={handleRegister}>
                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaUser style={{ marginRight: '8px', color: '#667eea' }} /> Nombre
                      </label>
                      <input
                        type="text"
                        value={registerForm.name}
                        onChange={(e) => setRegisterForm({...registerForm, name: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="Tu nombre"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaIdCard style={{ marginRight: '8px', color: '#667eea' }} /> Apellido
                      </label>
                      <input
                        type="text"
                        value={registerForm.lname}
                        onChange={(e) => setRegisterForm({...registerForm, lname: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="Tu apellido"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaEnvelope style={{ marginRight: '8px', color: '#667eea' }} /> Email
                      </label>
                      <input
                        type="email"
                        value={registerForm.email}
                        onChange={(e) => setRegisterForm({...registerForm, email: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="tu@email.com"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaPhone style={{ marginRight: '8px', color: '#667eea' }} /> Teléfono
                      </label>
                      <input
                        type="tel"
                        value={registerForm.phone}
                        onChange={(e) => setRegisterForm({...registerForm, phone: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="+54 11 1234-5678"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaLock style={{ marginRight: '8px', color: '#667eea' }} /> Contraseña
                      </label>
                      <input
                        type="password"
                        value={registerForm.password}
                        onChange={(e) => setRegisterForm({...registerForm, password: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                        placeholder="••••••••"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '6px',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>
                        <FaUserTag style={{ marginRight: '8px', color: '#667eea' }} /> Tipo de Usuario
                      </label>
                      <select
                        value={registerForm.userType}
                        onChange={(e) => setRegisterForm({...registerForm, userType: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px',
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                          transition: 'all 0.3s ease',
                          background: '#f8f9fa'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.background = 'white';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#e9ecef';
                          e.target.style.background = '#f8f9fa';
                        }}
                      >
                        <option value="individual">Individual</option>
                        <option value="business">Empresa</option>
                        <option value="agent">Agente Inmobiliario</option>
                      </select>
                    </div>

                    {/* Terms & Conditions Checkbox */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      marginBottom: '20px',
                      padding: '12px',
                      background: '#f8f9fa',
                      borderRadius: '8px',
                      border: '2px solid #e9ecef'
                    }}>
                      <input
                        type="checkbox"
                        checked={registerTermsAccepted}
                        onChange={(e) => setRegisterTermsAccepted(e.target.checked)}
                        style={{
                          marginTop: '1px',
                          width: '14px',
                          height: '14px',
                          accentColor: '#667eea',
                          cursor: 'pointer',
                          flexShrink: 0
                        }}
                      />
                      <div style={{
                        fontSize: '11px',
                        color: '#495057',
                        lineHeight: '1.3'
                      }}>
                        Acepto los{' '}
                        <a 
                          href="/terminos-y-condiciones" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ 
                            color: '#667eea', 
                            fontWeight: '600',
                            textDecoration: 'none',
                            borderBottom: '1px solid #667eea'
                          }}
                        >
                          Términos y Condiciones
                        </a>
                        {' '}y la{' '}
                        <a 
                          href="/politica-de-privacidad" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ 
                            color: '#667eea', 
                            fontWeight: '600',
                            textDecoration: 'none',
                            borderBottom: '1px solid #667eea'
                          }}
                        >
                          Política de Privacidad
                        </a>. Entiendo que mi número será utilizado para contactarme con fines comerciales.
                      </div>
                    </div>
                    
                    {loginError && (
                      <div style={{
                        background: '#f8d7da',
                        color: '#721c24',
                        padding: '12px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        border: '1px solid #f5c6cb'
                      }}>
                        <FaTimesCircle style={{ marginRight: '6px' }} /> {loginError}
                      </div>
                    )}

                    {loginSuccess && (
                      <div style={{
                        background: '#d4edda',
                        color: '#155724',
                        padding: '12px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        border: '1px solid #c3e6cb'
                      }}>
                        <FaCheckCircle style={{ marginRight: '6px' }} /> {loginSuccess}
                      </div>
                    )}
                    
                    <button
                      type="submit"
                      disabled={loginLoading || !registerTermsAccepted}
                      style={{
                        width: '100%',
                        background: (loginLoading || !registerTermsAccepted) 
                          ? '#dee2e6' 
                          : 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                        color: 'white',
                        border: 'none',
                        padding: '16px',
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: (loginLoading || !registerTermsAccepted) ? 'not-allowed' : 'pointer',
                        opacity: (loginLoading || !registerTermsAccepted) ? 0.6 : 1,
                        transition: 'all 0.3s ease',
                        marginBottom: '20px'
                      }}
                      onMouseEnter={(e) => {
                        if (!loginLoading) {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!loginLoading) {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = 'none';
                        }
                      }}
                    >
                      {loginLoading ? <><FaClock style={{ marginRight: '8px' }} /> Creando cuenta...</> : <><FaUserPlus style={{ marginRight: '8px' }} /> Crear Cuenta</>}
                    </button>

                    <div style={{
                      textAlign: 'center',
                      padding: '20px 0',
                      borderTop: '1px solid #e9ecef'
                    }}>
                      <p style={{ margin: '0 0 15px 0', color: '#6c757d', fontSize: '14px' }}>
                        ¿Ya tienes cuenta?
                      </p>
                      <button
                        type="button"
                        onClick={switchToLogin}
                        style={{
                          background: 'transparent',
                          color: '#667eea',
                          border: '2px solid #667eea',
                          padding: '12px 24px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#667eea';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'transparent';
                          e.target.style.color = '#667eea';
                        }}
                      >
                        <FaSignInAlt style={{ marginRight: '6px' }} /> Iniciar Sesión
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        )}

        {/* New Feature Announcement Modal */}
        {showNewFeatureModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1050
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '15px',
              padding: '0',
              maxWidth: '600px',
              width: '90%',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
            }}>
              {/* Header with gradient */}
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '30px',
                borderRadius: '15px 15px 0 0',
                textAlign: 'center',
                color: 'white',
                position: 'relative'
              }}>
                <button
                  onClick={closeNewFeatureModal}
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '20px',
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    fontSize: '24px',
                    cursor: 'pointer',
                    opacity: 0.8
                  }}
                  onMouseEnter={(e) => e.target.style.opacity = '1'}
                  onMouseLeave={(e) => e.target.style.opacity = '0.8'}
                >
                  ×
                </button>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>🏗️</div>
                <h2 style={{ 
                  margin: 0, 
                  fontSize: '28px', 
                  fontWeight: 'bold',
                  textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                  ¡Nueva Funcionalidad!
                </h2>
                <p style={{ 
                  margin: '10px 0 0 0', 
                  fontSize: '18px', 
                  opacity: 0.9 
                }}>
                  Análisis de Desarrollo Inmobiliario
                </p>
              </div>

              {/* Content */}
              <div style={{ padding: '30px' }}>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '10px',
                  marginBottom: '25px',
                  border: '2px solid #e9ecef'
                }}>
                  <h4 style={{ 
                    color: '#495057', 
                    marginBottom: '15px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    <MdGpsFixed size={24} />
                    ¿Qué es esta herramienta?
                  </h4>
                  <p style={{ 
                    color: '#6c757d', 
                    lineHeight: '1.6',
                    marginBottom: '15px',
                    fontSize: '16px'
                  }}>
                    Una herramienta revolucionaria que analiza el <strong>potencial de desarrollo</strong> de cualquier terreno o propiedad en CABA. 
                    Te dice exactamente cuántos pisos podés construir, cuántos metros cuadrados vendibles obtendrías, y cuánto podrías ganar.
                  </p>
                  <div style={{
                    backgroundColor: '#e3f2fd',
                    padding: '15px',
                    borderRadius: '8px',
                    borderLeft: '4px solid #2196f3'
                  }}>
                    <p style={{ 
                      margin: 0, 
                      color: '#1976d2',
                      fontWeight: 'bold',
                      fontSize: '14px'
                    }}>
                      📍 <strong>Disponible solo para CABA</strong> - Utilizamos datos oficiales del gobierno de la ciudad
                    </p>
                  </div>
                </div>


                <div style={{
                  display: 'flex',
                  gap: '15px',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={tryNewFeature}
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      border: 'none',
                      padding: '15px 30px',
                      borderRadius: '25px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                    }}
                  >
                    🚀 ¡Quiero Probarlo!
                  </button>
                  <button
                    onClick={closeNewFeatureModal}
                    style={{
                      background: 'transparent',
                      color: '#6c757d',
                      border: '2px solid #dee2e6',
                      padding: '15px 30px',
                      borderRadius: '25px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.borderColor = '#adb5bd';
                      e.target.style.color = '#495057';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.borderColor = '#dee2e6';
                      e.target.style.color = '#6c757d';
                    }}
                  >
                    Más Tarde
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );

}

export default App;
